import MapControl from '../MapControlFeature/map/MapControl';
import * as eventTypes from '../MapControlFeature/map/utils/eventTypes';
import * as formats from '../MapControlFeature/map/utils/formats';

export default class FormControl {
    constructor(options) {
        this.localization = options.localization;
        this.actionLocalization = options.actionLocalization;
        this.container = options.container;
        this.metadata = null;
        this.otherParameters = options.otherParameters != null ? options.otherParameters : {};
        this.actionButtons = [];
        this.isPreview = false;
        this.uniqueId = 'formControl' + options.pageGuid;
        this.pageGuid = options.pageGuid;
        this.uniqueModalId = this.uniqueId + '-modal';
        this.uniqueModalInnerId = this.uniqueId + '-modal-inner';
        this.comboBoxSelectView = this.uniqueId + '-combo-box-select-view';
        this.lastChosenTab = null;
        this.context = options.context;
        this.objectId = options.objectId;
        this.isValid = true;
        this.saveTabs = true;
        this.fromActionType = options.fromActionType;
        this.loadCommands = {};

        if (this.context == 'full') {
            let pkValParams = location.search.split('&').filter(row => { return row.indexOf('pkVal=') >= 0 });

            if (pkValParams.length > 0) {
                let pkValTuples = pkValParams[0].split('=');
                if (pkValTuples.length == 2) {
                    if (!isNaN(pkValTuples[1]) && pkValTuples[1] != '0') {
                        if (this.objectId == 0 || this.objectId == null || this.objectId == '') {
                            this.objectId = pkValTuples[1];
                        }
                    }
                }
            }
        }
        this.getDataUrl = options.getDataUrl;
        this.getDataPostParam = options.getDataPostParam;
        this.saveDataUrl = options.saveDataUrl;
        this.saveDataPostParam = options.saveDataPostParam;
        this.formId = options.formId;
        this.idExtConn = options.idExtConn;
        this.layoutId = options.layoutId;
        this.isFilter = options.isFilter;
        this.listControl = options.listControl;
        this.currentActionId = -1;
        this.generalResources = options.generalResources;
        this.customFormResources = options.customFormResources;
        this.parentGuid = options.parentGuid;
        this.reloadAfterSubmit = false;
        this.ignoreNotificationAfterSubmit = false;
        this.initiatorIdAfterSubmit = null;
        if (this.parentGuid != null && this.parentGuid != '') {
            $('#sublist-modal-' + this.parentGuid.replaceAll('listControl', '')).siblings('.k-window-titlebar').find('[aria-label="Close"]').attr('id', 'form-panel-close-' + this.pageGuid);
            $('#form-panel-close-' + this.pageGuid).hide();
        }

        this.uploadedFiles = {};
        this.dropzones = {};
        this.actionGeom = {};
        this.formGeomEdited = false;
        this.formItemPrefix = 'entity-form-item-';
        this.commands = options.XpCommands;

        this.allowEdit = false;
        this.allowDelete = false;
        this.dataItem = {};
        this.saveDataItem = {
            idForm: this.formId,
            idExtConn: this.idExtConn,
            pkVal: this.objectId,
            values: {}
        };

        $('#' + this.container)[0][this.uniqueId] = this;

        // control items
        this.saveButtonId = 'form-save-button-' + this._generateUUID();
        this.cancelButtonId = 'form-cancel-button-' + this._generateUUID();
        this.clearFilterButtonId = 'clear-filter-button-' + this._generateUUID();
        this.searchFilterButtonId = 'search-filter-button-' + this._generateUUID();

        if (options.isPreview != null) {
            this.isPreview = options.isPreview;
            if (this.isPreview) {
                this.allowEdit = true;
                this.allowDelete = true;
            }
        }
        this.featureSelectionChangedHandler = this._handleMapElementSelection();
        this.parentControl = null;

        if (this._getXpList(this.parentGuid) != null) {
            this.parentControl = this._getXpList(this.parentGuid);
        }

        this.sublists = {};
    }

    getCurrentPlatform() {
        return 1;
    }

    saveState(ignoreNotification, ignoreValidation) {
        this.saveDataItem.values = {};
        this._storeData(this.metadata);
        this._storeGeomData();
        return this._saveState(ignoreNotification, ignoreValidation);
    }

    sublistFilterLoaded(sublistId) {
        if (window['onSublistFilterLoaded' + this.pageGuid] != null && !this.isPreview) {
            window['onSublistFilterLoaded' + this.pageGuid](sublistId);
        }
    }

    //public methods
    loadForm(metadata, actionButtons) {
        if (metadata != null && metadata.Items != null && metadata.Items.length > 0) {
            this._disposeForm();
            this.metadata = metadata;
            this.actionButtons = actionButtons;

            if (window['onBeforeFormLoaded' + this.pageGuid] != null && !this.isPreview) {
                window['onBeforeFormLoaded' + this.pageGuid]();
            }

            this._initForm();
        }
    }

    reloadForm() {
        if (window['onBeforeFormLoaded' + this.pageGuid] != null && !this.isPreview) {
            window['onBeforeFormLoaded' + this.pageGuid]();
        }

        this._initForm();
    }

    getFieldMetadataByInternalId(id) {
        let item = this._searchFieldByInternalId(this.metadata, id);
        return item;
    }

    getFieldMetadataById(id) {
        let item = this._searchFieldByUiName(this.metadata, id);
        return item;
    }

    getFieldMetadataByUniqueId(id) {
        let item = this._searchFieldByUniqueId(this.metadata, id);
        return item;
    }

    getFieldById(id) {
        let item = this._searchFieldByUiName(this.metadata, id);
        let value = null;
        if (item != null) {
            switch (item.CtlType) {
                case 'Switch': value = $("#" + item.UniqueClientId).data('kendoSwitch');
                    break;
                case 'IntegerTextBox': value = $("#" + item.UniqueClientId).data('kendoNumericTextBox');
                    break;
                case 'DatePicker': value = $("#" + item.UniqueClientId).data("kendoDatePicker");
                    break;
                case 'NumericTextBox': value = $("#" + item.UniqueClientId).data('kendoNumericTextBox');
                    break;
                case 'TextBox': value = $("#" + item.UniqueClientId);
                    break;
                case 'TextArea': value = $("#" + item.UniqueClientId);
                    break;
                case 'RichText': value = $("#" + item.UniqueClientId);
                    break;
                case 'DateTimePicker': value = $("#" + item.UniqueClientId).data("kendoDateTimePicker");
                    break;
                case 'ComboBox': {
                    switch (this._getFieldControlSubType(item)) {
                        case 'ListView': value = $("#" + item.UniqueClientId);
                            break;
                        case 'MultiSelect': value = $("#" + item.UniqueClientId).data('kendoMultiSelect');
                            break;
                        case 'TreeView': value = $("#" + item.UniqueClientId).data('kendoDropDownTree');
                            break;
                        default: value = $("#" + item.UniqueClientId).data('kendoComboBox');
                            break;
                    }
                }

                    break;
                case 'GeomPicker': {
                    switch (this._getFieldControlSubType(item)) {
                        case 'ModalMap': value = $("#" + item.UniqueClientId);
                            break;
                        case 'MapView': value = $("#" + item.UniqueClientId)[0].mapControl;
                            break;
                    }
                }
                    break;
                default: break;
            }

            if (item.TypeName == 'UISublistDto') {
                value = this.sublists[item.UniqueClientId];
            }

            if (item.TypeName == 'UIMapViewDto') {
                value = $("#" + item.UniqueClientId)[0].mapControl;
            }
        }

        return value;
    }

    getFieldByUniqueId(id) {
        let item = this._searchFieldByUniqueId(this.metadata, id);
        let value = null;
        if (item != null) {
            switch (item.CtlType) {
                case 'Switch': value = $("#" + item.UniqueClientId).data('kendoSwitch');
                    break;
                case 'IntegerTextBox': value = $("#" + item.UniqueClientId).data('kendoNumericTextBox');
                    break;
                case 'DatePicker': value = $("#" + item.UniqueClientId).data("kendoDatePicker");
                    break;
                case 'NumericTextBox': value = $("#" + item.UniqueClientId).data('kendoNumericTextBox');
                    break;
                case 'TextBox': value = $("#" + item.UniqueClientId);
                    break;
                case 'TextArea': value = $("#" + item.UniqueClientId);
                    break;
                case 'RichText': value = $("#" + item.UniqueClientId);
                    break;
                case 'DateTimePicker': value = $("#" + item.UniqueClientId).data("kendoDateTimePicker");
                    break;
                case 'ComboBox': {
                    switch (this._getFieldControlSubType(item)) {
                        case 'ListView': value = $("#" + item.UniqueClientId);
                            break;
                        case 'MultiSelect': value = $("#" + item.UniqueClientId).data('kendoMultiSelect');
                            break;
                        case 'TreeView': value = $("#" + item.UniqueClientId).data('kendoDropDownTree');
                            break;
                        default: value = $("#" + item.UniqueClientId).data('kendoComboBox');
                            break;
                    }
                }

                    break;
                case 'GeomPicker': {
                    switch (this._getFieldControlSubType(item)) {
                        case 'ModalMap': value = $("#" + item.UniqueClientId);
                            break;
                        case 'MapView': value = $("#" + item.UniqueClientId)[0].mapControl;
                            break;
                    }
                }
                    break;
                default: break;
            }

            if (item.TypeName == 'UISublistDto') {
                value = this.sublists[item.UniqueClientId];
            }

            if (item.TypeName == 'UIMapViewDto') {
                value = $("#" + item.UniqueClientId)[0].mapControl;
            }
        }

        return value;
    }

    setFieldValue(fieldName, value) {
        this.setFieldValueById(fieldName, value);
    }

    setFieldValueById(id, value) {
        let item = this._searchFieldByUiName(this.metadata, id);

        if (item != null) {
            switch (item.CtlType) {
                case 'Switch': this._threeStateSwitchSetValue("#" + item.UniqueClientId, value);
                    break;
                case 'IntegerTextBox': $("#" + item.UniqueClientId).data('kendoNumericTextBox').value(value);
                    break;
                case 'DatePicker': $("#" + item.UniqueClientId).data("kendoDatePicker").value(value);
                    break;
                case 'NumericTextBox': $("#" + item.UniqueClientId).data('kendoNumericTextBox').value(value);
                    break;
                case 'TextBox': $("#" + item.UniqueClientId).val(value);
                    break;
                case 'TextArea': $("#" + item.UniqueClientId).val(value);
                    break;
                case 'RichText': $("#" + item.UniqueClientId).data('kendoEditor').value(value);
                    break;
                case 'DateTimePicker': $("#" + item.UniqueClientId).data("kendoDateTimePicker").value(value);
                    break;
                case 'ComboBox': {
                    switch (this._getFieldControlSubType(item)) {
                        case 'ListView': $("#" + item.UniqueClientId).attr('current-value', value);
                            break;
                        case 'MultiSelect': $("#" + item.UniqueClientId).data('kendoMultiSelect').value(value);
                            break;
                        case 'TreeView': $("#" + item.UniqueClientId).data('kendoDropDownTree').value(value);
                            break;
                        default: $("#" + item.UniqueClientId).data('kendoComboBox').value(value);
                            break;
                    }
                }
                    break;
                case 'GeomPicker': {
                    switch (this._getFieldControlSubType(item)) {
                        case 'ModalMap': $("#" + item.UniqueClientId).val(value);
                            break;
                        case 'MapView': $("#" + item.UniqueClientId).attr('current-value', value);
                            break;
                    }
                }
                    break;
                default: break;
            }
        }
    }

    getFieldValueById(id) {
        let item = this._searchFieldByUiName(this.metadata, id);
        let value = null;
        if (item != null) {
            switch (item.CtlType) {
                case 'Switch': value = this._threeStateSwitchGetValue("#" + item.UniqueClientId);
                    break;
                case 'IntegerTextBox': value = $("#" + item.UniqueClientId).data('kendoNumericTextBox').value();
                    break;
                case 'DatePicker': value = $("#" + item.UniqueClientId).data("kendoDatePicker").value();
                    break;
                case 'NumericTextBox': value = $("#" + item.UniqueClientId).data('kendoNumericTextBox').value();
                    break;
                case 'TextBox': value = $("#" + item.UniqueClientId).val();
                    break;
                case 'TextArea': value = $("#" + item.UniqueClientId).val();
                    break;
                case 'RichText': value = $("#" + item.UniqueClientId).data('kendoEditor').value();
                    break;
                case 'DateTimePicker': value = $("#" + item.UniqueClientId).data("kendoDateTimePicker").value();
                    break;
                case 'ComboBox': {
                    switch (this._getFieldControlSubType(item)) {
                        case 'ListView': value = $("#" + item.UniqueClientId).attr('current-value');
                            break;
                        case 'MultiSelect': value = $("#" + item.UniqueClientId).data('kendoMultiSelect').value();
                            break;
                        case 'TreeView': value = $("#" + item.UniqueClientId).data('kendoDropDownTree').value();
                            break;
                        default: value = $("#" + item.UniqueClientId).data('kendoComboBox').value();
                            break;
                    }
                }
                    break;
                case 'GeomPicker': {
                    switch (this._getFieldControlSubType(item)) {
                        case 'ModalMap': value = $("#" + item.UniqueClientId).val();
                            break;
                        case 'MapView': value = $("#" + item.UniqueClientId).attr('current-value');
                            break;
                    }
                }
                    break;
                default: break;
            }
        }

        return value;
    }

    _getFieldValueByUniqueId(id) {
        let item = this._searchFieldByUniqueId(this.metadata, id);
        let value = null;
        if (item != null) {
            switch (item.CtlType) {
                case 'Switch': value = this._threeStateSwitchGetValue("#" + item.UniqueClientId);
                    break;
                case 'IntegerTextBox': value = $("#" + item.UniqueClientId).data('kendoNumericTextBox').value();
                    break;
                case 'DatePicker': value = $("#" + item.UniqueClientId).data("kendoDatePicker").value();
                    break;
                case 'NumericTextBox': value = $("#" + item.UniqueClientId).data('kendoNumericTextBox').value();
                    break;
                case 'TextBox': value = $("#" + item.UniqueClientId).val();
                    break;
                case 'TextArea': value = $("#" + item.UniqueClientId).val();
                    break;
                case 'RichText': value = $("#" + item.UniqueClientId).data('kendoEditor').value();
                    break;
                case 'DateTimePicker': value = $("#" + item.UniqueClientId).data("kendoDateTimePicker").value();
                    break;
                case 'ComboBox': {
                    switch (this._getFieldControlSubType(item)) {
                        case 'ListView': value = $("#" + item.UniqueClientId).attr('current-value');
                            break;
                        case 'MultiSelect': value = $("#" + item.UniqueClientId).data('kendoMultiSelect').value();
                            break;
                        case 'TreeView': value = $("#" + item.UniqueClientId).data('kendoDropDownTree').value();
                            break;
                        default: value = $("#" + item.UniqueClientId).data('kendoComboBox').value();
                            break;
                    }
                }
                    break;
                case 'GeomPicker': {
                    switch (this._getFieldControlSubType(item)) {
                        case 'ModalMap': value = $("#" + item.UniqueClientId).val();
                            break;
                        case 'MapView': value = $("#" + item.UniqueClientId).attr('current-value');
                            break;
                    }
                }
                    break;
                case 'File': {
                    value = this.uploadedFiles[item.UniqueClientId] != null ? this.uploadedFiles[item.UniqueClientId].uploadedFileAdded : null;
                }
                    break;
                default: break;
            }
        }

        return value;
    }

    executeCommandById(id, params) {
        let foundCommands = this.commands.filter((row) => { return row.Id == id });

        if (foundCommands.length > 0) {
            return this._executeCommand(foundCommands[0], params);
        } else {
            return new Promise((resolve, reject) => { return reject('Command does not exist!'); });
        }
    }

    executeCommandByName(name, params) {
        let foundCommands = this.commands.filter((row) => { return row.Name == name });

        if (foundCommands.length > 0) {
            if (foundCommands.length > 0) {
                return this._executeCommand(foundCommands[0], params);
            } else {
                return new Promise((resolve, reject) => { return reject('Command does not exist!'); });
            }
        } else {
            return new Promise((resolve, reject) => { return reject('Command does not exist!'); });
        }
    }

    showLoadingPanel(target) {
        Swal.fire({
            target: target,
            allowOutsideClick: false,
            onBeforeOpen: () => {
                Swal.showLoading();
                $('body').css('overflow', 'auto');
            },
            customClass: {
                container: 'position-absolute'
            }
        });
    }

    loadSublists() {
        let sublists = $('.xp-list-container');

        if (sublists.length > 0) {
            for (let i = 0; i < sublists.length; i++) {
                let sublist = sublists[i];

                let sublistMetadata = this._searchFieldByUniqueId(this.metadata, sublist.id);

                if (sublistMetadata != null && !sublistMetadata.isLoaded) {
                    this._initSublistControl(sublistMetadata, false);
                    sublistMetadata.isLoaded = true;
                }
            }
        }
    }

    isClientCommand(id) {
        let foundCommands = this.commands.filter((row) => { return row.Id == id });

        if (foundCommands.length > 0) {
            return foundCommands[0].Type == 'CLIENT';
        }

        return false;
    }

    _executeCommand(command, params) {
        if (command.Type == 'CLIENT') {
            return new Promise((resolve, reject) => {
                try {
                    let result = window['command_' + this.pageGuid + '_' + command.Id](params);

                    resolve(result);
                } catch (err) {
                    reject(err);
                }
            });
        } else if (command.Type == 'SERVER_WITH_RESULT' || command.Type == 'C_SHARP_WITH_RESULT') {
            return new Promise((resolve, reject) => {
                try {
                    let postData = {
                        id: command.Id,
                        idEntity: this.metadata.IdEntity,
                        params: {}
                    };

                    if (params != null) {
                        postData.params = params;
                    } else {
                        for (var i = 0; i < command.Parameters.length; i++) {
                            let value = this.getFieldValueById(command.Parameters[i]);

                            if (command.Parameters[i] != 'User.Id') {
                                let type = this.getFieldMetadataById(command.Parameters[i]).EntityField.DataType;

                                if (type == 'INTEGER' && value === '') {
                                    value = '-120043434';
                                }

                                if (type == 'DATE') {
                                    value = this._serializeDate(value);
                                }

                                if (type == 'TIMESTAMP') {
                                    value = this._serializeDateTime(value);
                                }

                                postData.params[command.Parameters[i]] = {
                                    value: value,
                                    type: type
                                }
                            }
                        }
                    }

                    let commandUrl = rootUrl + 'EntityForm/ExecuteCommandWithResult';

                    $.ajax({
                        type: "POST",
                        url: commandUrl,
                        async: true,
                        data: JSON.stringify(postData),
                        contentType: "application/json; charset=utf-8",
                        success: (result) => {
                            if (result != null) {
                                var resp = JSON.parse(result);

                                if (resp.length == 0) {
                                    resolve(null);
                                } else if (resp.length == 1) {
                                    resolve(resp[0]);
                                } else {
                                    resolve(resp);
                                }
                            }
                        },
                        error: (e) => {
                            reject(e)
                        }
                    });
                } catch (err) {
                    reject(err);
                }
            });
        } else if (command.Type == 'SERVER_NO_RESULT') {
            return new Promise((resolve, reject) => {
                try {
                    let postData = {
                        id: command.Id,
                        idEntity: this.metadata.IdEntity,
                        params: {}
                    };

                    if (params != null) {
                        postData.params = params;
                    } else {
                        for (var i = 0; i < command.Parameters.length; i++) {
                            let value = this.getFieldValueById(command.Parameters[i]);

                            if (command.Parameters[i] != 'User.Id') {
                                let type = this.getFieldMetadataById(command.Parameters[i]).EntityField.DataType;

                                if (type == 'INTEGER' && value === '') {
                                    value = '-120043434';
                                }

                                if (type == 'DATE') {
                                    value = this._serializeDate(value);
                                }

                                if (type == 'TIMESTAMP') {
                                    value = this._serializeDateTime(value);
                                }

                                postData.params[command.Parameters[i]] = {
                                    value: value,
                                    type: type
                                }
                            }
                        }
                    }

                    let commandUrl = rootUrl + 'EntityForm/ExecuteCommandWithoutResult';

                    $.ajax({
                        type: "POST",
                        url: commandUrl,
                        async: true,
                        data: JSON.stringify(postData),
                        contentType: "application/json; charset=utf-8",
                        success: (result) => {
                            if (result != null) {
                                if (result.status == true) {
                                    resolve(true);
                                } else {
                                    resolve(false);
                                }
                            } else {
                                resolve(false);
                            }
                        },
                        error: (e) => {
                            reject(e)
                        }
                    });
                } catch (err) {
                    reject(err);
                }
            });
        } else {
            return new Promise((resolve, reject) => { return reject('Command type not implemented!'); });
        }
    }

    _dateToISOString(date) {
        let year = date.getFullYear();
        let month = date.getMonth() + 1;
        let day = date.getDate();
        let hours = this._padDatePart(date.getHours());
        let minutes = this._padDatePart(date.getHours());
        let seconds = this._padDatePart(date.getSeconds());

        return year + '-' + month + '-' + day + 'T' + hours + ':' + minutes + ':' + seconds + '.000Z';
    }

    _padDatePart(part) {
        if (part < 10) {
            return '0' + part;
        } else {
            return part;
        }
    }

    //private methods
    _searchFieldByUiName(item, name) {
        let found = null;

        if ((item.TypeName == 'UICustomFieldControlDto' || item.TypeName == 'UIFieldControlDto' || item.TypeName == 'UISublistDto' || item.TypeName == 'UIMapViewDto') && item.Name == name) {
            return item;
        }

        if (item.Items != null && item.Items.length > 0) {
            for (var i = 0; i < item.Items.length; i++) {
                let childFound = this._searchFieldByUiName(item.Items[i], name);
                if (childFound != null) {
                    found = childFound;
                }
            }
        }

        return found;
    }

    _searchFieldByUniqueId(item, id) {
        let found = null;

        if ((item.TypeName == 'UICustomFieldControlDto' || item.TypeName == 'UIFieldControlDto' || item.TypeName == 'UISublistDto' || item.TypeName == 'UIMapViewDto' || item.TypeName == 'UITabPageDto') && item.UniqueClientId == id) {
            return item;
        }

        if (item.Items != null && item.Items.length > 0) {
            for (var i = 0; i < item.Items.length; i++) {
                let childFound = this._searchFieldByUniqueId(item.Items[i], id);
                if (childFound != null) {
                    found = childFound;
                }
            }
        }

        return found;
    }

    _searchFieldByInternalId(item, id) {
        let found = null;

        if ((item.TypeName == 'UICustomFieldControlDto' || item.TypeName == 'UIFieldControlDto' || item.TypeName == 'UISublistDto' || item.TypeName == 'UIMapViewDto' || item.TypeName == 'UITabPageDto') && item.Id == id) {
            return item;
        }

        if (item.Items != null && item.Items.length > 0) {
            for (var i = 0; i < item.Items.length; i++) {
                let childFound = this._searchFieldByInternalId(item.Items[i], id);
                if (childFound != null) {
                    found = childFound;
                }
            }
        }

        return found;
    }

    _searchFieldById(item, id) {
        let found = null;

        if ((item.TypeName == 'UIFieldControlDto' || item.TypeName == 'UICustomFieldControlDto') && item.Id == id) {
            return item;
        }

        if (item.Items != null && item.Items.length > 0) {
            for (var i = 0; i < item.Items.length; i++) {
                let childFound = this._searchFieldById(item.Items[i], id);
                if (childFound != null) {
                    found = childFound;
                }
            }
        }

        return found;
    }

    _loadCommands() {
        let commandsUrl = rootUrl + 'EntityForm/GetXpCommandsRuntime?idForm=' + this.formId;
        return new Promise((resolve, reject) => {
            if (this.isFilter || this.isPreview) {
                resolve();
            } else {
                $.ajax({
                    type: "GET",
                    url: commandsUrl,
                    contentType: "application/json; charset=utf-8",
                    async: true,
                    success: (result) => {
                        this.commands = result;
                        resolve();
                    },
                    error: (e) => {
                        toastr.error(e.responseText, '@resources["GetCommandsError"]');
                        resolve();
                    }
                });
            }
        });
    }

    _initForm() {
        this.actionGeom = {};

        if (this.parentControl != null) {
            $('#' + this.container).css('max-height', '80vh');
        }

        if ($('#' + this.container)[0] != null) {
            $('#' + this.container)[0].innerHTML = this._getTemplate();
        }


        if (!this.isPreview) {
            this.showLoadingPanel('[id="' + this.container + '"]');

        }

        this._getData().then(() => {
            this.saveTabs = false;
            this._initControls(this.metadata);
            this.saveTabs = true;
            if (!this.isPreview) {
                this._bindChangeEvents(this.metadata);
            }

            if (this.objectId != null && this.objectId != 0) {
                let formTabs = sessionStorage.getItem('formTabs');

                if (formTabs != null && formTabs.trim() != '') {
                    formTabs = JSON.parse(formTabs);

                    if (formTabs[xapp.currentApp + '_' + this.formId + '_' + this.objectId] != null) {
                        let tabMetadata = this.getFieldMetadataByInternalId(formTabs[xapp.currentApp + '_' + this.formId + '_' + this.objectId]);

                        if (tabMetadata != null) {
                            this._tabOnClick(tabMetadata.UniqueClientId);
                        }
                    }
                }
            }

            if (!this.isFilter && !this.isPreview && $('#panel-hdr-title').length > 0 && this.parentControl == null) {
                $('#panel-hdr-title')[0].innerHTML = this.metadata.Name;
            }

            if (this.parentControl != null && !this.isFilter) {
                if (this.parentControl.modalInner != null) {
                    $('#' + this.parentControl.modalInner + '_wnd_title')[0].innerHTML = this.metadata.Name;
                } else if (this.parentControl.uniqueModalInnerId) {
                    $('#' + this.parentControl.uniqueModalInnerId + '_wnd_title')[0].innerHTML = this.metadata.Name;
                }
            }

            if (!this.isPreview) {
                if (!this.isFilter) {
                    this._initData().then(() => {
                        if (this.checkMetadataVisibility()) {
                            $('#' + this.metadata.UniqueClientId + '-wrapper').show();
                        }

                        if (this.parentControl != null) {
                            this.parentControl.centerModal();
                        }
                    });
                } else {
                    let listFilterHolder = JSON.parse(sessionStorage.getItem('listFilterHolder'));

                    if (listFilterHolder != null && listFilterHolder != null && listFilterHolder[this.listControl.uid] != null && Object.keys(listFilterHolder[this.listControl.uid]).length > 0) {
                        this.dataItem = listFilterHolder[this.listControl.uid].values;
                    }

                    this._populateItem(this.metadata, false);

                    this._handleLoadCommands().then(() => {
                        this.saveDataItem.values = {};
                        this._storeData(this.metadata);

                        if (this.checkMetadataVisibility()) {
                            $('#' + this.metadata.UniqueClientId + '-wrapper').show();
                        }
                        this.listControl.filterLoaded();
                    });
                }
            } else {
                this._populateItem(this.metadata, false);

                if (this.checkMetadataVisibility()) {
                    $('#' + this.metadata.UniqueClientId + '-wrapper').show();
                }
            }

            if (this.isFilter || this.isPreview) {
                this._addButtonEvents();
                Swal.close();
            }

            if (this.parentControl != null) {
                this.parentControl.centerModal();
            } else if (this.context == 'modal' && modalWindow != null) {
                modalWindow.center();
            }
        });

        if ($('#' + this.container).closest('.k-window-content').length > 0) {
            $('#' + this.container).closest('.k-window-content').parent().find('[aria-label="Close"]').on('click', () => {
                if (this.lastEditedLayer) {
                    let maps = Array.from(document.getElementsByClassName('xp-map'));
                    maps.forEach(map => {
                        let mapControl = map.mapControl;
                        let featureInteractionControl = mapControl.generalActionHandler.generalActionControls.editControl;

                        featureInteractionControl.stopEdit();
                        featureInteractionControl.clear();
                        featureInteractionControl.editSuspended = false;
                    });
                }

                this._reloadDependantLayers();
            });
        }
    }

    checkMetadataVisibility() {
        if (this.metadata.Style != null && this.metadata.Style.trim() != '') {
            let style = JSON.parse(this.metadata.Style);
            if (style.styleWrapper != null && style.styleWrapper.trim() != '') {
                let wrapperStyle = style.styleWrapper;

                if (wrapperStyle.replaceAll(' ', '').indexOf('display:none') >= 0) {
                    return false;
                }
            }
        }

        return true;
    }

    centerForm() {
        if (this.parentControl != null) {
            this.parentControl.centerModal();
        }
    }

    // populate the created controls

    _getData() {
        return new Promise((resolve, reject) => {
            if (this.isPreview) {
                this.serverData = {};
                resolve();
            } else if (this.isFilter) {
                let listFilterHolder = JSON.parse(sessionStorage.getItem('listFilterHolder'));

                if (this.serverData == null) {
                    if (listFilterHolder != null && listFilterHolder != null && listFilterHolder[this.listControl.uid] != null && Object.keys(listFilterHolder[this.listControl.uid]).length > 0) {
                        this.serverData = listFilterHolder[this.listControl.uid].values;
                    } else {
                        this.serverData = {};
                    }
                }
                resolve();
            } else {
                var url;
                if (this.getDataUrl == null || this.getDataUrl == "") {
                    url = rootUrl + 'EntityForm/GetData';
                }
                else {
                    url = rootUrl + this.getDataUrl;
                }
                url += '?idForm=' + this.formId + '&pkVal=' + this.objectId;
                let dataUrl = url;

                if (this.otherParameters != null && this.otherParameters.parentPkVal != null) {
                    dataUrl += '&pkValCurrent=' + this.otherParameters.parentPkVal;
                }

                if (this.otherParameters != null && this.otherParameters.parentIdAction != null) {
                    dataUrl += '&idAction=' + this.otherParameters.parentIdAction;
                }
                if (this.idExtConn != null) {
                    dataUrl += "&idExtConn=" + this.idExtConn;
                }
                var type = "GET";
                var data = null;
                if (this.getDataPostParam != null && this.getDataPostParam != "") {
                    type = "POST";
                    data = this.getDataPostParam;
                }
                $.ajax({
                    type: type,
                    url: dataUrl,
                    data: data,
                    contentType: "application/json; charset=utf-8",
                    async: true,
                    success: (result) => {
                        this.serverData = result;
                        resolve();
                    },
                    error: (e) => {
                        toastr.error(e.responseText, this.getResource('GetDataError'));
                        Swal.close();
                        resolve();
                    }
                });
            }
        });
    }

    _handleLoadCommands() {
        this._mapLoadCommands([this.metadata]);
        this.loadCommands = this._sortLoadCommands(this.loadCommands);

        return new Promise((resolve, reject) => {
            let promises = [];

            let keys = Object.keys(this.loadCommands);

            keys.forEach(key => {
                promises.push(this._handleLoadCommand(this.loadCommands[key]));
            });

            Promise.all(promises).then(() => {
                resolve();
            });
        });
    }

    _handleLoadCommand(loadCommand, itemId) {
        return new Promise((resolve, reject) => {
            this.executeCommandById(loadCommand.command.Id).then(result => {
                let keys = Object.keys(loadCommand.dependands);

                keys.forEach(key => {
                    this._handleLoadCommandDependant(loadCommand.dependands[key], result);
                });

                resolve();
            }).catch(err => {
                resolve();
            });
        });
    }

    _handleLoadCommandDependant(item, data) {
        let value;
        if (typeof data == 'object') {
            let dataItem = {};
            if (data instanceof Array) {
                if (data.length > 0) {
                    dataItem = data[0];
                }
            } else {
                dataItem = data;
            }

            value = dataItem[item.Name];
        } else {
            value = data;
        }


        if (value) {
            this.setFieldValueById(item.Name, value);
        }
    }

    _sortLoadCommands(data) {
        const guidToCommand = {};
        for (const [cmdId, cmdObj] of Object.entries(data)) {
            const deps = cmdObj?.dependands ?? {};
            for (const dep of Object.values(deps)) {
                if (dep && dep.Guid != null) {
                    guidToCommand[String(dep.Guid)] = cmdId;
                }
            }
        }

        const ids = Object.keys(data);
        const graph = new Map(ids.map(id => [id, new Set()]));
        const indegree = new Map(ids.map(id => [id, 0]));

        for (const [cmdId, cmdObj] of Object.entries(data)) {
            const deps = cmdObj?.dependands ?? {};
            for (const dep of Object.values(deps)) {
                const list = dep?.DependsOnGuids ?? [];
                for (const guid of list) {
                    const parent = guidToCommand[String(guid)];
                    if (parent && parent !== cmdId) {
                        const set = graph.get(parent);
                        if (!set.has(cmdId)) {
                            set.add(cmdId);
                            indegree.set(cmdId, (indegree.get(cmdId) || 0) + 1);
                        }
                    }
                }
            }
        }

        const queue = ids.filter(id => (indegree.get(id) || 0) === 0);
        const sortedIds = [];
        while (queue.length) {
            const node = queue.shift();
            sortedIds.push(node);
            for (const neigh of graph.get(node)) {
                indegree.set(neigh, indegree.get(neigh) - 1);
                if (indegree.get(neigh) === 0) queue.push(neigh);
            }
        }

        for (const id of ids) {
            if (!sortedIds.includes(id)) sortedIds.push(id);
        }

        const sortedObj = {};
        for (const id of sortedIds) {
            sortedObj['_' + id] = data[id];
        }
        return sortedObj;
    }

    _mapLoadCommands(items) {
        items.forEach(item => {
            if (item.IdXpCommandLoad != null) {
                if (this.loadCommands[item.IdXpCommandLoad] == null) {
                    let foundCommand = this.commands.find((row) => { return row.Id == item.IdXpCommandLoad });
                    this.loadCommands[item.IdXpCommandLoad] = {
                        command: foundCommand,
                        dependands: {}
                    };
                }

                this.loadCommands[item.IdXpCommandLoad].dependands[item.Id] = item;
            }

            if (item.Items != null && item.Items.length > 0) {
                this._mapLoadCommands(item.Items);
            }
        });
    }

    _initData() {
        this._populateData(this.serverData);

        return new Promise((resolve, reject) => {
            this._handleLoadCommands().then(() => {
                this._checkVisibility(this.metadata);
                this._addButtonEvents();
                Swal.close();
                if (window['onFormLoaded' + this.pageGuid] != null && !this.isPreview) {
                    window['onFormLoaded' + this.pageGuid]();
                }

                if (this.parentControl != null) {
                    this.parentControl.centerModal();
                }

                resolve();
            });
        });
    }

    applyFilters(validate) {
        if (validate) {
            this._validateFormData().then(result => {
                if (result) {
                    this._applyFilters();
                }
            });
        } else {
            this._applyFilters();
        }
    }

    _applyFilters() {
        let filters = this.getFormData();

        if (this.listControl != null) {
            this.listControl.notifyFilters(filters);
            if (this.listControl.uid != null) {
                let listFilterHolder = JSON.parse(sessionStorage.getItem('listFilterHolder'));
                listFilterHolder[this.listControl.uid] = filters;
                sessionStorage.setItem('listFilterHolder', JSON.stringify(listFilterHolder));
            }
        }
    }

    _addButtonEvents() {
        if (this.isFilter) {
            $('#' + this.searchFilterButtonId).on('click', () => {
                let filters = this.getFormData();

                this._validateFormData().then(result => {
                    if (result) {
                        if (this.listControl != null) {
                            this.listControl.notifyFilters(filters);
                            if (this.listControl.uid != null) {
                                let listFilterHolder = JSON.parse(sessionStorage.getItem('listFilterHolder'));
                                listFilterHolder[this.listControl.uid] = filters;
                                sessionStorage.setItem('listFilterHolder', JSON.stringify(listFilterHolder));
                            }
                        }
                    }
                });
            });

            $('#' + this.clearFilterButtonId).on('click', () => {
                this._clearData(this.metadata, true);

                let filters = this.getFormData();

                if (this.listControl != null) {
                    this.listControl.notifyFilters(filters);
                    if (this.listControl.uid != null) {
                        let listFilterHolder = JSON.parse(sessionStorage.getItem('listFilterHolder'));
                        listFilterHolder[this.listControl.uid] = {};
                        sessionStorage.setItem('listFilterHolder', JSON.stringify(listFilterHolder));
                    }
                }
            });
        }

        if (this.actionButtons != null) {
            let cancelButtons = this.actionButtons.filter(row => { return row.SubType == 'CANCEL' });

            if (cancelButtons.length > 0) {
                $('#form-panel-close-' + this.pageGuid).show();
            } else {
                $('#form-panel-close-' + this.pageGuid).hide();
            }

            this.actionButtons.forEach(actionButton => {
                if (actionButton.SubType == 'SAVE' || actionButton.SubType == 'APPLY') {
                    if (this.allowEdit || this.isPreview) {
                        $('#form-action-' + actionButton.Id).show();
                    }
                } else if (actionButton.SubType == 'DELETE') {
                    if (this.allowDelete || this.isPreview) {
                        $('#form-action-' + actionButton.Id).show();
                    }
                } else if (actionButton.SubType == 'SHOW_IN_MAP' && (this.objectId == null || this.objectId == '')) {
                    $('#form-action-' + actionButton.Id).hide();
                } else if (actionButton.SubType == 'EDIT_GEOMETRY' && (this.objectId == null || this.objectId == '')) {
                    let hasGeom = false;
                    if (window.featuresToBeProcessed && window.featuresToBeProcessed.layerId && window.featuresToBeProcessed.features && window.featuresToBeProcessed.features.length > 0) {
                        let maps = Array.from(document.getElementsByClassName('xp-map'));
                        maps.forEach(map => {
                            let mapControl = map.mapControl;
                            let layerSettings = mapControl.layerSettingsHandler.getLayerSettings(window.featuresToBeProcessed.layerId);

                            if (actionButton.IdFieldTarget == layerSettings.Entity.GeometryFieldId) {
                                hasGeom = true;
                                this.actionGeom[actionButton.Id] = { wkt: window.featuresToBeProcessed.features[0].geom, srid: window.featuresToBeProcessed.features[0].srid };
                            }
                        });
                    }

                    if (!hasGeom) {
                        $('#form-action-' + actionButton.Id)[0].innerHTML = this._getActionResource('AddGeometry');
                    }
                    $('#form-action-' + actionButton.Id).show();
                } else {
                    $('#form-action-' + actionButton.Id).show();
                }

                $('#form-action-' + actionButton.Id).on('click', (e) => {
                    switch (actionButton.SubType) {
                        case 'EDIT_GEOMETRY': this._editGeometry(actionButton);
                            break;
                        case 'SHOW_IN_MAP': this._showGeometry(actionButton);
                            break;
                        case 'SELECT_FROM_MAP': this._selectMapElement(actionButton);
                            break;
                        case 'DELETE': this._deleteElement(actionButton);
                            break;
                        case 'FORM': this._showForm(actionButton);
                            break;
                        case 'URL': this._showUrl(actionButton);
                            break;
                        case 'FormWf': this._showWfForm(actionButton);
                            break;
                        case 'JS': this._handleJavascriptAction(actionButton);
                            break;
                        case 'CANCEL': this._cancelForm();
                            break;
                        case 'SAVE': this._saveForm(false, '#form-action-' + actionButton.Id);
                            break;
                        case 'APPLY': this._applyFormChanges(false, '#form-action-' + actionButton.Id);
                            break;
                        default: break;
                    }
                });
            });
        }

        if (this.context != 'modal') {
            $('#form-panel-close-' + this.pageGuid).hide();
        }
    }

    _cancelForm() {
        if (window.textAnnotator) {
            window.textAnnotator.destroy();
        }

        if (this.parentControl != null) {
            if (this.lastEditedLayer != null) {
                let maps = Array.from(document.getElementsByClassName('xp-map'));
                maps.forEach(map => {
                    let mapControl = map.mapControl;
                    let featureInteractionControl = mapControl.generalActionHandler.generalActionControls.editControl;
                    featureInteractionControl.clear();
                    featureInteractionControl.editSuspended = false;
                });
            }
            this.parentControl.closeModal();
        } else {
            if ($('#' + this.container).closest('.k-window-content').length > 0) {
                if (this.lastEditedLayer != null) {
                    let maps = Array.from(document.getElementsByClassName('xp-map'));
                    maps.forEach(map => {
                        let mapControl = map.mapControl;
                        let featureInteractionControl = mapControl.generalActionHandler.generalActionControls.editControl;
                        featureInteractionControl.clear();
                        featureInteractionControl.editSuspended = false;
                    });
                }

                $('#' + this.container).closest('.k-window-content').data('kendoWindow').close();
            } else {
                history.back();
            }
        }

        this._reloadDependantLayers();
    }

    _saveForm(ignoreNotification, initiatorId) {
        this.saveDataItem.values = {};
        this._storeData(this.metadata);
        this._storeGeomData();
        this._saveData(false, ignoreNotification, initiatorId);
    }

    _applyFormChanges(ignoreNotification, initiatorId) {
        this.saveDataItem.values = {};
        this._storeData(this.metadata);
        this._storeGeomData();
        this._saveData(true, ignoreNotification, initiatorId);
    }

    validateForm() {
        this.saveDataItem.values = {};
        this._storeData(this.metadata);
        this._storeGeomData();
        return this._validateFormData();
    }

    _editGeometry(actionButton) {
        if (window.mapCtrl) {
            this.formGeomEdited = true;
            let layerSettings = window.mapCtrl.config.layersSettings.filter(row => { return row.geometryFieldId == actionButton.IdFieldTarget })[0];

            let mapLayerId = layerSettings.id;
            let featureId = this.objectId;

            let scale = null;

            if (layerSettings.geometryType == 'POINT') {
                scale = 500;
            }

            if (featureInteractionControl.editSuspended == true) {
                $('.k-window').hide();
                $('.k-overlay').hide();
                featureInteractionControl.isFromForm = true;
                featureInteractionControl.startEdit(mapLayerId, null, (response) => {
                    if (response != null && response.features != null && response.features.length > 0) {
                        this.actionGeom[actionButton.Id] = { wkt: response.features[0].geom, srid: response.features[0].srid };
                        $('#form-action-' + actionButton.Id)[0].innerHTML = this._getActionResource('ElementAction_EDIT_GEOMETRY');
                    }
                    $('#' + this.container).closest('.k-window').show();
                    $('.k-overlay').show();
                    featureInteractionControl.editSuspended = true;
                }, () => {
                    $('#' + this.container).closest('.k-window').show();
                    $('.k-overlay').show();
                });
            } else {
                window.mapCtrl.showFeature(mapLayerId, featureId, scale, () => {
                    $('.k-window').hide();
                    $('.k-overlay').hide();
                    featureInteractionControl.isFromForm = true;
                    featureInteractionControl.startEdit(mapLayerId, null, (response) => {
                        if (response != null && response.features != null && response.features.length > 0) {
                            this.actionGeom[actionButton.Id] = { wkt: response.features[0].geom, srid: response.features[0].srid };
                            $('#form-action-' + actionButton.Id)[0].innerHTML = this._getActionResource('ElementAction_EDIT_GEOMETRY');
                        }
                        $('#' + this.container).closest('.k-window').show();
                        $('.k-overlay').show();
                        featureInteractionControl.editSuspended = true;
                    }, () => {
                        $('#' + this.container).closest('.k-window').show();
                        $('.k-overlay').show();
                    });
                }, (e) => {
                    if (e == 'Feature has no geometry' || e.message == 'Unexpected token \'<\', "<?xml vers"... is not valid JSON') {
                        $('.k-window').hide();
                        $('.k-overlay').hide();
                        featureInteractionControl.isFromForm = true;
                        featureInteractionControl.startInsert(mapLayerId, (response) => {
                            if (response != null && response.features != null && response.features.length > 0) {
                                this.actionGeom[actionButton.Id] = { wkt: response.features[0].geom, srid: response.features[0].srid };
                                $('#form-action-' + actionButton.Id)[0].innerHTML = this._getActionResource('ElementAction_EDIT_GEOMETRY');
                            }
                            $('#' + this.container).closest('.k-window').show();
                            $('.k-overlay').show();
                            featureInteractionControl.editSuspended = true;
                        }, () => {
                            $('#' + this.container).closest('.k-window').show();
                            $('.k-overlay').show();
                        });
                    } else {
                        toastr.error(e);
                    }
                });
            }
        } else {
            let maps = Array.from(document.getElementsByClassName('xp-map'));
            maps.forEach(map => {
                let mapControl = map.mapControl;

                let layerSettings = mapControl.layerSettingsHandler.getLayerSettingsByField(actionButton.IdFieldTarget, this.idExtConn, this.objectId, true);

                let mapLayerId = layerSettings.Id;
                let featureId = this.objectId;

                let scale = null;

                if (layerSettings.Entity.GeometryFieldTyp == 'POINT') {
                    scale = 500;
                }

                let featureInteractionControl = mapControl.generalActionHandler.generalActionControls.editControl;

                let existingFeatures;

                if (this.actionGeom != null && this.actionGeom[actionButton.Id] != null && this.actionGeom[actionButton.Id].wkt != null) {
                    existingFeatures = [this.actionGeom[actionButton.Id]];
                }

                if (featureInteractionControl.editSuspended == true || existingFeatures != null) {
                    $('.k-window').hide();
                    $('.k-overlay').hide();
                    featureInteractionControl.isFromForm = true;
                    featureInteractionControl.startEdit(mapLayerId, null, (response) => {
                        if (response != null && response.features != null && response.features.length > 0) {
                            this.actionGeom[actionButton.Id] = { wkt: response.features[0].geom, srid: response.features[0].srid };
                            $('#form-action-' + actionButton.Id)[0].innerHTML = this._getActionResource('ElementAction_EDIT_GEOMETRY');
                        }
                        $('#' + this.container).closest('.k-window').show();
                        $('.k-overlay').show();
                        featureInteractionControl.editSuspended = true;
                        this.lastEditedLayer = mapLayerId;
                        featureInteractionControl.isFromForm = false;
                    }, () => {
                        $('#' + this.container).closest('.k-window').show();
                        $('.k-overlay').show();
                        this.lastEditedLayer = null;
                        featureInteractionControl.isFromForm = false;
                    }, existingFeatures);
                } else {
                    mapControl.showFeature(mapLayerId, featureId, scale, () => {
                        $('.k-window').hide();
                        $('.k-overlay').hide();
                        featureInteractionControl.isFromForm = true;
                        featureInteractionControl.startEdit(mapLayerId, null, (response) => {
                            if (response != null && response.features != null && response.features.length > 0) {
                                this.actionGeom[actionButton.Id] = { wkt: response.features[0].geom, srid: response.features[0].srid };
                                $('#form-action-' + actionButton.Id)[0].innerHTML = this._getActionResource('ElementAction_EDIT_GEOMETRY');
                            }
                            $('#' + this.container).closest('.k-window').show();
                            $('.k-overlay').show();
                            featureInteractionControl.editSuspended = true;
                            this.lastEditedLayer = mapLayerId;
                            featureInteractionControl.isFromForm = false;
                        }, () => {
                            $('#' + this.container).closest('.k-window').show();
                            $('.k-overlay').show();
                            this.lastEditedLayer = null;
                            featureInteractionControl.isFromForm = false;
                        });
                    }, (e) => {
                        if (e == 'Feature has no geometry' || e.message == 'Unexpected token \'<\', "<?xml vers"... is not valid JSON' || e.message == 'Unsupported GeoJSON type: undefined') {
                            $('.k-window').hide();
                            $('.k-overlay').hide();
                            featureInteractionControl.isFromForm = true;
                            featureInteractionControl.startInsert(mapLayerId, (response) => {
                                if (response != null && response.features != null && response.features.length > 0) {
                                    this.actionGeom[actionButton.Id] = { wkt: response.features[0].geom, srid: response.features[0].srid };
                                    $('#form-action-' + actionButton.Id)[0].innerHTML = this._getActionResource('ElementAction_EDIT_GEOMETRY');
                                }
                                $('#' + this.container).closest('.k-window').show();
                                $('.k-overlay').show();
                                featureInteractionControl.editSuspended = true;
                                this.lastEditedLayer = mapLayerId;
                                featureInteractionControl.isFromForm = false;
                            }, () => {
                                $('#' + this.container).closest('.k-window').show();
                                $('.k-overlay').show();
                                this.lastEditedLayer = null;
                                featureInteractionControl.isFromForm = false;
                            });
                        } else {
                            toastr.error(e);
                        }
                    });
                }
            });
        }
    }

    _selectMapElement(actionButton) {
        $('.k-window').hide();
        $('.k-overlay').hide();
        $event.register("featureSelectionChanged", this.featureSelectionChangedHandler, $('#' + this.container)[0], null);
    }

    _handleMapElementSelection() {
        let featureSelectionChangedHandler = (eventName, eventArgs, sender) => {
            $('#' + this.container).closest('.k-window').show();
            $('.k-overlay').show();

            if (eventArgs.layerId != null) {
                $event.unregister("featureSelectionChanged", this.featureSelectionChangedHandler, $('#' + this.container)[0], null);
                this.currentSelectedLayer = eventArgs.layerId;
                this.currentSelectedFeature = eventArgs.featureId;
                this.currentSelectedLayerObject = eventArgs.layer;

                if (window['onMapElementSelected' + this.pageGuid] && !this.isPreview) {
                    window['onMapElementSelected' + this.pageGuid](this.currentSelectedLayer, this.currentSelectedFeature, this.currentSelectedLayerObject);
                }
            }
        }

        return featureSelectionChangedHandler;
    }

    _showGeometry(actionButton) {
        if (window.mapCtrl) {
            let layerSettings = window.mapCtrl.config.layersSettings.filter(row => { return row.geometryFieldId == actionButton.IdFieldTarget })[0];

            let mapLayerId = layerSettings.id;
            let featureId = this.objectId;

            let scale = null;

            if (layerSettings.geometryType == 'POINT') {
                scale = 500;
            }

            if (legendControl != null) {
                legendControl.toggleSelection(mapLayerId, true);
            }

            window.mapCtrl.showFeature(mapLayerId, featureId, scale, () => { }, (evt) => {
                swal.fire({ title: 'Atentie', html: this._getResource(evt) });
            });
        } else {
            let maps = Array.from(document.getElementsByClassName('xp-map'));
            maps.forEach(map => {
                let mapControl = map.mapControl;

                let layerSettings = mapControl.layerSettingsHandler.getLayerSettingsByField(actionButton.IdFieldTarget, this.idExtConn, this.objectId, true);

                let mapLayerId = layerSettings.Id;
                let featureId = this.objectId;

                let scale = null;

                if (layerSettings.Entity.GeometryFieldType == 'POINT') {
                    scale = 500;
                }

                mapControl.generalActionHandler.generalActionControls.legendControl.toggleSelection(mapLayerId, true);

                mapControl.showFeature(mapLayerId, featureId, scale, () => { }, (evt) => {
                    if (typeof evt == 'object' && evt.message != null) {
                        swal.fire({ title: 'Atentie', html: this._getResource(evt.message), allowOutsideClick: false });
                    } else if (typeof evt == 'string') {
                        swal.fire({ title: 'Atentie', html: this._getResource(evt), allowOutsideClick: false });
                    }
                });
            });
        }
    }

    _deleteElement(actionButton) {
        confirmDialog.fire({
            title: this._getCustomFormResource('DeleteItemTitle'),
            text: this._getCustomFormResource('DeleteItemContent'),
            allowOutsideClick: false
        }).then((result) => {
            if (result.value) {
                let url = rootUrl + 'Entity/DeleteData';
                let data = {
                    pkVal: this.objectId,
                    idEntity: this.metadata.IdEntity,
                    idExtConn: this.idExtConn
                };

                $.ajax({
                    type: "POST",
                    url: url,
                    async: true,
                    data: JSON.stringify(data),
                    contentType: "application/json; charset=utf-8",
                    success: (result) => {
                        if (this.parentControl == null) {
                            if ($('#' + this.container).closest('.k-window-content').length > 0) {
                                let maps = Array.from(document.getElementsByClassName('xp-map'));

                                maps.forEach(map => {
                                    let mapControl = map.mapControl;

                                    if (this.lastEditedLayer != null) {
                                        let featureInteractionControl = mapControl.generalActionHandler.generalActionControls.editControl;
                                        featureInteractionControl.clear();
                                        featureInteractionControl.editSuspended = false;
                                    }

                                    mapControl.refresh();
                                    mapControl.clearSelection();
                                });

                                $('#' + this.container).closest('.k-window-content').data('kendoWindow').close();
                            } else {
                                history.back();
                            }
                        } else {
                            let maps = Array.from(document.getElementsByClassName('xp-map'));

                            maps.forEach(map => {
                                let mapControl = map.mapControl;

                                if (this.lastEditedLayer != null) {
                                    let featureInteractionControl = mapControl.generalActionHandler.generalActionControls.editControl;
                                    featureInteractionControl.clear();
                                    featureInteractionControl.editSuspended = false;
                                }

                                mapControl.refresh();
                                mapControl.clearSelection();
                            });

                            this.parentControl.closeModal();
                        }
                    },
                    error: (e) => {
                        toastr.error(this._getCustomFormResource('RemoveItemError'));
                    }
                });
            }
        });
    }

    _showForm(actionButton) {
        let url = rootUrl + 'EntityForm/EntityFormRuntime';

        //idform
        if (actionButton.IdFormTarget != null && actionButton.IdFormTarget != '') {
            url += '?idForm=' + actionButton.IdFormTarget;
        } else {
            url += '?idForm=' + this.getFieldData(actionButton.IdFormUIObjTarget);
        }
        if (this.idExtConn = null) {
            url += '&idExtConn=' + this.idExtConn;
        }

        //pkVal
        if (actionButton.NewRecord) {
            //do nothing here
        }
        else {
            if (actionButton.IdUIObjTarget != null) {
                url += '&pkVal=' + this.getFieldData(actionButton.IdUIObjTarget);
            } else {
                url += '&pkVal=' + this.objectId;
            }
        }

        url += '&idaction=' + actionButton.Id + '&pkValCurrent=' + this.objectId;

        if (url.indexOf('idApp') < 0) {
            url += '&idApp=' + xapp.currentApp;
        }

        if (this.parentGuid == null || this.parentGuid == '') {
            $.pjax({ url: url, container: '#js-page-content', timeout: 10000, contentType: 'application/json' })
        } else {
            let width = null;
            let height = null;
            if (actionButton.UiContent != null && actionButton.UiContent.trim() != '') {
                let uiContent = JSON.parse(actionButton.UiContent);

                if (uiContent.modalWidth != null && uiContent.modalWidth.trim() != '') {
                    width = uiContent.modalWidth;
                }

                if (uiContent.modalHeight != null && uiContent.modalHeight.trim() != '') {
                    height = uiContent.modalHeight;
                }
            }

            this.initModal('', height, url, false, width);
        }
    }

    _getXpList(identifier) {
        let lists = $('.xp-list-container');

        if (lists.length > 0) {
            for (let i = 0; i < lists.length; i++) {
                if (lists[i][identifier]) {
                    return lists[i][identifier];
                }
            }
        }
    }

    _showUrl(actionButton) {
        let url = actionButton.Url;

        if (this.parentGuid == null || this.parentGuid == '') {
            if (url.indexOf('http') == 0) {
                window.open(url, '_blank');
            } else {
                $.pjax({ url: url, container: '#js-page-content', timeout: 10000 })
            }
        } else {
            if (url.indexOf('http') == 0) {
                window.open(url, '_blank');
            } else {
                let width = null;
                let height = null;

                if (actionButton.UiContent != null && actionButton.UiContent.trim() != '') {
                    let uiContent = JSON.parse(actionButton.UiContent);

                    if (uiContent.modalWidth != null && uiContent.modalWidth.trim() != '') {
                        width = uiContent.modalWidth;
                    }

                    if (uiContent.modalHeight != null && uiContent.modalHeight.trim() != '') {
                        height = uiContent.modalHeight;
                    }
                }

                this.initModal('', height, url, false, width);
            }
        }
    }

    _checkMobile() {
        return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    }

    initModal(title, height, url, hideButtons, width, keepForm) {
        let modalOptions = {
            draggable: true,
            resizable: true,
            width: width != null ? width : "70%",
            height: height != null ? height : "auto",
            title: title,
            modal: true,
            close: () => { this.closeModal(keepForm); },
            actions: hideButtons ? [] : ["Minimize", "Maximize", "Close"]
        };

        if (this._checkMobile()) {
            modalOptions.height = 'auto';
            modalOptions.maxHeight = 'calc(100% - 3.8rem)';
            modalOptions.width = '100%';
        }

        if (url != null && url != '') {
            if (url.indexOf('?') >= 0) {
                url += '&context=modal&parentGuid=' + this.uniqueId;
            } else {
                url += '?context=modal&parentGuid=' + this.uniqueId;
            }

            modalOptions.content = {
                type: "GET",
                url: url,
                contentType: "application/json"
            };
        }

        $('#' + this.uniqueModalId).append('<div class="p-1" id="' + this.uniqueModalInnerId + '"></div>');

        $('#' + this.uniqueModalInnerId).kendoWindow(modalOptions);

        if ($('body')[0].classList.contains('mod-skin-dark')) {
            $('.k-window').addClass('mod-skin-dark');
        }

        this.centerModal();

        if (!hideButtons) {
            $('#' + this.container).closest('.k-window').hide();
        }
    }

    centerModal() {
        $('#' + this.uniqueModalInnerId).data("kendoWindow").center();

        if (this._checkMobile()) {
            setTimeout(() => {
                $('#' + this.uniqueModalInnerId).data("kendoWindow").wrapper.css({ top: "3.8rem", position: 'fixed' });
            }, 1000);
        }
    }

    closeModal(keepForm) {
        $('#' + this.uniqueModalInnerId).data("kendoWindow").destroy();
        $('#' + this.container).closest('.k-window').show();

        if (!keepForm) {
            this.reloadForm();
        }
    }

    _showWfForm(actionButton) {
        var url = rootUrl + 'UIAction/GetFormWFRun?idAction=' + actionButton.Id;

        if (actionButton.Content != null && actionButton.Content.trim() != '') {
            let paramsMap = JSON.parse(actionButton.Content);
            let params = {};
            if (paramsMap.length > 0) {
                paramsMap.forEach(param => {
                    params[param] = this.getFieldValueById(param);
                });
            }

            url += '&parameters=' + JSON.stringify(params);
        }

        if (this.parentGuid == null || this.parentGuid == '') {
            $.pjax({ url: url, container: '#js-page-content', timeout: 10000 })
        } else {
            let width = null;
            let height = null;

            if (actionButton.UiContent != null && actionButton.UiContent.trim() != '') {
                let uiContent = JSON.parse(actionButton.UiContent);

                if (uiContent.modalWidth != null && uiContent.modalWidth.trim() != '') {
                    width = uiContent.modalWidth;
                }

                if (uiContent.modalHeight != null && uiContent.modalHeight.trim() != '') {
                    height = uiContent.modalHeight;
                }
            }

            this.initModal('', height, url, false, width);
        }
    }

    _handleJavascriptAction(actionButton) {
        if (window['btn_' + actionButton.Id + '_onClick'] != null) {
            window['btn_' + actionButton.Id + '_onClick']();
        }
    }

    getFieldData(id) {
        let formData = this.getFormData();
        return formData.values['fld_' + id];
    }

    getFormData() {
        this._storeData(this.metadata);
        this._storeGeomData();
        return this.saveDataItem;
    }

    _storeGeomData() {
        let keys = Object.keys(this.actionGeom);
        keys.forEach(key => {
            this.saveDataItem.values['act_' + key] = this.actionGeom[key];
        });
    }

    // send data to backend

    _saveData(reloadData, ignoreNotification, initiatorId) {
        this._validateFormData().then(result => {
            if (result) {
                this._storeData(this.metadata);
                this._storeGeomData();

                if (this.uploadedFiles != null && Object.keys(this.uploadedFiles).length > 0) {
                    let fileKeys = Object.keys(this.uploadedFiles);
                    let filesToUpload = fileKeys.filter(row => { return !this.uploadedFiles[row].uploadedFileProcessed; });

                    if (filesToUpload.length > 0) {
                        this._uploadFilesAndSubmitData(filesToUpload, reloadData, ignoreNotification, initiatorId);
                    } else {
                        this._submitData(reloadData, ignoreNotification, initiatorId);
                    }
                } else {
                    this._submitData(reloadData, ignoreNotification, initiatorId);
                }
            }
        });
    }

    _saveState(ignoreNotification, ignoreValidation) {
        return new Promise((resolve, reject) => {
            var url;
            if (this.saveDataUrl == null || this.saveDataUrl == "") {
                url = rootUrl + 'EntityForm/SaveData';
            }
            else {
                url = rootUrl + this.saveDataUrl;
            }
            let saveDataUrl = url;

            this.saveDataItem.otherParameters = this.otherParameters;
            if (this.saveDataPostParam != null && this.saveDataPostParam != "") {
                this.saveDataItem.postParam = this.saveDataPostParam;
            }

            if (ignoreNotification) {
                this.saveDataItem.ignoreNotify = true;
            }

            if (ignoreValidation) {
                this.saveDataItem.ignoreNullValidation = true;
            }

            $.ajax({
                type: "POST",
                url: saveDataUrl,
                headers: {
                    'X-XSRF-TOKEN': getCookie('XSRF-TOKEN')
                },
                async: true,
                data: JSON.stringify(this.saveDataItem),
                contentType: "application/json; charset=utf-8",
                success: (result) => {
                    if (result != null && (result.Error == null || result.Error == '')) {
                        resolve(result);
                    } else if (result == null || result.Error == null) {
                        reject(this.getResource('GetLayoutError'));
                        toastr.error(this.getResource('GetLayoutError'));
                    } else {
                        toastr.error(result.Error);
                        reject(result.Error);
                    }
                },
                error: (e) => {
                    toastr.error(this.getResource('GetLayoutError'));
                    reject(this.getResource('GetLayoutError'));
                }
            });
        });
    }

    _uploadFilesAndSubmitData(filesToUpload, reloadData, ignoreNotification, initiatorId) {
        let invalidSize = false;
        filesToUpload.forEach((fileToUpload) => {
            if (this.uploadedFiles[fileToUpload].file.size == 0) {
                invalidSize = true;
            }
        });

        if (invalidSize) {
            swal.fire({ title: 'Atentie', html: 'Fisierele incarcate nu pot fi goale!' });
            return;
        }

        this.reloadAfterSubmit = reloadData;
        this.ignoreNotificationAfterSubmit = ignoreNotification;
        this.initiatorIdAfterSubmit = initiatorId;
        this.initModal(this._getResource('FilesUploadTitle'), 'auto', null, true, '50%');

        let template = `<div class="panel-content file-uploads-panel">`;

        filesToUpload.forEach(fileToUpload => {
            template += `<div class="form-row">
                            <label class="form-label pl-1">` + this.uploadedFiles[fileToUpload].file.name + `</label>
                        </div>
                        <div class="file-upload-progress" id="` + fileToUpload + `-progress">
                            <div class="file-upload-bar" id="` + fileToUpload + `-bar">0%</div>
                         </div>`;
        });
        template += `<div id="file-uploads-buttons" style="display: none;"><div class="panel-content border-faded border-left-0 border-right-0 border-bottom-0 d-flex flex-row align-items-right pr-0 pb-0 pt-2 pl-0 mr-0 ml-0" style="padding-bottom: 0.5rem !important; display: none;"><button id="file-uploads-cancel" class="btn ml-auto btn-secondary" title="` + this._getResource('Cancel') + `" type="button">` + this._getResource('Cancel') + `</button></div></div>`;
        template += `</div>`;

        $('#' + this.uniqueModalInnerId).append(template);
        this.centerModal();

        $('#file-uploads-cancel').on('click', () => {
            this.closeModal();
        });

        filesToUpload.forEach(fileToUpload => {
            this.dropzones[fileToUpload].get(0).dropzone.uploadFile(this.dropzones[fileToUpload].get(0).dropzone.files[0]);
        });
    }

    _saveFormData(reloadData, ignoreNotification, initiatorId, saveDataUrl) {
        if (initiatorId != null && $(initiatorId) != null) {
            $(initiatorId).attr('disabled', true);
        }

        if (this.fromActionType == 'ADD' && this.saveDataItem.values) {
            if (window.featuresToBeProcessed && window.featuresToBeProcessed.layerId && window.featuresToBeProcessed.features && window.featuresToBeProcessed.features.length > 0) {
                this.saveDataItem.values['ml_' + window.featuresToBeProcessed.layerId] = { wkt: window.featuresToBeProcessed.features[0].geom, srid: window.featuresToBeProcessed.features[0].srid };
                this.lastEditedLayer = window.featuresToBeProcessed.layerId;
            }
        }

        if ((this.fromActionType == 'ADD_MULTI' || this.fromActionType == 'EDIT_MULTI') && this.saveDataItem.values) {
            if (window.featuresToBeProcessed && window.featuresToBeProcessed.layerId && window.featuresToBeProcessed.features && window.featuresToBeProcessed.features.length > 0) {
                let data = [];
                this.lastEditedLayer = window.featuresToBeProcessed.layerId;
                window.featuresToBeProcessed.features.forEach(x => {
                    let clone = JSON.parse(JSON.stringify(this.saveDataItem));

                    if (this.fromActionType == 'EDIT_MULTI') {
                        clone.pkVal = x;
                    } else if (this.fromActionType == 'ADD_MULTI') {
                        clone.values['ml_' + window.featuresToBeProcessed.layerId] = { wkt: x.geom, srid: x.srid };
                    }

                    data.push(clone);
                });

                window.featuresToBeProcessed = null;

                saveDataUrl = rootUrl + 'EntityForm/SaveBulkData';
                showLoadingPanel();
                $.ajax({
                    type: "POST",
                    url: saveDataUrl,
                    async: true,
                    data: JSON.stringify(data),
                    contentType: "application/json; charset=utf-8",
                    headers: {
                        'X-XSRF-TOKEN': getCookie('XSRF-TOKEN')
                    },
                    success: (result) => {
                        hideLoadingPanel();
                        if (this.lastEditedLayer != null) {
                            let maps = Array.from(document.getElementsByClassName('xp-map'));
                            maps.forEach(map => {
                                let mapControl = map.mapControl;
                                let featureInteractionControl = mapControl.generalActionHandler.generalActionControls.editControl;
                                featureInteractionControl.clear();
                                featureInteractionControl.editSuspended = false;
                            });
                        }

                        this._reloadDependantLayers();

                        if (this.parentControl == null) {
                            if ($('#' + this.container).closest('.k-window-content').length > 0) {
                                $('#' + this.container).closest('.k-window-content').data('kendoWindow').close();
                            } else {
                                history.back();
                            }
                        } else {
                            this.parentControl.closeModal();
                        }
                    },
                    error: (e) => {
                        hideLoadingPanel();
                        if (initiatorId != null && $(initiatorId) != null) {
                            $(initiatorId).attr('disabled', false);
                        }

                        toastr.error(this.getResource('GetLayoutError'));
                    }
                });
            }
        } else {
            showLoadingPanel();
            $.ajax({
                type: "POST",
                url: saveDataUrl,
                async: true,
                data: JSON.stringify(this.saveDataItem),
                contentType: "application/json; charset=utf-8",
                headers: {
                    'X-XSRF-TOKEN': getCookie('XSRF-TOKEN')
                },
                success: (result) => {
                    hideLoadingPanel();
                    if (initiatorId != null && $(initiatorId) != null) {
                        $(initiatorId).attr('disabled', false);
                    }

                    if (result != null && (result.Error == null || result.Error == '')) {
                        if (window['onAfterFormSaved' + this.pageGuid] != null && !this.isPreview) {
                            var data = this.saveDataItem;
                            if (result.jsonEntity != null && result.jsonEntity != '') {
                                var parsedResult = JSON.parse(result.jsonEntity);
                                data.pkVal = parsedResult.pkVal;
                            }
                            window['onAfterFormSaved' + this.pageGuid](data, result).then(() => {
                                if (!reloadData) {
                                    if (this.lastEditedLayer) {
                                        let maps = Array.from(document.getElementsByClassName('xp-map'));
                                        maps.forEach(map => {
                                            let mapControl = map.mapControl;
                                            let featureInteractionControl = mapControl.generalActionHandler.generalActionControls.editControl;

                                            featureInteractionControl.stopEdit();
                                            featureInteractionControl.clear();
                                            featureInteractionControl.editSuspended = false;
                                        });
                                    }

                                    this._reloadDependantLayers();

                                    if (this.parentControl == null) {
                                        if ($('#' + this.container).closest('.k-window-content').length > 0) {
                                            $('#' + this.container).closest('.k-window-content').data('kendoWindow').close();
                                        } else {
                                            history.back();
                                        }
                                    } else {
                                        this.parentControl.closeModal();
                                    }
                                } else {
                                    if (this.lastEditedLayer != null) {
                                        let maps = Array.from(document.getElementsByClassName('xp-map'));
                                        maps.forEach(map => {
                                            let mapControl = map.mapControl;
                                            let featureInteractionControl = mapControl.generalActionHandler.generalActionControls.editControl;
                                            featureInteractionControl.clear();
                                            featureInteractionControl.editSuspended = false;
                                        });
                                    }

                                    this._reloadDependantLayers();

                                    if (result.jsonEntity != null && result.jsonEntity != '') {
                                        let parsedResult = JSON.parse(result.jsonEntity);

                                        let newId = parsedResult.pkVal;
                                        if (this.objectId != newId) {
                                            this.objectId = newId;
                                            this.saveDataItem.pkVal = this.objectId;

                                            if (this.context == 'full') {
                                                var newURL = this._updateURLParameter(window.location.href, 'pkVal', newId);
                                                let state = history.state;

                                                if (state != null) {
                                                    state.url = newURL;
                                                }

                                                history.replaceState(state, '', newURL);
                                            }
                                        }
                                    }

                                    this.reloadForm();
                                }
                            });
                        } else {
                            if (!reloadData) {
                                if (this.lastEditedLayer) {
                                    let maps = Array.from(document.getElementsByClassName('xp-map'));
                                    maps.forEach(map => {
                                        let mapControl = map.mapControl;
                                        let featureInteractionControl = mapControl.generalActionHandler.generalActionControls.editControl;

                                        featureInteractionControl.stopEdit();
                                        featureInteractionControl.clear();
                                        featureInteractionControl.editSuspended = false;
                                    });
                                }

                                this._reloadDependantLayers();

                                if (this.parentControl == null) {
                                    if ($('#' + this.container).closest('.k-window-content').length > 0) {
                                        $('#' + this.container).closest('.k-window-content').data('kendoWindow').close();
                                    } else {
                                        history.back();
                                    }
                                } else {
                                    this.parentControl.closeModal();
                                }
                            } else {
                                if (this.lastEditedLayer != null) {
                                    let maps = Array.from(document.getElementsByClassName('xp-map'));
                                    maps.forEach(map => {
                                        let mapControl = map.mapControl;
                                        let featureInteractionControl = mapControl.generalActionHandler.generalActionControls.editControl;
                                        featureInteractionControl.clear();
                                        featureInteractionControl.editSuspended = false;
                                    });
                                }

                                this._reloadDependantLayers();

                                if (result.jsonEntity != null && result.jsonEntity != '') {
                                    let parsedResult = JSON.parse(result.jsonEntity);

                                    let newId = parsedResult.pkVal;
                                    if (this.objectId != newId) {
                                        this.objectId = newId;
                                        this.saveDataItem.pkVal = this.objectId;

                                        if (this.context == 'full') {
                                            var newURL = this._updateURLParameter(window.location.href, 'pkVal', newId);
                                            let state = history.state;

                                            if (state != null) {
                                                state.url = newURL;
                                            }

                                            history.replaceState(state, '', newURL);
                                        }
                                    }
                                }

                                this.reloadForm();
                            }
                        }
                    } else if (result == null || result.Error == null) {
                        toastr.error(this.getResource('GetLayoutError'));
                    } else {
                        if (window['onAfterFormSaved' + this.pageGuid] != null && !this.isPreview) {
                            window['onAfterFormSaved' + this.pageGuid](this.saveDataItem, result).then(() => {
                                toastr.error(result.Error);
                            });
                        } else {
                            toastr.error(result.Error);
                        }
                    }
                },
                error: (e) => {
                    hideLoadingPanel();
                    if (initiatorId != null && $(initiatorId) != null) {
                        $(initiatorId).attr('disabled', false);
                    }

                    toastr.error(this.getResource('GetLayoutError'));
                }
            });
        }
    }

    _submitData(reloadData, ignoreNotification, initiatorId) {
        var url;
        if (this.saveDataUrl == null || this.saveDataUrl == "") {
            url = rootUrl + 'EntityForm/SaveData';
        }
        else {
            url = rootUrl + this.saveDataUrl;
        }
        let saveDataUrl = url;

        this.saveDataItem.otherParameters = this.otherParameters;
        if (this.saveDataPostParam != null && this.saveDataPostParam != "") {
            this.saveDataItem.postParam = this.saveDataPostParam;
        }

        if (ignoreNotification) {
            this.saveDataItem.ignoreNotify = true;
        }

        if (window['onBeforeFormSaved' + this.pageGuid] != null && !this.isPreview) {
            window['onBeforeFormSaved' + this.pageGuid](this.saveDataItem).then((save) => {
                if (save) {
                    this._saveFormData(reloadData, ignoreNotification, initiatorId, saveDataUrl);
                }
            });
        } else {
            this._saveFormData(reloadData, ignoreNotification, initiatorId, saveDataUrl);
        }
    }

    _updateURLParameter(url, param, paramVal) {
        var newAdditionalURL = "";
        var tempArray = url.split("?");
        var baseURL = tempArray[0];
        var additionalURL = tempArray[1];
        var temp = "";
        if (additionalURL) {
            tempArray = additionalURL.split("&");
            for (var i = 0; i < tempArray.length; i++) {
                if (tempArray[i].split('=')[0] != param) {
                    newAdditionalURL += temp + tempArray[i];
                    temp = "&";
                }
            }
        }

        var rows_txt = temp + "" + param + "=" + paramVal;
        return baseURL + "?" + newAdditionalURL + rows_txt;
    }

    _validateFormData() {
        return new Promise((resolve, reject) => {
            this.isValid = true;

            let keys = Object.keys(this.saveDataItem.values);
            let promises = [];

            for (let i = 0; i < keys.length; i++) {
                if (keys[i].indexOf('fld') >= 0) {
                    let tuples = keys[i].split('_');

                    if (tuples.length == 2) {
                        let id = tuples[1];

                        let item = this._searchFieldById(this.metadata, id);

                        promises.push(this._checkItemValidity(item));
                    }
                }
            }

            Promise.all(promises).then(() => {
                resolve(this.isValid);
            });
        });
    }

    _decorateField(item, isValid, message) {
        if (isValid) {
            $("#" + item.UniqueClientId + '-validation').hide();
            $("#" + item.UniqueClientId + '-validation').removeClass('invalid-item');
            $("#" + item.UniqueClientId + '-validation').siblings('span').children('span').children('.k-select').removeClass('invalid-kendo-select');
            $("#" + item.UniqueClientId + '-validation').siblings('span').children('span').children('.k-input').removeClass('invalid-kendo-input');
            $("#" + item.UniqueClientId + '-validation').siblings('.normal-input').removeClass('invalid-normal-input');
            $("#" + item.UniqueClientId + '-validation').siblings('.dropzone').removeClass('invalid-normal-input');
        } else {
            $("#" + item.UniqueClientId + '-validation').show();

            if (message) {
                $("#" + item.UniqueClientId + '-validation')[0].innerHTML = message;
            } else {
                $("#" + item.UniqueClientId + '-validation')[0].innerHTML = this._getFieldValidationMessage(item);
            }

            $("#" + item.UniqueClientId + '-validation').addClass('invalid-item');
            $("#" + item.UniqueClientId + '-validation').siblings('span').children('span').children('.k-select').addClass('invalid-kendo-select');
            $("#" + item.UniqueClientId + '-validation').siblings('span').children('span').children('.k-input').addClass('invalid-kendo-input');
            $("#" + item.UniqueClientId + '-validation').siblings('.normal-input').addClass('invalid-normal-input');
            $("#" + item.UniqueClientId + '-validation').siblings('.dropzone').addClass('invalid-normal-input');
        }
    }

    // clear input data

    _clearData(item, ignoreHidden) {
        if (item.TypeName == 'UIFieldControlDto' || item.TypeName == 'UICustomFieldControlDto') {
            let isEligible = true;

            if (ignoreHidden && item.Hidden) {
                isEligible = false;
            }

            if (isEligible && item.CtlType != null) {
                switch (item.CtlType) {
                    case 'Switch': this._threeStateSwitchSetValue("#" + item.UniqueClientId, null);
                        break;
                    case 'IntegerTextBox': $("#" + item.UniqueClientId).data('kendoNumericTextBox').value(null);
                        break;
                    case 'DatePicker': $("#" + item.UniqueClientId).data('kendoDatePicker').value(null);
                        break;
                    case 'NumericTextBox': $("#" + item.UniqueClientId).data('kendoNumericTextBox').value(null);
                        break;
                    case 'TextBox': $("#" + item.UniqueClientId).val(null);
                        break;
                    case 'TextArea': $("#" + item.UniqueClientId).val(null);
                        break;
                    case 'RichText': $("#" + item.UniqueClientId).data('kendoEditor').value(null);
                        break;
                    case 'DateTimePicker': $("#" + item.UniqueClientId).data('kendoDateTimePicker').value(null);
                        break;
                    case 'ComboBox': {
                        switch (this._getFieldControlSubType(item)) {
                            case 'ListView': break; //TO DO
                            case 'MultiSelect': $("#" + item.UniqueClientId).data('kendoMultiSelect').value(null);
                                break;
                            case 'TreeView': $("#" + item.UniqueClientId).data('kendoDropDownTree').value(null);
                                break;
                            default: $("#" + item.UniqueClientId).data('kendoComboBox').value(null);
                                break;
                        }
                    }
                        break;
                    case 'GeomPicker': {
                        switch (this._getFieldControlSubType(item)) {
                            case 'ModalMap': $("#" + item.UniqueClientId).val(null);
                                break;
                            case 'MapView': this._clearGeomPickerMapViewData(item);
                                break;
                        }
                    }
                        break;
                    case 'File': break;
                    default: break;
                }
            }
        }

        if (item.Items != null && item.Items.length > 0) {
            item.Items.forEach(child => {
                this._clearData(child, ignoreHidden);
            });
        }
    }

    _clearGeomPickerMapViewData(item) {
        throw 'unimeplented';
    }

    // store input data

    _storeData(item) {
        if (item.TypeName == 'UIFieldControlDto' || item.TypeName == 'UICustomFieldControlDto') {
            if (item.CtlType != null) {
                switch (item.CtlType) {
                    case 'Switch': this._storeSwitchData(item);
                        break;
                    case 'IntegerTextBox': this._storeIntegerTextBoxData(item);
                        break;
                    case 'DatePicker': this._storeDatePickerData(item);
                        break;
                    case 'NumericTextBox': this._storeNumericTextBoxData(item);
                        break;
                    case 'TextBox': this._storeTextBoxData(item);
                        break;
                    case 'TextArea': this._storeTextAreaData(item);
                        break;
                    case 'RichText': this._storeRichTextData(item);
                        break;
                    case 'DateTimePicker': this._storeDateTimePickerData(item);
                        break;
                    case 'ComboBox': {
                        switch (this._getFieldControlSubType(item)) {
                            case 'ListView': this._storeComboBoxListViewData(item);
                                break;
                            case 'MultiSelect': this._storeMultiSelectData(item);
                                break;
                            case 'TreeView': this._storeDropDownTreeData(item);
                                break;
                            default: this._storeComboBoxData(item);
                                break;
                        }
                    }
                        break;
                    case 'GeomPicker': {
                        switch (this._getFieldControlSubType(item)) {
                            case 'ModalMap': this._storeGeomPickerModalMapControl(item);
                                break;
                            case 'MapView': this._storeGeomPickerMapViewControl(item);
                                break;
                        }
                    }
                        break;
                    case 'File': this._storeFileData(item);
                        break;
                    default: break;
                }
            }
        }

        if (item.Items != null && item.Items.length > 0) {
            item.Items.forEach(child => {
                this._storeData(child);
            });
        }
    }

    _storeDatePickerData(item) {
        if (item.IsReadOnly || $("#" + item.UniqueClientId).attr('persisted') == 'false' || this.dataItem['fld_' + item.Id + '_xp_allow_view'] == 0 || this.dataItem['fld_' + item.Id + '_xp_allow_edit'] == 0) {
            return;
        }

        let value = null;

        if ($("#" + item.UniqueClientId).data('kendoDatePicker').value() != null && $("#" + item.UniqueClientId).data('kendoDatePicker').value() != '') {
            value = this._serializeDate($("#" + item.UniqueClientId).data('kendoDatePicker').value());
        }

        this.saveDataItem.values['fld_' + item.Id] = value;
    }

    _storeIntegerTextBoxData(item) {
        if (item.IsReadOnly || $("#" + item.UniqueClientId).attr('persisted') == 'false' || this.dataItem['fld_' + item.Id + '_xp_allow_view'] == 0 || this.dataItem['fld_' + item.Id + '_xp_allow_edit'] == 0) {
            return;
        }

        let value = null;

        if ($("#" + item.UniqueClientId).data('kendoNumericTextBox').value() != null) {
            value = $("#" + item.UniqueClientId).data('kendoNumericTextBox').value();
        }

        this.saveDataItem.values['fld_' + item.Id] = value;
    }

    _storeNumericTextBoxData(item) {
        if (item.IsReadOnly || $("#" + item.UniqueClientId).attr('persisted') == 'false' || this.dataItem['fld_' + item.Id + '_xp_allow_view'] == 0 || this.dataItem['fld_' + item.Id + '_xp_allow_edit'] == 0) {
            return;
        }

        let value = null;

        if ($("#" + item.UniqueClientId).data('kendoNumericTextBox').value() != null) {
            value = $("#" + item.UniqueClientId).data('kendoNumericTextBox').value();
        }

        this.saveDataItem.values['fld_' + item.Id] = value;
    }

    _storeRichTextData(item) {
        if (item.IsReadOnly || $("#" + item.UniqueClientId).attr('persisted') == 'false' || this.dataItem['fld_' + item.Id + '_xp_allow_view'] == 0 || this.dataItem['fld_' + item.Id + '_xp_allow_edit'] == 0) {
            return;
        }

        let value = null;

        if ($("#" + item.UniqueClientId).data('kendoEditor').value() != null) {
            value = $("#" + item.UniqueClientId).data('kendoEditor').value();
        }

        this.saveDataItem.values['fld_' + item.Id] = value;
    }

    _storeTextBoxData(item) {
        if (item.IsReadOnly || $("#" + item.UniqueClientId).attr('persisted') == 'false' || this.dataItem['fld_' + item.Id + '_xp_allow_view'] == 0 || this.dataItem['fld_' + item.Id + '_xp_allow_edit'] == 0) {
            return;
        }

        let value = null;

        if ($("#" + item.UniqueClientId).val() != null && $("#" + item.UniqueClientId).val() != '') {
            value = $("#" + item.UniqueClientId).val();
        }

        this.saveDataItem.values['fld_' + item.Id] = value;
    }

    _storeGeomPickerModalMapControl(item) {
        if (item.IsReadOnly || $("#" + item.UniqueClientId).attr('persisted') == 'false' || this.dataItem['fld_' + item.Id + '_xp_allow_view'] == 0 || this.dataItem['fld_' + item.Id + '_xp_allow_edit'] == 0) {
            return;
        }

        let value = null;

        if ($("#" + item.UniqueClientId).val() != null && $("#" + item.UniqueClientId).val() != '') {
            value = $("#" + item.UniqueClientId).val();
        }

        this.saveDataItem.values['fld_' + item.Id] = value;
    }

    _storeGeomPickerMapViewControl(item) {
        if (item.IsReadOnly || $("#" + item.UniqueClientId).attr('persisted') == 'false' || this.dataItem['fld_' + item.Id + '_xp_allow_view'] == 0 || this.dataItem['fld_' + item.Id + '_xp_allow_edit'] == 0) {
            return;
        }

        let value = $("#" + item.UniqueClientId).attr('current-value');

        if (value != null) {
            this.saveDataItem.values['fld_' + item.Id] = value;
        }
    }


    _storeTextAreaData(item) {
        if (item.IsReadOnly || $("#" + item.UniqueClientId).attr('persisted') == 'false' || this.dataItem['fld_' + item.Id + '_xp_allow_view'] == 0 || this.dataItem['fld_' + item.Id + '_xp_allow_edit'] == 0) {
            return;
        }

        let value = null;

        if ($("#" + item.UniqueClientId).val() != null && $("#" + item.UniqueClientId).val() != '') {
            value = $("#" + item.UniqueClientId).val();
        }

        this.saveDataItem.values['fld_' + item.Id] = value;
    }

    _storeDateTimePickerData(item) {
        if (item.IsReadOnly || $("#" + item.UniqueClientId).attr('persisted') == 'false' || this.dataItem['fld_' + item.Id + '_xp_allow_view'] == 0 || this.dataItem['fld_' + item.Id + '_xp_allow_edit'] == 0) {
            return;
        }

        let value = null;

        if ($("#" + item.UniqueClientId).data('kendoDateTimePicker').value() != null && $("#" + item.UniqueClientId).data('kendoDateTimePicker').value() != '') {
            value = this._serializeDateTime($("#" + item.UniqueClientId).data('kendoDateTimePicker').value());
        }

        this.saveDataItem.values['fld_' + item.Id] = value;
    }

    _serializeDate(date) {
        if (date != null) {
            let result = date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate();
            return result;
        }

        return null;
    }

    _serializeDateTime(date) {
        if (date != null) {
            let result = date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate() + "-" + date.getHours() + "-" + date.getMinutes() + "-" + date.getSeconds();
            return result;
        }

        return null;
    }

    _deserializeDate(date) {
        if (date == null || date == '') {
            return null;
        }
        else {
            var tuples = date.split("-");
            var result = new Date(tuples[0], tuples[1] - 1, tuples[2]);
            return result;
        }
    }

    _deserializeDateTime(date) {
        if (date == null || date == '') {
            return null;
        }
        else {
            var tuples = date.split("-");
            var result = new Date(tuples[0], tuples[1] - 1, tuples[2], tuples[3], tuples[4], tuples[5]);
            return result;
        }
    }

    _storeSwitchData(item) {
        if (item.IsReadOnly || $("#" + item.UniqueClientId).attr('persisted') == 'false' || this.dataItem['fld_' + item.Id + '_xp_allow_view'] == 0 || this.dataItem['fld_' + item.Id + '_xp_allow_edit'] == 0) {
            return;
        }

        if (item.EntityField && item.EntityField.DataType == 'INTEGER') {
            let value = 0;
            var switchValue = this._threeStateSwitchGetValue("#" + item.UniqueClientId);
            if (switchValue === null) {
                if (!item.NotNull) {
                    value = null;
                }                
            }
            else if (switchValue === true) {
                value = 1;
            }
            this.saveDataItem.values['fld_' + item.Id] = value;
        } else if (item.EntityField && item.EntityField.DataType == 'BOOLEAN') {
            let value = false;

            var switchValue = this._threeStateSwitchGetValue("#" + item.UniqueClientId);
            if (switchValue === null) {
                if (!item.NotNull) {
                    value = null;
                }                
            }
            else if (switchValue === true) {
                value = true;
            }

            this.saveDataItem.values['fld_' + item.Id] = value;
        } else if (item.EntityField && item.EntityField.DataType == 'BOOLINT') {
            let value = 0;

            var switchValue = this._threeStateSwitchGetValue("#" + item.UniqueClientId);
            if (switchValue === null) {
                if (!item.NotNull) {
                    value = null;
                }
            }
            else if (switchValue === true) {
                value = 1;
            }

            this.saveDataItem.values['fld_' + item.Id] = value;
        }
    }

    _storeMultiSelectData(item) {
        if (item.IsReadOnly || $("#" + item.UniqueClientId).attr('persisted') == 'false' || this.dataItem['fld_' + item.Id + '_xp_allow_view'] == 0 || this.dataItem['fld_' + item.Id + '_xp_allow_edit'] == 0) {
            return;
        }

        let value = $("#" + item.UniqueClientId).data('kendoMultiSelect').value().filter(v => v !== '');

        if (value != null && value.length > 0) {
            this.saveDataItem.values['fld_' + item.Id] = value;
        } else {
            this.saveDataItem.values['fld_' + item.Id] = null;
        }
    }

    _storeDropDownTreeData(item) {
        if (item.IsReadOnly || $("#" + item.UniqueClientId).attr('persisted') == 'false' || this.dataItem['fld_' + item.Id + '_xp_allow_view'] == 0 || this.dataItem['fld_' + item.Id + '_xp_allow_edit'] == 0) {
            return;
        }

        let value = $("#" + item.UniqueClientId).data('kendoDropDownTree').value();

        if (value != null) {
            this.saveDataItem.values['fld_' + item.Id] = value;
        }
    }

    _storeComboBoxData(item) {
        if (item.IsReadOnly || $("#" + item.UniqueClientId).attr('persisted') == 'false' || this.dataItem['fld_' + item.Id + '_xp_allow_view'] == 0 || this.dataItem['fld_' + item.Id + '_xp_allow_edit'] == 0) {
            return;
        }

        let value = $("#" + item.UniqueClientId).data('kendoComboBox').value();

        if (value != null) {
            this.saveDataItem.values['fld_' + item.Id] = value;
        }
    }

    _storeComboBoxListViewData(item) {
        if (item.IsReadOnly || $("#" + item.UniqueClientId).attr('persisted') == 'false' || this.dataItem['fld_' + item.Id + '_xp_allow_view'] == 0 || this.dataItem['fld_' + item.Id + '_xp_allow_edit'] == 0) {
            return;
        }

        let value = $("#" + item.UniqueClientId).attr('current-value');

        if (value != null) {
            this.saveDataItem.values['fld_' + item.Id] = value;
        }
    }

    _storeFileData(item) {
        if (item.IsReadOnly || $("#" + item.UniqueClientId).attr('persisted') == 'false' || this.dataItem['fld_' + item.Id + '_xp_allow_view'] == 0 || this.dataItem['fld_' + item.Id + '_xp_allow_edit'] == 0) {
            return;
        }

        if (this.uploadedFiles[item.UniqueClientId] != null) {
            if (this.uploadedFiles[item.UniqueClientId].uploadedFileAdded) {
                if (this.uploadedFiles[item.UniqueClientId].file != null) {
                    this.saveDataItem.values['fld_' + item.Id] = true;
                    this.saveDataItem.values['fld_' + item.Id + '_dzIdentifier'] = this.uploadedFiles[item.UniqueClientId].file.upload.uuid;
                    this.saveDataItem.values['fld_' + item.Id + '_xp_fileName'] = this.uploadedFiles[item.UniqueClientId].file.name;
                    this.saveDataItem.values['fld_' + item.Id + '_xp_mimeType'] = this.uploadedFiles[item.UniqueClientId].file.type;
                }
            } else {
                this.saveDataItem.values['fld_' + item.Id] = false;
            }
        } else {
            this.saveDataItem.values['fld_' + item.Id] = null;
        }
    }

    _populateData(item) {
        if (item != null) {
            this.allowEdit = item.xp_allow_edit != null && item.xp_allow_edit == '1';
            this.allowDelete = item.xp_allow_del != null && item.xp_allow_del == '1';

            this.dataItem = item;
            this._populateItem(this.metadata, false);
        }
    }

    _populateItem(item, ignoreComplex) {
        if (item.TypeName == 'UIFieldControlDto' || item.TypeName == 'UICustomFieldControlDto') {
            if (item.CtlType != null) {
                switch (item.CtlType) {
                    case 'Switch': this._populateSwitchControl(item);
                        break;
                    case 'IntegerTextBox': this._populateIntegerTextBoxControl(item);
                        break;
                    case 'DatePicker': this._populateDatePickerControl(item);
                        break;
                    case 'NumericTextBox': this._populateNumericTextBoxControl(item);
                        break;
                    case 'TextBox': this._populateTextBoxControl(item);
                        break;
                    case 'TextArea': this._populateTextAreaControl(item);
                        break;
                    case 'RichText': this._populateRichTextControl(item);
                        break;
                    case 'DateTimePicker': this._populateDateTimePickerControl(item);
                        break;
                    case 'ComboBox': {
                        switch (this._getFieldControlSubType(item)) {
                            case 'ListView': this._populateComboBoxListViewControl(item);
                                break;
                            case 'MultiSelect': this._populateMultiSelectControl(item);
                                break;
                            case 'TreeView': this._populateDropDownTreeControl(item);
                                break;
                            default: this._populateComboBoxControl(item);
                                break;
                        }
                    }
                        break;
                    case 'GeomPicker': {
                        switch (this._getFieldControlSubType(item)) {
                            case 'ModalMap': this._populateGeomPickerModalMapControl(item);
                                break;
                            case 'MapView': this._populateGeomPickerMapViewControl(item);
                                break;
                        }
                    }
                        break;
                    case 'File': this._populateFileControl(item);
                        break;
                    default: break;
                }
            }
        }

        if (item.TypeName == 'UISublistDto') {
            if ((this.isPreview && item.IdList != null) || (!this.isPreview && this.objectId != null && this.objectId != 'null' && this.objectId != 0 && item.IdList != null)) {
                if (!item.isLoaded) {
                    this._initSublistControl(item, ignoreComplex);
                    item.isLoaded = !ignoreComplex;
                }
            }
        }

        if (!this.isPreview) {
            this._checkItemReadonly(item);
        }

        if (item.Items != null && item.Items.length > 0) {
            for (let i = 0; i < item.Items.length; i++) {
                let child = item.Items[i];
                this._populateItem(child, (item.TypeName == 'UITabControlDto' && i > 0 ? true : ignoreComplex));
            }
        }
    }

    _populateDatePickerControl(item) {
        if ((this.dataItem['fld_' + item.Id + '_xp_allow_view'] == null || this.dataItem['fld_' + item.Id + '_xp_allow_view'] == 1) && !item.Hidden) {
            $('#' + item.UniqueClientId + '-wrapper').show();
        }

        if ((!this.allowEdit || this.dataItem['fld_' + item.Id + '_xp_allow_edit'] == 0) && !this.isFilter) {
            $("#" + item.UniqueClientId).data("kendoDatePicker").readonly(true);
        }

        if (item.TypeName == 'UICustomFieldControlDto' && item.IdXpCommandSave == null) {
            $("#" + item.UniqueClientId).data("kendoDatePicker").readonly(true);
        }

        if (this._isEligibleForValidation(item)) {
            $("#" + item.UniqueClientId).data("kendoDatePicker").bind('change', (e) => {
                if (e.sender.value() == null) {
                    this._decorateField(item, false);
                } else {
                    this._decorateField(item, true);
                }
            });
        }
    }

    _populateIntegerTextBoxControl(item) {
        if (this.dataItem['fld_' + item.Id] != null) {
            $("#" + item.UniqueClientId).data('kendoNumericTextBox').value(this.dataItem['fld_' + item.Id]);
        }

        if ((this.dataItem['fld_' + item.Id + '_xp_allow_view'] == null || this.dataItem['fld_' + item.Id + '_xp_allow_view'] == 1) && !item.Hidden) {
            $('#' + item.UniqueClientId + '-wrapper').show();
        }

        if ((!this.allowEdit || this.dataItem['fld_' + item.Id + '_xp_allow_edit'] == 0) && !this.isFilter) {
            $("#" + item.UniqueClientId).data("kendoNumericTextBox").readonly(true);
        }

        if (item.TypeName == 'UICustomFieldControlDto' && item.IdXpCommandSave == null) {
            $("#" + item.UniqueClientId).data("kendoNumericTextBox").readonly(true);
        }

        if (this._isEligibleForValidation(item)) {
            $("#" + item.UniqueClientId).data("kendoNumericTextBox").bind('change', (e) => {
                if (e.sender.value() == null) {
                    this._decorateField(item, false);
                } else {
                    this._decorateField(item, true);
                }
            });
        }

        $("#" + item.UniqueClientId).data("kendoNumericTextBox").bind('change', (e) => {
            let dependants = this._getDependants(item.Guid);

            if (dependants != null && dependants.length > 0) {
                this._handleItemsState(dependants);

                let cascadedDependants = [];

                dependants.forEach(dependant => {
                    if (dependant.SqlWhere != null && dependant.SqlWhere != '' && dependant.SqlWhere.indexOf(item.EntityField.FieldName) >= 0) {
                        cascadedDependants.push(dependant);
                    }
                });

                this._handleCascadedItems(cascadedDependants);
            }

            //self check
            this._checkItemValidity(item);
        });
    }

    _isEligibleForValidation(item) {
        let result = item.NotNull || (item.EntityField != null && item.EntityField.NotNull && !this.isFilter);

        if (!((this.dataItem['fld_' + item.Id + '_xp_allow_view'] == null || this.dataItem['fld_' + item.Id + '_xp_allow_view'] == 1) && !item.Hidden)) {
            result = false;
        }

        if ((!this.allowEdit || this.dataItem['fld_' + item.Id + '_xp_allow_edit'] == 0) && !this.isFilter) {
            result = false;
        }

        return result;
    }

    _populateNumericTextBoxControl(item) {
        if (this.dataItem['fld_' + item.Id] != null) {
            $("#" + item.UniqueClientId).data('kendoNumericTextBox').value(this.dataItem['fld_' + item.Id]);
        }

        if ((this.dataItem['fld_' + item.Id + '_xp_allow_view'] == null || this.dataItem['fld_' + item.Id + '_xp_allow_view'] == 1) && !item.Hidden) {
            $('#' + item.UniqueClientId + '-wrapper').show();
        }

        if ((!this.allowEdit || this.dataItem['fld_' + item.Id + '_xp_allow_edit'] == 0) && !this.isFilter) {
            $("#" + item.UniqueClientId).data("kendoNumericTextBox").readonly(true);
        }

        if (item.TypeName == 'UICustomFieldControlDto' && item.IdXpCommandSave == null) {
            $("#" + item.UniqueClientId).data("kendoNumericTextBox").readonly(true);
        }

        if (this._isEligibleForValidation(item)) {
            $("#" + item.UniqueClientId).data("kendoNumericTextBox").bind('change', (e) => {
                if (e.sender.value() == null) {
                    this._decorateField(item, false);
                } else {
                    this._decorateField(item, true);
                }
            });
        }

        $("#" + item.UniqueClientId).data("kendoNumericTextBox").bind('change', (e) => {
            let dependants = this._getDependants(item.Guid);

            if (dependants != null && dependants.length > 0) {
                this._handleItemsState(dependants);

                let cascadedDependants = [];

                dependants.forEach(dependant => {
                    if (dependant.SqlWhere != null && dependant.SqlWhere != '' && dependant.SqlWhere.indexOf(item.EntityField.FieldName) >= 0) {
                        cascadedDependants.push(dependant);
                    }
                });

                this._handleCascadedItems(cascadedDependants);
            }

            //self check
            this._checkItemValidity(item);
        });
    }

    _populateRichTextControl(item) {
        if (this.dataItem['fld_' + item.Id] != null) {
            $("#" + item.UniqueClientId).data('kendoEditor').value(this.dataItem['fld_' + item.Id]);
        }

        if ((this.dataItem['fld_' + item.Id + '_xp_allow_view'] == null || this.dataItem['fld_' + item.Id + '_xp_allow_view'] == 1) && !item.Hidden) {
            $('#' + item.UniqueClientId + '-wrapper').show();
        }

        if ((!this.allowEdit || this.dataItem['fld_' + item.Id + '_xp_allow_edit'] == 0) && !this.isFilter) {
            $("#" + item.UniqueClientId).data("kendoEditor").readonly(true);
        }

        if (item.TypeName == 'UICustomFieldControlDto' && item.IdXpCommandSave == null) {
            $("#" + item.UniqueClientId).data("kendoEditor").readonly(true);
        }

        if (this._isEligibleForValidation(item)) {
            $("#" + item.UniqueClientId).data("kendoEditor").bind('change', (e) => {
                if (e.sender.value() == null) {
                    this._decorateField(item, false);
                } else {
                    this._decorateField(item, true);
                }
            });
        }
    }

    _populateTextBoxControl(item) {
        if (this.dataItem['fld_' + item.Id] != null) {
            $("#" + item.UniqueClientId).val(this.dataItem['fld_' + item.Id]);
        }

        if ((this.dataItem['fld_' + item.Id + '_xp_allow_view'] == null || this.dataItem['fld_' + item.Id + '_xp_allow_view'] == 1) && !item.Hidden) {
            $('#' + item.UniqueClientId + '-wrapper').show();
        }

        if ((!this.allowEdit || this.dataItem['fld_' + item.Id + '_xp_allow_edit'] == 0) && !this.isFilter) {
            $("#" + item.UniqueClientId).attr('readonly', true);
        }

        if (item.TypeName == 'UICustomFieldControlDto' && item.IdXpCommandSave == null) {
            $("#" + item.UniqueClientId).attr('readonly', true);
        }

        if (this._isEligibleForValidation(item)) {
            $("#" + item.UniqueClientId).on('keyup', (e) => {
                if ($("#" + item.UniqueClientId).val() == '') {
                    this._decorateField(item, false);
                } else {
                    this._decorateField(item, true);
                }
            });
        }

        $("#" + item.UniqueClientId).on('focusout', () => {
            let dependants = this._getDependants(item.Guid);

            if (dependants != null && dependants.length > 0) {
                this._handleItemsState(dependants);

                let cascadedDependants = [];

                dependants.forEach(dependant => {
                    if (dependant.SqlWhere != null && dependant.SqlWhere != '' && dependant.SqlWhere.indexOf(item.EntityField.FieldName) >= 0) {
                        cascadedDependants.push(dependant);
                    }
                });

                this._handleCascadedItems(cascadedDependants);
            }

            //self check
            this._checkItemValidity(item);
        });
    }

    _populateGeomPickerModalMapControl(item) {
        if (this.dataItem['fld_' + item.Id] != null) {
            $("#" + item.UniqueClientId).val(this.dataItem['fld_' + item.Id]);
        }

        if ((this.dataItem['fld_' + item.Id + '_xp_allow_view'] == null || this.dataItem['fld_' + item.Id + '_xp_allow_view'] == 1) && !item.Hidden) {
            $('#' + item.UniqueClientId + '-wrapper').show();
        }

        if ((!this.allowEdit || this.dataItem['fld_' + item.Id + '_xp_allow_edit'] == 0) && !this.isFilter) {
            $("#" + item.UniqueClientId).attr('readonly', true);
        }

        if (item.TypeName == 'UICustomFieldControlDto' && item.IdXpCommandSave == null) {
            $("#" + item.UniqueClientId).attr('readonly', true);
        }

        if (this._isEligibleForValidation(item)) {
            $("#" + item.UniqueClientId).on('keyup', (e) => {
                if ($("#" + item.UniqueClientId).val() == '') {
                    this._decorateField(item, false);
                } else {
                    this._decorateField(item, true);
                }
            });
        }

        $("#" + item.UniqueClientId).on('focusout', () => {
            let dependants = this._getDependants(item.Guid);

            if (dependants != null && dependants.length > 0) {
                this._handleItemsState(dependants);

                let cascadedDependants = [];

                dependants.forEach(dependant => {
                    if (dependant.SqlWhere != null && dependant.SqlWhere != '' && dependant.SqlWhere.indexOf(item.EntityField.FieldName) >= 0) {
                        cascadedDependants.push(dependant);
                    }
                });

                this._handleCascadedItems(cascadedDependants);
            }

            //self check
            this._checkItemValidity(item);
        });
    }

    _populateGeomPickerMapViewControl(item) {
        if (this.dataItem['fld_' + item.Id] != null) {
            $("#" + item.UniqueClientId).attr('current-value', this.dataItem['fld_' + item.Id]);
            this._populateMap($("#" + item.UniqueClientId)[0].mapControl, item);
        }

        if ((this.dataItem['fld_' + item.Id + '_xp_allow_view'] == null || this.dataItem['fld_' + item.Id + '_xp_allow_view'] == 1) && !item.Hidden) {
            $('#' + item.UniqueClientId + '-wrapper').show();
        }
    }

    _populateMap(mapControl, item) {
        if (mapControl.isLoaded) {
            let feature = {};
            feature['id'] = this.objectId;

            let value = '';

            if (item.CtlProps.CtlSubType == 'ModalMap') {
                value = $("#" + item.UniqueClientId).val();
            } else {
                value = $("#" + item.UniqueClientId).attr('current-value');
            }

            feature[item.EntityField.FieldName] = value;
            mapControl.addTemporaryFeatures(item.Name, [feature], formats.WKT, true, true);

            //if (value == null || value.trim() == '') {
            $event.notify(eventTypes.TEMPORARY_LAYER_SELECTION_CHANGED, { features: null, layerSettings: mapControl.layerHandler.getLayerById(item.Name)[0].get('temporarySettings'), isNew: true }, this, item.IdMap + '-' + item.Id);
            //}

            if (window['onFormMapStarted' + this.pageGuid] != null && !this.isPreview) {
                window['onFormMapStarted' + this.pageGuid](mapControl, item);
            }
        } else {
            setTimeout(() => {
                this._populateMap(mapControl, item);
            }, 100);
        }
    }

    _populateTextAreaControl(item) {
        if (this.dataItem['fld_' + item.Id] != null) {
            $("#" + item.UniqueClientId).val(this.dataItem['fld_' + item.Id]);
        }

        if ((this.dataItem['fld_' + item.Id + '_xp_allow_view'] == null || this.dataItem['fld_' + item.Id + '_xp_allow_view'] == 1) && !item.Hidden) {
            $('#' + item.UniqueClientId + '-wrapper').show();
        }

        if ((!this.allowEdit || this.dataItem['fld_' + item.Id + '_xp_allow_edit'] == 0) && !this.isFilter) {
            $("#" + item.UniqueClientId).attr('readonly', true);
        }

        if (item.TypeName == 'UICustomFieldControlDto' && item.IdXpCommandSave == null) {
            $("#" + item.UniqueClientId).attr('readonly', true);
        }

        if (this._isEligibleForValidation(item)) {
            $("#" + item.UniqueClientId).on('keyup', (e) => {
                if ($("#" + item.UniqueClientId).val() == '') {
                    this._decorateField(item, false);
                } else {
                    this._decorateField(item, true);
                }
            });
        }

        $("#" + item.UniqueClientId).on('focusout', () => {
            let dependants = this._getDependants(item.Guid);

            if (dependants != null && dependants.length > 0) {
                this._handleItemsState(dependants);

                let cascadedDependants = [];

                dependants.forEach(dependant => {
                    if (dependant.SqlWhere != null && dependant.SqlWhere != '' && dependant.SqlWhere.indexOf(item.EntityField.FieldName) >= 0) {
                        cascadedDependants.push(dependant);
                    }
                });

                this._handleCascadedItems(cascadedDependants);
            }

            //self check
            this._checkItemValidity(item);
        });
    }

    _populateDateTimePickerControl(item) {
        if ((this.dataItem['fld_' + item.Id + '_xp_allow_view'] == null || this.dataItem['fld_' + item.Id + '_xp_allow_view'] == 1) && !item.Hidden) {
            $('#' + item.UniqueClientId + '-wrapper').show();
        }

        if ((!this.allowEdit || this.dataItem['fld_' + item.Id + '_xp_allow_edit'] == 0) && !this.isFilter) {
            $("#" + item.UniqueClientId).data("kendoDateTimePicker").readonly(true);
        }

        if (item.TypeName == 'UICustomFieldControlDto' && item.IdXpCommandSave == null) {
            $("#" + item.UniqueClientId).data("kendoDateTimePicker").readonly(true);
        }

        if (this._isEligibleForValidation(item)) {
            $("#" + item.UniqueClientId).data("kendoDateTimePicker").bind('change', (e) => {
                if (e.sender.value() == null) {
                    this._decorateField(item, false);
                } else {
                    this._decorateField(item, true);
                }
            });
        }
    }

    _populateSwitchControl(item) {
        var switchValue = this._parseBooleanCommandResult(this.dataItem['fld_' + item.Id]);

        this._threeStateSwitchSetValue("#" + item.UniqueClientId, switchValue);

        if ((this.dataItem['fld_' + item.Id + '_xp_allow_view'] == null || this.dataItem['fld_' + item.Id + '_xp_allow_view'] == 1) && !item.Hidden) {
            $('#' + item.UniqueClientId + '-wrapper').show();
        }

        if ((!this.allowEdit || this.dataItem['fld_' + item.Id + '_xp_allow_edit'] == 0) && !this.isFilter) {
            $("#" + item.UniqueClientId).data('kendoSwitch').readonly(true);
        }

        if (item.TypeName == 'UICustomFieldControlDto' && item.IdXpCommandSave == null) {
            $("#" + item.UniqueClientId).data('kendoSwitch').readonly(true);
        }

        let dependants = this._getDependants(item.Guid);

        if (dependants != null && dependants.length > 0) {
            this._handleItemsState(dependants);
        }
    }

    _populateMultiSelectControl(item) {
        if (this.dataItem['fld_' + item.Id] != null) {
            if (this.allowEdit && !item.IsReadOnly) {
                $("#" + item.UniqueClientId).data("kendoMultiSelect").readonly(false);
            }

            let dependants = this._getDependants(item.Guid);

            if (dependants != null && dependants.length > 0) {
                this._handleItemsState(dependants);
            }
        }

        if ((this.dataItem['fld_' + item.Id + '_xp_allow_view'] == null || this.dataItem['fld_' + item.Id + '_xp_allow_view'] == 1) && !item.Hidden) {
            $('#' + item.UniqueClientId + '-wrapper').show();
        }

        if ((!this.allowEdit || this.dataItem['fld_' + item.Id + '_xp_allow_edit'] == 0 || item.IsReadOnly) && !this.isFilter) {
            $("#" + item.UniqueClientId).data("kendoMultiSelect").readonly(true);
        }

        if (item.TypeName == 'UICustomFieldControlDto' && item.IdXpCommandLoad != null && item.IdXpCommandSave == null) {
            $("#" + item.UniqueClientId).data("kendoMultiSelect").readonly(true);
        }

        if (this._isEligibleForValidation(item)) {
            $("#" + item.UniqueClientId).data("kendoMultiSelect").bind('change', (e) => {
                if (e.sender.value() == null || e.sender.value().trim() == '') {
                    this._decorateField(item, false);
                } else {
                    this._decorateField(item, true);
                }
            });
        }
    }

    _populateDropDownTreeControl(item) {
        if (this.dataItem['fld_' + item.Id] != null) {
            if (this.allowEdit && !item.IsReadOnly) {
                $("#" + item.UniqueClientId).data("kendoDropDownTree").readonly(false);
                $('#' + item.UniqueClientId).parent().removeClass('isReadonly');
            }

            let dependants = this._getDependants(item.Guid);

            if (dependants != null && dependants.length > 0) {
                this._handleItemsState(dependants);
            }
        }

        if ((this.dataItem['fld_' + item.Id + '_xp_allow_view'] == null || this.dataItem['fld_' + item.Id + '_xp_allow_view'] == 1) && !item.Hidden) {
            $('#' + item.UniqueClientId + '-wrapper').show();
        }

        if ((!this.allowEdit || this.dataItem['fld_' + item.Id + '_xp_allow_edit'] == 0 || item.IsReadOnly) && !this.isFilter) {
            $("#" + item.UniqueClientId).data("kendoDropDownTree").readonly(true);
            $('#' + item.UniqueClientId).parent().addClass('isReadonly');
        }

        if (item.TypeName == 'UICustomFieldControlDto' && item.IdXpCommandSave == null) {
            $("#" + item.UniqueClientId).data("kendoDropDownTree").readonly(true);
            $('#' + item.UniqueClientId).parent().addClass('isReadonly');
        }

        if (this._isEligibleForValidation(item)) {
            $("#" + item.UniqueClientId).data("kendoDropDownTree").bind('change', (e) => {
                if (e.sender.value() == null || e.sender.value().trim() == '') {
                    this._decorateField(item, false);
                } else {
                    this._decorateField(item, true);
                }
            });
        }
    }

    _populateComboBoxControl(item) {
        if (this.dataItem['fld_' + item.Id] != null) {
            if (this.allowEdit && !item.IsReadOnly) {
                $("#" + item.UniqueClientId).data("kendoComboBox").readonly(false);
            }

            let dependants = this._getDependants(item.Guid);

            if (dependants != null && dependants.length > 0) {
                this._handleItemsState(dependants);
            }
        }

        if ((this.dataItem['fld_' + item.Id + '_xp_allow_view'] == null || this.dataItem['fld_' + item.Id + '_xp_allow_view'] == 1) && !item.Hidden) {
            $('#' + item.UniqueClientId + '-wrapper').show();
        }

        if ((!this.allowEdit || this.dataItem['fld_' + item.Id + '_xp_allow_edit'] == 0 || item.IsReadOnly) && !this.isFilter) {
            $("#" + item.UniqueClientId).data("kendoComboBox").readonly(true);
        }

        if (item.TypeName == 'UICustomFieldControlDto' && item.IdXpCommandSave == null) {
            $("#" + item.UniqueClientId).data("kendoComboBox").readonly(true);
        }

        if (this._isEligibleForValidation(item)) {
            $("#" + item.UniqueClientId).data("kendoComboBox").bind('change', (e) => {
                if (e.sender.value() == null || e.sender.value().trim() == '') {
                    this._decorateField(item, false);
                } else {
                    this._decorateField(item, true);
                }
            });
        }
    }

    _populateComboBoxListViewControl(item) {
        if (this.dataItem['fld_' + item.Id] != null) {
            $("#" + item.UniqueClientId).attr('current-value', this.dataItem['fld_' + item.Id]);
            let listViewDataSourceUrl = rootUrl + 'Entity/GetFieldSource?idField=' + item.Id + '&fkVal=' + this.dataItem['fld_' + item.Id];
            if (this.idExtConn != null) {
                listViewDataSourceUrl += "&idExtConn=" + this.idExtConn;
            }

            $.ajax({
                type: "GET",
                url: listViewDataSourceUrl,
                contentType: "application/json; charset=utf-8",
                async: true,
                success: (result) => {
                    if (result != null && result.length > 0) {
                        let currentValue = result.filter((row) => {
                            return row.Id == this.dataItem['fld_' + item.Id];
                        });

                        if (currentValue != null & currentValue.length > 0) {
                            $("#" + item.UniqueClientId).attr('current-value', currentValue[0].Id);
                            $('#' + item.UniqueClientId + '-img img').attr('src', rootUrl + 'Entity/GetFileContent?idEntityField=' + currentValue[0].Attr[1] + '&pkVal=' + currentValue[0].Id);
                            $('#' + item.UniqueClientId + '-img .list-view-selection-title')[0].innerHTML = currentValue[0].Name;
                            $('#' + item.UniqueClientId + '-img .list-view-selection-description')[0].innerHTML = currentValue[0].Attr[0];
                            $('#' + item.UniqueClientId + '-img').addClass('d-flex');
                            $('#' + item.UniqueClientId + '-placeholder').removeClass('d-flex');
                            $('#' + item.UniqueClientId + '-placeholder').hide();
                        }
                    }
                },
                error: (e) => {
                    toastr.error(e.responseText, this._getResource('GetFieldSourceError'));
                }
            });

            let dependants = this._getDependants(item.Guid);

            if (dependants != null && dependants.length > 0) {
                this._handleItemsState(dependants);
            }
        }

        if ((this.dataItem['fld_' + item.Id + '_xp_allow_view'] == null || this.dataItem['fld_' + item.Id + '_xp_allow_view'] == 1) && !item.Hidden) {
            $('#' + item.UniqueClientId + '-wrapper').show();
        }

        if ((!this.allowEdit || this.dataItem['fld_' + item.Id + '_xp_allow_edit'] == 0) && !this.isFilter) {
            $('#' + item.UniqueClientId).addClass('disabled-control');
        }

        if (item.IsReadOnly) {
            $("#" + item.UniqueClientId).addClass('disabled-control');
        }

        if (item.TypeName == 'UICustomFieldControlDto' && item.IdXpCommandSave == null) {
            $("#" + item.UniqueClientId).addClass('disabled-control');
        }

        $("#" + item.UniqueClientId).on('click', (evt) => {
            this._initComboBoxListViewControl(item);
        });
    }

    _initComboBoxListViewControl(item) {
        this.initModal(item.Label, '70%', null, false, null, true);

        $('#' + this.uniqueModalInnerId).append('<div class="col-8 d-flex" style="margin: 0 auto;"><input id="list-view-search" placeholder="' + this._getResource('Search') + '" type="text" class="form-control mb-3" style="border-top-right-radius: 0 !important; border-bottom-right-radius: 0 !important;"/><span class="fal fa-search btn btn-primary" style="height: 2.3rem; line-height: 1.5rem; font-size: 1.1rem; border-top-left-radius: 0 !important; border-bottom-left-radius: 0 !important;"></span></div><div id="' + this.comboBoxSelectView + '" style="display: grid; grid-template-columns: auto auto; border: none; min-height: calc(100% - 3.5rem);"></div>');

        $("#" + this.comboBoxSelectView).kendoListView({
            dataSource: {
                serverFiltering: false,
                transport: {
                    read: {
                        dataType: 'json',
                        url: () => {
                            return rootURL + 'Entity/GetFieldSource?idField=' + item.Id + '&idExtConn=' + this.idExtConn;
                        }
                    }
                }
            },
            height: 350,
            layout: "grid",
            grid: {
                cols: 2,
            },
            scrollable: "endless",
            template: (item) => {
                return `<div class="list-view-item" data-id="` + item.Id + `" data-entity-field="` + item.Attr[1] + `" data-title="` + item.Name + `" data-description="` + item.Attr[0] + `" style="height: 400px; padding: 1.5rem; cursor: pointer;">
                    <div class="list-view-item-label" style="height: 2rem; font-size: 1rem; font-family: roboto; font-weight: 500; color: #666666;display: flex; align-content: center; flex-wrap: wrap; justify-content: center;">` + item.Name + `</div>
                    <div class="list-view-item-label" style="height: 2rem; font-family: roboto; color: #666666;display: flex; align-content: center; flex-wrap: wrap; justify-content: center;">` + item.Attr[0] + `</div>
                    <div style="height: calc(100% - 4rem); display: flex; justify-content: center;">
                        <img src="` + (rootUrl + 'Entity/GetFileContent?idEntityField=' + item.Attr[1] + '&pkVal=' + item.Id) + `"></img>
                    </div>
                </div>`;
            },
            dataBound: () => {
                $('.list-view-item').on('click', (evt) => {
                    let selectedId = evt.currentTarget.getAttribute('data-id');
                    let selectedIdEntityField = evt.currentTarget.getAttribute('data-entity-field');
                    let selectedTitle = evt.currentTarget.getAttribute('data-title');
                    let selectedDescription = evt.currentTarget.getAttribute('data-description');
                    this.closeModal(true);
                    $("#" + item.UniqueClientId).attr('current-value', selectedId);
                    $('#' + item.UniqueClientId + '-img img').attr('src', rootUrl + 'Entity/GetFileContent?idEntityField=' + selectedIdEntityField + '&pkVal=' + selectedId);
                    $('#' + item.UniqueClientId + '-img').addClass('d-flex');
                    $('#' + item.UniqueClientId + '-placeholder').removeClass('d-flex');
                    $('#' + item.UniqueClientId + '-placeholder').hide();
                    $('#' + item.UniqueClientId + '-img .list-view-selection-title')[0].innerHTML = selectedTitle;
                    $('#' + item.UniqueClientId + '-img .list-view-selection-description')[0].innerHTML = selectedDescription;

                    let dependants = this._getDependants(item.Guid);

                    if (dependants != null && dependants.length > 0) {
                        this._handleItemsState(dependants);

                        let cascadedDependants = [];

                        dependants.forEach(dependant => {
                            if (dependant.SqlWhere != null && dependant.SqlWhere != '' && dependant.SqlWhere.indexOf(item.EntityField.FieldName) >= 0) {
                                cascadedDependants.push(dependant);
                            }
                        });

                        this._handleCascadedItems(cascadedDependants);
                    }

                    this._checkItemValidity(item);
                });
            }
        });

        $('#list-view-search').on('keyup', () => {
            let criteria = $('#list-view-search').val();

            let choices = $('.list-view-item');
            for (let i = 0; i < choices.length; i++) {
                let choice = $(choices[i]);
                let title = choice.attr('data-title');
                let description = choice.attr('data-description');


                if (title.toLowerCase().indexOf(criteria.toLowerCase()) >= 0 || description.toLowerCase().indexOf(criteria.toLowerCase()) >= 0) {
                    choice.show();
                } else {
                    choice.hide();
                }
            }
        });
    }

    _populateFileControl(item) {
        if (this.dataItem['fld_' + item.Id] != null && this.dataItem['fld_' + item.Id] != 'False') {
            this.uploadedFiles[item.UniqueClientId] = {};
            this.uploadedFiles[item.UniqueClientId].uploadedFileAdded = true;
            let thumb = { name: this.dataItem['fld_' + item.Id + '_xp_file_name'] != null ? this.dataItem['fld_' + item.Id + '_xp_file_name'] : 'N/A', size: 0, dataURL: rootUrl + 'Entity/GetFileContent?idEntityField=' + item.EntityField.Id + '&pkVal=' + this.objectId + '&_r=' + Math.random(5) };

            $("#" + item.UniqueClientId)[0].dropzone.files.push(thumb);

            $("#" + item.UniqueClientId)[0].dropzone.emit('addedfile', thumb);

            $("#" + item.UniqueClientId)[0].dropzone.createThumbnailFromUrl(thumb,
                $("#" + item.UniqueClientId)[0].dropzone.options.thumbnailWidth, $("#" + item.UniqueClientId)[0].dropzone.options.thumbnailHeight,
                $("#" + item.UniqueClientId)[0].dropzone.options.thumbnailMethod, true, function (thumbnail) {
                    $("#" + item.UniqueClientId)[0].dropzone.emit('thumbnail', thumb, thumb.dataURL);
                });

            $("#" + item.UniqueClientId)[0].dropzone.emit('complete', thumb);

            $("#" + item.UniqueClientId + ' .dz-remove')[0].innerHTML = '';
            $("#" + item.UniqueClientId + ' .dz-remove').addClass('btn btn-danger fal fa-trash-alt d-inline ml-2');
            $("#" + item.UniqueClientId + ' .dz-remove').before('<a class="btn btn-primary fal fa-download d-inline" style="padding-left: 0.5rem; padding-right: 0.5rem; font-size: 14px; text-align: center; display: block; cursor: pointer; border: none;" href="' + rootUrl + 'Entity/GetFileContent?idEntityField=' + item.EntityField.Id + '&pkVal=' + this.objectId + '"></a>');
        }

        if ((this.dataItem['fld_' + item.Id + '_xp_allow_view'] == null || this.dataItem['fld_' + item.Id + '_xp_allow_view'] == 1) && !item.Hidden) {
            $('#' + item.UniqueClientId + '-wrapper').show();
        }

        if (!this.allowEdit || this.dataItem['fld_' + item.Id + '_xp_allow_edit'] == 0) {
            $('#' + item.UniqueClientId).addClass('disabled-control');
            $("#" + item.UniqueClientId + ' .dz-remove').remove();
        }

        if (item.TypeName == 'UICustomFieldControlDto' && item.IdXpCommandSave == null) {
            $('#' + item.UniqueClientId).addClass('disabled-control');
            $("#" + item.UniqueClientId + ' .dz-remove').remove();
        }
    }

    // init and add events to the created controls

    _initControls(item) {
        if (item.TypeName == 'UIFieldControlDto' || item.TypeName == 'UICustomFieldControlDto') {
            if (item.CtlType != null) {
                switch (item.CtlType) {
                    case 'Switch': this._initSwitchControl(item);
                        break;
                    case 'IntegerTextBox': this._initIntegerTextBoxControl(item);
                        break;
                    case 'DatePicker': this._initDatePickerControl(item);
                        break;
                    case 'NumericTextBox': this._initNumericTextBoxControl(item);
                        break;
                    case 'TextBox': this._initTextBoxControl(item);
                        break;
                    case 'TextArea': this._initTextAreaControl(item);
                        break;
                    case 'RichText': this._initRichTextControl(item);
                        break;
                    case 'DateTimePicker': this._initDateTimePickerControl(item);
                        break;
                    case 'ComboBox': {
                        switch (this._getFieldControlSubType(item)) {
                            case 'ListView': break;
                            case 'MultiSelect': this._initMultiSelectControl(item);
                                break;
                            case 'TreeView': this._initDropDownTreeControl(item);
                                break;
                            default: this._initComboBoxControl(item);
                                break;
                        }
                    }
                        break;
                    case 'GeomPicker': {
                        switch (this._getFieldControlSubType(item)) {
                            case 'ModalMap': this._initGeomPickerModalMapControl(item);
                                break;
                            case 'MapView': this._initGeomPickerMapViewControl(item);
                                break;
                        }
                    }
                        break;
                    case 'File': this._initFileControl(item);
                        break;
                    default: break;
                }
            }
        }

        if (item.TypeName == 'UIMapViewDto') {
            if (item.IdMap != null) {
                this._initMapViewControl(item);
            }
        }

        if (item.Items != null && item.Items.length > 0) {
            item.Items.forEach(child => {
                this._initControls(child);
            });
        }

        if (item.IdXpCommandVisible != null && !this.isPreview) {
            this._hideItem(item);
        }
    }

    _hideItem(item) {
        if (item.TypeName == 'UITabPageDto') {
            $('#' + item.UniqueClientId + '-anchor').parent().hide();
            $('#' + item.UniqueClientId + '-anchor').hide();

            if ($('#' + item.UniqueClientId + '-anchor')[0].classList.contains('active')) {
                let siblings = $('#' + item.UniqueClientId + '-anchor').parent().siblings();

                for (let i = 0; i < siblings.length; i++) {
                    if (siblings[i].style.display != 'none') {
                        siblings[i].click();
                        i = siblings.length;
                    }
                }
            }
        } else if (item.TypeName == 'UIGroupDto' || item.TypeName == 'UITabControlDto') {
            $('#' + item.UniqueClientId).hide();
        } else {
            $("#" + item.UniqueClientId + "-wrapper").hide();
        }

        this._setVisibleState(item, false);
    }

    _setPersistedState(item, persisted) {
        $("#" + item.UniqueClientId).attr('persisted', persisted);
        if (item.Items != null) {
            item.Items.forEach(child => { this._setPersistedState(child, persisted) });
        }
    }

    _setVisibleState(item, visible) {
        $("#" + item.UniqueClientId).attr('item-visible', visible);
        if (item.Items != null) {
            item.Items.forEach(child => { this._setVisibleState(child, visible) });
        }

        if (!visible) {
            this._decorateField(item, true);
        }
    }

    _getVisibleState(item) {
        let state = $("#" + item.UniqueClientId).attr('item-visible');

        if (state == null || state == "true") {
            return true;
        } else {
            return false;
        }
    }

    _setReadonlyState(item, readonly) {
        $("#" + item.UniqueClientId).attr('item-readonly', readonly);
        if (item.Items != null) {
            item.Items.forEach(child => { this._setReadonlyState(child, readonly) });
        }

        if (readonly) {
            this._decorateField(item, true);
        }
    }

    _getReadonlyState(item) {
        let state = $("#" + item.UniqueClientId).attr('item-readonly');

        if (state == null || state == "false") {
            return false;
        } else {
            return true;
        }
    }

    _setItemReadonly(item) {
        if (item.TypeName == 'UIFieldControlDto' || item.TypeName == 'UICustomFieldControlDto') {
            if (item.CtlType == 'TextBox' || item.CtlType == 'TextArea') {
                $('#' + item.UniqueClientId).attr('readonly', true);
            } else if (item.CtlType == 'ComboBox') {
                if (item.CtlProps.CtlSubType == 'ListView') {
                    $('#' + item.UniqueClientId).addClass('disabled-control');
                } else if (item.CtlProps.CtlSubType == 'ComboBox') {
                    $('#' + item.UniqueClientId).data('kendoComboBox').readonly(true);
                } else if (item.CtlProps.CtlSubType == 'TreeView') {
                    $('#' + item.UniqueClientId).data('kendoDropDownTree').readonly(true);
                    $('#' + item.UniqueClientId).parent().addClass('isReadonly');
                } else if (item.CtlProps.CtlSubType == 'MultiSelect') {
                    $('#' + item.UniqueClientId).data('kendoMultiSelect').readonly(true);
                }
            } else if (item.CtlType == 'IntegerTextBox' || item.CtlType == 'NumericTextBox') {
                $('#' + item.UniqueClientId).data('kendoNumericTextBox').readonly(true);
            } else if (item.CtlType == 'DatePicker') {
                $('#' + item.UniqueClientId).data('kendoDatePicker').readonly(true);
            } else if (item.CtlType == 'DateTimePicker') {
                $('#' + item.UniqueClientId).data('kendoDateTimePicker').readonly(true);
            } else if (item.CtlType == 'RichText') {
                $('#' + item.UniqueClientId).closest('table').addClass('disabled-control');
            } else if (item.CtlType == 'Switch') {
                $('#' + item.UniqueClientId).data('kendoSwitch').readonly(true);
            } else if (item.CtlType == 'File') {
                $('#' + item.UniqueClientId).addClass('disabled-control');
            } else if (item.CtlType == 'GeomPicker') {
                if (item.CtlProps.CtlSubType == 'ModalMap') {
                    $("#" + item.UniqueClientId).attr('readonly', true);
                } else if (item.CtlProps.CtlSubType == 'MapView') {
                    //TODO
                }
            }
        } else {
            $('#' + item.UniqueClientId).addClass('disabled-control');
        }

        this._setReadonlyState(item, true);
    }

    _setItemReadwrite(item) {
        if (item.TypeName == 'UIFieldControlDto' || item.TypeName == 'UICustomFieldControlDto') {
            if (item.CtlType == 'TextBox' || item.CtlType == 'TextArea') {
                $('#' + item.UniqueClientId).attr('readonly', false);
            } else if (item.CtlType == 'ComboBox') {
                if (item.CtlProps.CtlSubType == 'ListView') {
                    $('#' + item.UniqueClientId).removeClass('disabled-control');
                } else if (item.CtlProps.CtlSubType == 'ComboBox') {
                    $('#' + item.UniqueClientId).data('kendoComboBox').readonly(false);
                } else if (item.CtlProps.CtlSubType == 'TreeView') {
                    $('#' + item.UniqueClientId).data('kendoDropDownTree').readonly(false);
                    $('#' + item.UniqueClientId).parent().removeClass('isReadonly');
                } else if (item.CtlProps.CtlSubType == 'MultiSelect') {
                    $('#' + item.UniqueClientId).data('kendoMultiSelect').readonly(false);
                }
            } else if (item.CtlType == 'IntegerTextBox' || item.CtlType == 'NumericTextBox') {
                $('#' + item.UniqueClientId).data('kendoNumericTextBox').readonly(false);
            } else if (item.CtlType == 'DatePicker') {
                $('#' + item.UniqueClientId).data('kendoDatePicker').readonly(false);
            } else if (item.CtlType == 'DateTimePicker') {
                $('#' + item.UniqueClientId).data('kendoDateTimePicker').readonly(false);
            } else if (item.CtlType == 'RichText') {
                $('#' + item.UniqueClientId).closest('table').removeClass('disabled-control');
            } else if (item.CtlType == 'Switch') {
                $('#' + item.UniqueClientId).data('kendoSwitch').readonly(false);
            } else if (item.CtlType == 'File') {
                $('#' + item.UniqueClientId).removeClass('disabled-control');
            } else if (item.CtlType == 'GeomPicker') {
                if (item.CtlProps.CtlSubType == 'ModalMap') {
                    $("#" + item.UniqueClientId).attr('readonly', false);
                } else if (item.CtlProps.CtlSubType == 'MapView') {
                    //TODO
                }
            }
        } else {
            $('#' + item.UniqueClientId).removeClass('disabled-control');
        }

        this._setReadonlyState(item, false);
    }

    _showItem(item) {
        this._setPersistedState(item, true);

        if (item.TypeName == 'UITabPageDto') {
            $('#' + item.UniqueClientId + '-anchor').parent().show();
            $('#' + item.UniqueClientId + '-anchor').show();
        } else if (item.TypeName == 'UIGroupDto' || item.TypeName == 'UITabControlDto') {
            $('#' + item.UniqueClientId).show();
        } else {
            $("#" + item.UniqueClientId + "-wrapper").show();
        }

        this._setVisibleState(item, true);
    }

    _bindChangeEvents(item) {
        if (item.TypeName == 'UIFieldControlDto' || item.TypeName == 'UICustomFieldControlDto') {
            if (item.CtlType != null) {
                switch (item.CtlType) {
                    case 'ComboBox': {
                        switch (this._getFieldControlSubType(item)) {
                            case 'ListView': break;//TO DO
                            case 'MultiSelect': this._bindMultiSelectChange(item);
                                break;
                            case 'TreeView': this._bindDropDownTreeChange(item);
                                break;
                            default: this._bindComboBoxChange(item);
                                break;
                        }
                    }
                        break;
                    default: break;
                }
            }
        }

        if (item.Items != null && item.Items.length > 0) {
            item.Items.forEach(child => {
                this._bindChangeEvents(child);
            });
        }
    }

    _bindMultiSelectChange(item) {
        $("#" + item.UniqueClientId).data('kendoMultiSelect').bind("change", (e) => {
            let dependants = this._getDependants(item.Guid);

            if (dependants != null && dependants.length > 0) {
                this._handleItemsState(dependants);

                let cascadedDependants = [];

                dependants.forEach(dependant => {
                    if (dependant.SqlWhere != null && dependant.SqlWhere != '' && dependant.SqlWhere.indexOf(item.EntityField.FieldName) >= 0) {
                        cascadedDependants.push(dependant);
                    }
                });

                this._handleCascadedItems(cascadedDependants);
            }

            //self check
            this._checkItemValidity(item);
        });
    }

    _bindDropDownTreeChange(item) {
        $("#" + item.UniqueClientId).data('kendoDropDownTree').bind("change", (e) => {
            if (e.sender.value() == null || e.sender.value() == '') {
                e.sender.text('');
                e.sender._oldText = '';
                e.sender._prev = '';
            }

            let dependants = this._getDependants(item.Guid);

            if (dependants != null && dependants.length > 0) {
                this._handleItemsState(dependants);

                let cascadedDependants = [];

                dependants.forEach(dependant => {
                    if (dependant.SqlWhere != null && dependant.SqlWhere != '' && dependant.SqlWhere.indexOf(item.EntityField.FieldName) >= 0) {
                        cascadedDependants.push(dependant);
                    }
                });

                this._handleCascadedItems(cascadedDependants);
            }

            //self check
            this._checkItemValidity(item);
        });
    }

    _bindComboBoxChange(item) {
        $("#" + item.UniqueClientId).data('kendoComboBox').bind("change", (e) => {
            if (e.sender.value() == null || e.sender.value() == '') {
                e.sender.text('');
                e.sender._oldText = '';
                e.sender._prev = '';
            }

            let dependants = this._getDependants(item.Guid);

            if (dependants != null && dependants.length > 0) {
                this._handleItemsState(dependants);

                let cascadedDependants = [];

                dependants.forEach(dependant => {
                    if (dependant.SqlWhere != null && dependant.SqlWhere != '' && dependant.SqlWhere.indexOf(item.EntityField.FieldName) >= 0) {
                        cascadedDependants.push(dependant);
                    }
                });

                this._handleCascadedItems(cascadedDependants);
            }

            //self check
            this._checkItemValidity(item);
        });
    }

    _checkVisibility(item) {
        if (item.IdXpCommandVisible != null) {
            this.executeCommandById(item.IdXpCommandVisible, this.isClientCommand(item.IdXpCommandVisible) ? { item: item, value: this._getFieldValueByUniqueId(item.UniqueClientId) } : null).then((result) => {
                if (this._parseBooleanCommandResult(result) == true) {
                    this._showItem(item);
                } else {
                    this._hideItem(item);
                }
            });
        }

        if (item.Items != null && item.Items.length > 0) {
            item.Items.forEach(child => {
                this._checkVisibility(child);
            });
        }
    }

    _checkItemValidity(item) {
        return new Promise((resolve, reject) => {
            if (!item.Hidden && !item.IsReadOnly && this._getVisibleState(item) && !this._getReadonlyState(item)) {
                if (item.IdXpCommandNotNull != null) {
                    this.executeCommandById(item.IdXpCommandNotNull, this.isClientCommand(item.IdXpCommandNotNull) ? { item: item, value: this._getFieldValueByUniqueId(item.UniqueClientId) } : null).then((result) => {
                        if (this._parseBooleanCommandResult(result) == true) {
                            let value = this._getFieldValueByUniqueId(item.UniqueClientId);

                            if (value === null || value === '') {
                                this._decorateField(item, false);
                                this.isValid = false;
                                resolve();
                            } else {
                                this._decorateField(item, true);

                                if (item.IdXpCommandValid != null) {
                                    this.executeCommandById(item.IdXpCommandValid, this.isClientCommand(item.IdXpCommandValid) ? { item: item, value: this._getFieldValueByUniqueId(item.UniqueClientId) } : null).then((result) => {
                                        let value = this._parseStringCommandResult(result);

                                        if (value != null) {
                                            this._decorateField(item, false, value);
                                            this.isValid = false;
                                        } else {
                                            this._decorateField(item, true);
                                        }
                                        resolve();
                                    });
                                } else {
                                    resolve();
                                }
                            }
                        } else {
                            this._decorateField(item, true);

                            if (item.IdXpCommandValid != null) {
                                this.executeCommandById(item.IdXpCommandValid, this.isClientCommand(item.IdXpCommandValid) ? { item: item, value: this._getFieldValueByUniqueId(item.UniqueClientId) } : null).then((result) => {
                                    let value = this._parseStringCommandResult(result);

                                    if (value != null) {
                                        this._decorateField(item, false, value);
                                        this.isValid = false;
                                    } else {
                                        this._decorateField(item, true);
                                    }
                                    resolve();
                                });
                            } else {
                                resolve();
                            }
                        }
                    });
                } else if (this._isEligibleForValidation(item)) {
                    let value = this._getFieldValueByUniqueId(item.UniqueClientId);

                    if (value === null || value === '') {
                        this._decorateField(item, false);
                        this.isValid = false;
                        resolve();
                    } else {
                        this._decorateField(item, true);

                        if (item.IdXpCommandValid != null) {
                            this.executeCommandById(item.IdXpCommandValid, this.isClientCommand(item.IdXpCommandValid) ? { item: item, value: this._getFieldValueByUniqueId(item.UniqueClientId) } : null).then((result) => {
                                let value = this._parseStringCommandResult(result);

                                if (value != null) {
                                    this._decorateField(item, false, value);
                                    this.isValid = false;
                                } else {
                                    this._decorateField(item, true);
                                }
                                resolve();
                            });
                        } else {
                            resolve();
                        }
                    }
                } else if (item.IdXpCommandValid != null) {
                    this.executeCommandById(item.IdXpCommandValid, this.isClientCommand(item.IdXpCommandValid) ? { item: item, value: this._getFieldValueByUniqueId(item.UniqueClientId) } : null).then((result) => {
                        let value = this._parseStringCommandResult(result);

                        if (value != null) {
                            this._decorateField(item, false, value);
                            this.isValid = false;
                        } else {
                            this._decorateField(item, true);
                        }
                        resolve();
                    });
                } else {
                    resolve();
                }
            } else {
                resolve();
            }
        });
    }

    _checkItemReadonly(item) {
        return new Promise((resolve, reject) => {
            if (item.IdXpCommandReadOnly != null) {
                this.executeCommandById(item.IdXpCommandReadOnly, this.isClientCommand(item.IdXpCommandReadOnly) ? { item: item, value: this._getFieldValueByUniqueId(item.UniqueClientId) } : null).then((result) => {
                    if (this._parseBooleanCommandResult(result) == true) {
                        this._setItemReadonly(item);
                    } else {
                        this._setItemReadwrite(item);
                    }
                    resolve();
                });
            } else {
                resolve();
            }
        });

    }

    _checkItemVisibility(item) {
        return new Promise((resolve, reject) => {
            if (item.IdXpCommandVisible != null) {
                this.executeCommandById(item.IdXpCommandVisible, this.isClientCommand(item.IdXpCommandVisible) ? { item: item, value: this._getFieldValueByUniqueId(item.UniqueClientId) } : null).then((result) => {
                    if (this._parseBooleanCommandResult(result) == true) {
                        this._showItem(item);
                    } else {
                        this._hideItem(item);
                    }
                    resolve();
                });
            } else {
                resolve();
            }
        });
    }

    _checkValidate(item) {
        if (item.IdValidateCommand != null) {
            this.executeCommandById(item.IdValidateCommand, this.isClientCommand(item.IdValidateCommand) ? { item: item, value: this._getFieldValueByUniqueId(item.UniqueClientId) } : null).then((result) => {
                if (result == null) {
                    //validarea este ok
                    this._decorateField(item, true);
                } else {
                    //validarea nu este ok
                    alert(result);
                    this._decorateField(item, false);
                }
            });
        }

        if (item.Items != null && item.Items.length > 0) {
            item.Items.forEach(child => {
                this._checkValidate(child);
            });
        }
    }

    _parseBooleanCommandResult(item) {
        if (item == null) {
            return null;
        }

        if (item == 1 || item == '1' || item == true || item == 'true' || item == 'True') {
            return true;
        }

        if (item === 0 || item === '0' || item === false || item === 'false' || item === 'False') {
            return false;
        }

        let keys = Object.keys(item);

        if (keys.length > 0) {
            let value = item[keys[0]];

            if (value === 1 || value === '1' || value === true || value === 'true' || value === 'True') {
                return true;
            }

            if (value === 0 || value === '0' || value === false || value === 'false' || value === 'False') {
                return false;
            }
        }

        return null;
    }

    _parseStringCommandResult(item) {
        if (item != null) {
            if (typeof item === 'string') {
                return item;
            } else if (typeof item === 'object') {
                let keys = Object.keys(item);

                if (keys.length > 0) {
                    let value = item[keys[0]];

                    if (typeof value === 'string') {
                        return value;
                    }
                }
            }
        }

        return null;
    }

    _initDatePickerControl(item) {
        let options = {};

        if (item.Format != null && item.Format.trim() != '') {
            options.format = item.Format;
        }

        if (this.serverData['fld_' + item.Id] != null) {
            options.value = this._deserializeDate(this.serverData['fld_' + item.Id]);
        }

        options.change = (e) => {
            let dependants = this._getDependants(item.Guid);

            if (dependants != null && dependants.length > 0) {
                this._handleItemsState(dependants);

                let cascadedDependants = [];

                dependants.forEach(dependant => {
                    if (dependant.SqlWhere != null && dependant.SqlWhere != '' && dependant.SqlWhere.indexOf(item.EntityField.FieldName) >= 0) {
                        cascadedDependants.push(dependant);
                    }
                });

                this._handleCascadedItems(cascadedDependants);
            }

            //self check
            this._checkItemValidity(item);
        };

        options.popup = {
            appendTo: this._getAppendTo(item)
        }

        $("#" + item.UniqueClientId).kendoDatePicker(options);

        if (item.IsReadOnly) {
            $("#" + item.UniqueClientId).data("kendoDatePicker").readonly(true);
        }
    }

    _initIntegerTextBoxControl(item) {
        let format = "0";

        if (item.Format != null && item.Format.trim() != '') {
            format = item.Format;
        }

        $("#" + item.UniqueClientId).kendoNumericTextBox({
            format: format,
            decimals: 0,
            popup: {
                appendTo: this._getAppendTo(item)
            }
        });

        if (item.IsReadOnly) {
            $("#" + item.UniqueClientId).data("kendoNumericTextBox").readonly(true);
        }
    }

    _initNumericTextBoxControl(item) {
        let options = {};

        if (item.Format != null && item.Format.trim() != '') {
            options.format = item.Format;
            options.decimals = this._getDecimalsFromFormat(item.Format);
        }

        options.popup = {
            appendTo: this._getAppendTo(item)
        }

        $("#" + item.UniqueClientId).kendoNumericTextBox(options);

        if (item.IsReadOnly) {
            $("#" + item.UniqueClientId).data("kendoNumericTextBox").readonly(true);
        }
    }

    _initRichTextControl(item) {
        let options = {
            tools: [
                "undo",
                "redo",
                { name: "separator1", type: "separator" },
                {
                    name: "fontName",
                    items: [
                        { text: "Andale Mono", value: "\"Andale Mono\"" }, // Font-family names composed of several words should be wrapped in \" \"
                        { text: "Arial", value: "Arial" },
                        { text: "Arial Black", value: "\"Arial Black\"" },
                        { text: "Book Antiqua", value: "\"Book Antiqua\"" },
                        { text: "Comic Sans MS", value: "\"Comic Sans MS\"" },
                        { text: "Courier New", value: "\"Courier New\"" },
                        { text: "Georgia", value: "Georgia" },
                        { text: "Helvetica", value: "Helvetica" },
                        { text: "Impact", value: "Impact" },
                        { text: "Symbol", value: "Symbol" },
                        { text: "Tahoma", value: "Tahoma" },
                        { text: "Terminal", value: "Terminal" },
                        { text: "Times New Roman", value: "\"Times New Roman\"" },
                        { text: "Trebuchet MS", value: "\"Trebuchet MS\"" },
                        { text: "Verdana", value: "Verdana" },
                    ]
                },
                "fontSize",
                "bold",
                "italic",
                "underline",
                "backColor",
                "foreColor",
                { name: "separator2", type: "separator" },
                "insertUnorderedList",
                "justifyLeft",
                "justifyCenter",
                "justifyRight",
                { name: "separator3", type: "separator" },
                "formatting",
                { name: "separator4", type: "separator" },
                "createLink",
                "unlink",
                "insertImage",
                { name: "separator5", type: "separator" },
                "tableWizard",
                "tableProperties",
                "tableCellProperties",
                "createTable",
                "addRowAbove",
                "addRowBelow",
                "addColumnLeft",
                "addColumnRight",
                "deleteRow",
                "deleteColumn",
                "mergeCellsHorizontally",
                "mergeCellsVertically",
                "splitCellHorizontally",
                "splitCellVertically",
                "tableAlignLeft",
                "tableAlignCenter",
                "tableAlignRight"
            ]
        };

        options.change = (e) => {
            let dependants = this._getDependants(item.Guid);

            if (dependants != null && dependants.length > 0) {
                this._handleItemsState(dependants);

                let cascadedDependants = [];

                dependants.forEach(dependant => {
                    if (dependant.SqlWhere != null && dependant.SqlWhere != '' && dependant.SqlWhere.indexOf(item.EntityField.FieldName) >= 0) {
                        cascadedDependants.push(dependant);
                    }
                });

                this._handleCascadedItems(cascadedDependants);
            }

            //self check
            this._checkItemValidity(item);
        };

        options.popup = {
            appendTo: this._getAppendTo(item)
        }

        $("#" + item.UniqueClientId).kendoEditor(options);

        if (item.IsReadOnly) {
            $("#" + item.UniqueClientId).data("kendoEditor").readonly(true);
        }
    }

    _getDecimalsFromFormat(format) {
        switch (format) {
            case '{0:0.0}': return 1;
            case '{0:0.00}': return 2;
            case '{0:0.000}': return 3;
            case '{0:0.0000}': return 4;
            case '{0:0.00000}': return 5;
            case '{0:0.000000}': return 6;
            default: return 2;
        }
    }

    _initTextBoxControl(item) {
        if (item.IsReadOnly) {
            $("#" + item.UniqueClientId).attr('readonly', true);
        }
    }

    _initTextAreaControl(item) {
        if (item.IsReadOnly) {
            $("#" + item.UniqueClientId).attr('readonly', true);
        }
    }

    _initDateTimePickerControl(item) {
        let options = {};

        if (item.Format != null && item.Format.trim() != '') {
            options.format = item.Format;
        }

        if (this.serverData['fld_' + item.Id] != null) {
            options.value = this._deserializeDateTime(this.serverData['fld_' + item.Id]);
        }

        options.change = (e) => {
            let dependants = this._getDependants(item.Guid);

            if (dependants != null && dependants.length > 0) {
                this._handleItemsState(dependants);

                let cascadedDependants = [];

                dependants.forEach(dependant => {
                    if (dependant.SqlWhere != null && dependant.SqlWhere != '' && dependant.SqlWhere.indexOf(item.EntityField.FieldName) >= 0) {
                        cascadedDependants.push(dependant);
                    }
                });

                this._handleCascadedItems(cascadedDependants);
            }

            //self check
            this._checkItemValidity(item);
        };

        options.popup = {
            appendTo: this._getAppendTo(item)
        }

        $("#" + item.UniqueClientId).kendoDateTimePicker(options);

        if (item.IsReadOnly) {
            $("#" + item.UniqueClientId).data("kendoDateTimePicker").readonly(true);
        }
    }

    _initSwitchControl(item) {        
        
        $("#" + item.UniqueClientId).kendoSwitch({
            messages: {
                checked: this._getResource('SWITCH_ON'),
                unchecked: this._getResource('SWITCH_OFF')
            },
            checked: false,
            change: (e) => {
                if (!item.NotNull) {
                    this._threeStateSwitch_Change(e);
                }                
                let dependants = this._getDependants(item.Guid);

                if (dependants != null && dependants.length > 0) {
                    this._handleItemsState(dependants);

                    let cascadedDependants = [];

                    dependants.forEach(dependant => {
                        if (dependant.SqlWhere != null && dependant.SqlWhere != '' && dependant.SqlWhere.indexOf(item.EntityField.FieldName) >= 0) {
                            cascadedDependants.push(dependant);
                        }
                    });

                    this._handleCascadedItems(cascadedDependants);
                }

                //self check
                this._checkItemValidity(item);
            },
            popup: {
                appendTo: this._getAppendTo(item)
            }
        });

        if (!item.NotNull) {
            $("#" + item.UniqueClientId).prop("threeState", true);
            this._threeStateSwitchSetValue("#" + item.UniqueClientId, null);
        }
        else {
            this._threeStateSwitchSetValue("#" + item.UniqueClientId, false);
        }
        if (item.IsReadOnly) {
            $("#" + item.UniqueClientId).data('kendoSwitch').readonly(true);
        }
    }
    _threeStateSwitch_Change(e) {
        if (!e.checked) {
            if (!e.sender.element.prop("indeterminate")) {
                e.sender.element.prop("indeterminate", true);
                e.sender.wrapper.addClass("k-indeterminate");

                e.sender.setOptions({
                    messages: {
                        checked: this._getResource("SWITCH_NA")
                    }
                });
                e.preventDefault();
                e.sender.element.prop("currentValue", null);
            } else {
                e.sender.element.prop("indeterminate", false);
                e.sender.wrapper.removeClass("k-indeterminate");

                e.sender.setOptions({
                    messages: {
                        checked: this._getResource("SWITCH_ON")
                    }
                });

                e.sender.element.prop("currentValue", false);
            }
        }
        else {
            e.sender.element.prop("currentValue", true);
        }
    }
    _threeStateSwitchGetValue(sender) {
        var ctl = $(sender).data("kendoSwitch");
        if (ctl.element.prop("threeState")) {
            return ctl.element.prop("currentValue");
        }
        else {
            var value = ctl.value();
            if (value === null) {
                return false;
            }
            else {
                return value;
            }
        }
        
        //if (ctl.value()) {
        //    if (ctl.element.prop("indeterminate")) {
        //        return null;
        //    }
        //    else {
        //        return true;
        //    }
        //}
        //else {
        //    return false;
        //}
    }
    _threeStateSwitchSetValue(sender, value) {
        var ctl = $(sender).data("kendoSwitch");
        if (ctl.element.prop("threeState")) {
            ctl.element.prop("currentValue", value);
            if (value == null) {
                ctl.value(true);
                ctl.element.prop("indeterminate", true);
                ctl.wrapper.addClass("k-indeterminate");
                ctl.setOptions({
                    messages: {
                        checked: this._getResource("SWITCH_NA")
                    }
                });
            }
            else {
                ctl.element.prop("indeterminate", false);
                ctl.wrapper.removeClass("k-indeterminate");
                ctl.setOptions({
                    messages: {
                        checked: this._getResource("SWITCH_ON")
                    }
                });
                ctl.value(value);
            }
        }
        else {
            if (value === null) {
                value = false;
            }
            ctl.value(value);
        }
    }

    _initMapViewControl(item) {
        if (item.IdMap != null) {
            let container = document.querySelector('.xp-map-container[map-id="' + item.IdMap + '"]');
            $("#" + item.UniqueClientId)[0].mapControl = new MapControl(item.IdMap, container, rootURL, item.IdMap + '-' + item.Id);
            $("#" + item.UniqueClientId)[0].mapControl.init();
        }
    }

    _initSublistControl(item, ignore) {
        if (ignore) {
            return;
        }

        if (item.IdList == null || item.IdList == '') {
            return;
        }

        let sublistUrl = '';

        if (this.isPreview) {
            sublistUrl = rootURL + 'EntityList/EntitySubListRuntime?IdList=' + item.IdList + '&pageGuid=' + this._generateUUID();
        } else {
            sublistUrl = rootURL + 'EntityList/EntitySubListRuntime?idUISubList=' + item.Id + '&pkVal=' + this.objectId + '&pageGuid=' + this._generateUUID();
            if (this.idExtConn != null) {
                sublistUrl += "&idExtConn=" + this.idExtConn;
            }
        }

        $.ajax({
            type: "GET",
            url: sublistUrl,
            contentType: "application/json; charset=utf-8",
            async: true,
            success: (listMeta) => {
                $('#' + item.UniqueClientId).append('<script>' + listMeta.CustomJs + '</script>');
                let filterId = listMeta.IdFilter != null ? listMeta.IdFilter : -1;

                listMeta.Context = '';
                listMeta.CurrentUrl = 'full';
                listMeta.ReturnUrl = '';
                listMeta.ContainerId = item.UniqueClientId;
                listMeta.Template = 'standard';
                listMeta.GeneralResources = this.generalResources;
                listMeta.EntityFormResources = this.customFormResources;
                listMeta.UiActionResources = this.actionLocalization;
                listMeta.RootUrl = rootUrl;
                listMeta.IsPreview = this.isPreview;
                listMeta.LayoutResources = this.localization;
                listMeta.FilterId = filterId;
                listMeta.Parent = this;
                listMeta.uiLayoutId = item.Id;
                listMeta.parentPkVal = this.objectId;

                if (item.CtlProps == null || item.CtlProps.Autobind == null) {
                    listMeta.Autobind = true;
                } else {
                    listMeta.Autobind = item.CtlProps.Autobind;
                }

                this.sublists[item.UniqueClientId] = new ListControl(listMeta);
                item.isLoaded = true;
            },
            error: (e) => {
                toastr.error(e.responseText, this._getResource('GetSublistError'));
            }
        });
    }

    _initMultiSelectControl(item) {
        $("#" + item.UniqueClientId).kendoMultiSelect({
            autoBind: !this.isPreview,
            dataTextField: 'Name',
            dataValueField: 'Id',
            filter: 'contains',
            syncValueAndText: false,
            suggest: true,
            ignoreCase: true,
            popup: {
                appendTo: this._getAppendTo(item)
            },
            value: this.serverData != null && this.serverData['fld_' + item.Id] != null ? this.serverData['fld_' + item.Id] : null,
            template: (dataItem) => {
                if (dataItem.Attr != null) {
                    if (dataItem.Attr.length == 2) {
                        if (dataItem.Attr[1] != null) {
                            return '<img src="' + (rootUrl + 'Entity/GetFileContent?idEntityField=' + dataItem.Attr[1] + '&pkVal=' + dataItem.Id) + '" width="60" height="60" /><span class="k-state-default ml-2">' + '<strong>' + dataItem.Name + '</strong>' + (dataItem.Attr[0] != null ? ('<br>' + dataItem.Attr[0]) : '') + '</span>'
                        }
                        else {
                            return '<span class="k-state-default ml-2">' + '<strong>' + dataItem.Name + '</strong>' + (dataItem.Attr[0] != null ? ('<br>' + dataItem.Attr[0]) : '') + '</span>';
                        }
                    }
                    else if (dataItem.Attr.length == 1) {
                        return '<span class="k-state-default ml-2">' + '<strong>' + dataItem.Name + '</strong>' + (dataItem.Attr[0] != null ? ('<br>' + dataItem.Attr[0]) : '') + '</span>';
                    }
                } else {
                    return '<span class="k-state-default ml-2">' + '<strong>' + dataItem.Name + '</strong>' + '</span>';
                }
            },
            dataSource: {
                serverFiltering: (item.DependsOnGuids != null && item.DependsOnGuids.length > 0) || (item.Rows != null && item.Rows > 0),
                transport: {
                    read: {
                        dataType: 'json',
                        url: () => {
                            if (item.DependsOnGuids != null && item.DependsOnGuids.length > 0) {
                                let isReadonly = false;
                                let filter = {};

                                item.DependsOnGuids.forEach(depends => {
                                    let dependant = this._getItemByGuid(depends, [this.metadata]);
                                    let value = this._getItemValueByGuid(depends, true);

                                    if (value === null || value === '') {
                                        if (item.SqlWhere != null && item.SqlWhere != '' && item.SqlWhere.indexOf(dependant.EntityField.FieldName) >= 0) {
                                            isReadonly = true;

                                            filter["fld_" + dependant.Id] = {
                                                value: value,
                                                type: dependant.EntityField.DataType
                                            };
                                        }
                                    } else {
                                        if (item.SqlWhere != null && item.SqlWhere != '' && item.SqlWhere.indexOf(dependant.EntityField.FieldName) >= 0) {

                                            filter["fld_" + dependant.Id] = {
                                                value: value,
                                                type: dependant.EntityField.DataType
                                            };
                                        }
                                    }
                                });

                                if (this.isPreview) {
                                    return rootURL + 'Entity/GetEmptyFieldSource?idField=' + item.Id + '&filter=' + JSON.stringify(filter);
                                }

                                if (isReadonly) {
                                    $('#' + item.UniqueClientId).data("kendoMultiSelect").value(null);
                                    $('#' + item.UniqueClientId).data("kendoMultiSelect").readonly(true);

                                    let additionalFilter = '';

                                    var fkVal = $('#' + item.UniqueClientId).data('kendoMultiSelect').value();
                                    var search = $('#' + item.UniqueClientId).data('kendoMultiSelect').input.val();;
                                    additionalFilter = '&search=' + search;

                                    additionalFilter += '&fkVal=' + fkVal;

                                    return rootURL + 'Entity/GetEmptyFieldSource?idField=' + item.Id + additionalFilter;
                                } else {
                                    let additionalFilter = '';

                                    var fkVal = $('#' + item.UniqueClientId).data('kendoMultiSelect').value();
                                    var search = $('#' + item.UniqueClientId).data('kendoMultiSelect').input.val();
                                    additionalFilter = '&search=' + search;
                                    additionalFilter += '&fkVal=' + fkVal;

                                    return rootURL + 'Entity/GetFieldSource?idField=' + item.Id + '&idExtConn=' + this.idExtConn + '&filter=' + JSON.stringify(filter) + additionalFilter;
                                }
                            } else {
                                if (this.isPreview) {
                                    return rootURL + 'Entity/GetEmptyFieldSource?idField=' + item.Id;
                                }

                                let additionalFilter = '';

                                var fkVal = $('#' + item.UniqueClientId).data('kendoMultiSelect').value();
                                var search = $('#' + item.UniqueClientId).data('kendoMultiSelect').input.val();
                                additionalFilter = '&search=' + search;
                                additionalFilter += '&fkVal=' + fkVal;

                                return rootURL + 'Entity/GetFieldSource?idField=' + item.Id + '&idExtConn=' + this.idExtConn + additionalFilter;
                            }
                        }
                    }
                }
            },
            dataBound: () => {
                let val = $('#' + item.UniqueClientId).attr('initValue');
                if (val != null && val != '') {
                    $('#' + item.UniqueClientId).attr('initValue', null);

                    let cbo = $('#' + item.UniqueClientId).data("kendoMultiSelect");
                    cbo.dataSource.data().forEach(x => {
                        if (x.Id == val) {
                            cbo.value(val);
                            cbo.trigger('change');
                        }
                    });
                }
            }
        });

        if (item.IsReadOnly) {
            $("#" + item.UniqueClientId).data("kendoMultiSelect").readonly(true);
        }
    }

    _getAppendTo(item) {
        if ($("#" + item.UniqueClientId).closest('.k-window').length > 0) {
            return $("#" + item.UniqueClientId).closest('.k-window');
        } else {
            return $("#" + item.UniqueClientId).parent();
        }
    }

    _initDropDownTreeControl(item) {
        $("#" + item.UniqueClientId).kendoDropDownTree({
            autoBind: !this.isPreview,
            dataTextField: 'Name',
            dataValueField: 'Id',
            filter: 'contains',
            ignoreCase: true,
            popup: {
                appendTo: this._getAppendTo(item)
            },
            value: this.serverData != null && this.serverData['fld_' + item.Id] != null ? this.serverData['fld_' + item.Id] : null,
            loadOnDemand: true,
            dataSource: {
                schema: {
                    model: {
                        id: "Id",
                        items: "Items",
                        hasChildren: (selectedItem) => {
                            if (selectedItem.HasChildren == null) {
                                return false;
                            }
                            return selectedItem.HasChildren;
                        }
                    }
                },
                serverFiltering: true,
                transport: {
                    read: {
                        dataType: 'json',
                        url: () => {
                            if (item.DependsOnGuids != null && item.DependsOnGuids.length > 0) {
                                let isReadonly = false;
                                let filter = {};

                                item.DependsOnGuids.forEach(depends => {
                                    let dependant = this._getItemByGuid(depends, [this.metadata]);
                                    let value = this._getItemValueByGuid(depends, true);

                                    if (value === null || value === '') {
                                        if (item.SqlWhere != null && item.SqlWhere != '' && item.SqlWhere.indexOf(dependant.EntityField.FieldName) >= 0) {
                                            isReadonly = true;

                                            filter["fld_" + dependant.Id] = {
                                                value: value,
                                                type: dependant.EntityField.DataType
                                            };
                                        }
                                    } else {
                                        if (item.SqlWhere != null && item.SqlWhere != '' && item.SqlWhere.indexOf(dependant.EntityField.FieldName) >= 0) {

                                            filter["fld_" + dependant.Id] = {
                                                value: value,
                                                type: dependant.EntityField.DataType
                                            };
                                        }
                                    }
                                });

                                if (this.isPreview) {
                                    return rootURL + 'Entity/GetEmptyFieldSource?idField=' + item.Id + '&filter=' + JSON.stringify(filter);
                                }

                                if (isReadonly) {
                                    $('#' + item.UniqueClientId).data("kendoDropDownTree").value(null);
                                    $('#' + item.UniqueClientId).data("kendoDropDownTree").readonly(true);
                                    $('#' + item.UniqueClientId).parent().addClass('isReadonly');

                                    let additionalFilter = '';

                                    var fkVal = $('#' + item.UniqueClientId).data('kendoDropDownTree').value();
                                    var search = $('#' + item.UniqueClientId).data('kendoDropDownTree').filterInput.val();
                                    additionalFilter = '&search=' + search + '&fkVal=' + fkVal;

                                    return rootURL + 'Entity/GetEmptyFieldSource?idField=' + item.Id + additionalFilter;
                                } else {
                                    let additionalFilter = '';

                                    var fkVal = $('#' + item.UniqueClientId).data('kendoDropDownTree').value();
                                    var search = $('#' + item.UniqueClientId).data('kendoDropDownTree').filterInput.val();
                                    additionalFilter = '&search=' + search + '&fkVal=' + fkVal;

                                    return rootURL + 'Entity/GetTreeFieldSource?idField=' + item.Id + '&idExtConn=' + this.idExtConn + '&filter=' + JSON.stringify(filter) + additionalFilter;
                                }
                            } else {
                                if (this.isPreview) {
                                    return rootURL + 'Entity/GetEmptyFieldSource?idField=' + item.Id;
                                }

                                let additionalFilter = '';

                                var fkVal = $('#' + item.UniqueClientId).data('kendoDropDownTree').value();
                                var search = $('#' + item.UniqueClientId).data('kendoDropDownTree').filterInput.val();
                                additionalFilter = '&search=' + search + '&fkVal=' + fkVal;

                                return rootURL + 'Entity/GetTreeFieldSource?idField=' + item.Id + '&idExtConn=' + this.idExtConn + additionalFilter;
                            }
                        }
                    }
                }
            },
            dataBound: (evt) => {
                let val = $('#' + item.UniqueClientId).attr('initValue');
                if (val != null && val != '') {
                    $('#' + item.UniqueClientId).attr('initValue', null);

                    let cbo = $('#' + item.UniqueClientId).data("kendoDropDownTree");
                    cbo.dataSource.data().forEach(x => {
                        if (x.Id == val) {
                            cbo.value(val);
                            cbo.trigger('change');
                        }
                    });
                }
            },
            select: (e) => {
                if (item.CtlProps.SelectOnlyLeaves) {
                    let selectedItem = e.sender.dataItem(e.node);
                    if (selectedItem.hasChildren) {
                        e.preventDefault();
                        e.sender.treeview.toggle(e.node);
                    }
                }
            }
        });
    }

    _initComboBoxControl(item) {
        $("#" + item.UniqueClientId).kendoComboBox({
            autoBind: !this.isPreview,
            dataTextField: 'Name',
            dataValueField: 'Id',
            filter: 'contains',
            syncValueAndText: false,
            suggest: true,
            ignoreCase: true,
            popup: {
                appendTo: this._getAppendTo(item)
            },
            value: this.serverData != null && this.serverData['fld_' + item.Id] != null ? this.serverData['fld_' + item.Id] : null,
            template: (dataItem) => {
                if (dataItem.Attr != null) {
                    if (dataItem.Attr.length == 2) {
                        if (dataItem.Attr[1] != null) {
                            return '<img src="' + (rootUrl + 'Entity/GetFileContent?idEntityField=' + dataItem.Attr[1] + '&pkVal=' + dataItem.Id) + '" width="60" height="60" /><span class="k-state-default ml-2">' + '<strong>' + dataItem.Name + '</strong>' + (dataItem.Attr[0] != null ? ('<br>' + dataItem.Attr[0]) : '') + '</span>'
                        }
                        else {
                            return '<span class="k-state-default ml-2">' + '<strong>' + dataItem.Name + '</strong>' + (dataItem.Attr[0] != null ? ('<br>' + dataItem.Attr[0]) : '') + '</span>';
                        }
                    }
                    else if (dataItem.Attr.length == 1) {
                        return '<span class="k-state-default ml-2">' + '<strong>' + dataItem.Name + '</strong>' + (dataItem.Attr[0] != null ? ('<br>' + dataItem.Attr[0]) : '') + '</span>';
                    }
                } else {
                    return '<span class="k-state-default ml-2">' + '<strong>' + dataItem.Name + '</strong>' + '</span>';
                }
            },
            dataSource: {
                serverFiltering: (item.DependsOnGuids != null && item.DependsOnGuids.length > 0) || (item.Rows != null && item.Rows > 0),
                transport: {
                    read: {
                        dataType: 'json',
                        url: () => {
                            if (item.DependsOnGuids != null && item.DependsOnGuids.length > 0) {
                                let isReadonly = false;
                                let filter = {};

                                item.DependsOnGuids.forEach(depends => {
                                    let dependant = this._getItemByGuid(depends, [this.metadata]);
                                    let value = this._getItemValueByGuid(depends, true);

                                    if (value === null || value === '') {
                                        if (item.SqlWhere != null && item.SqlWhere != '' && item.SqlWhere.indexOf(dependant.EntityField.FieldName) >= 0) {
                                            isReadonly = true;

                                            filter["fld_" + dependant.Id] = {
                                                value: value,
                                                type: dependant.EntityField.DataType
                                            };
                                        }
                                    } else {
                                        if (item.SqlWhere != null && item.SqlWhere != '' && item.SqlWhere.indexOf(dependant.EntityField.FieldName) >= 0) {

                                            filter["fld_" + dependant.Id] = {
                                                value: value,
                                                type: dependant.EntityField.DataType
                                            };
                                        }
                                    }
                                });

                                if (this.isPreview) {
                                    return rootURL + 'Entity/GetEmptyFieldSource?idField=' + item.Id + '&filter=' + JSON.stringify(filter);
                                }

                                if (isReadonly) {
                                    $('#' + item.UniqueClientId).data("kendoComboBox").value(null);
                                    $('#' + item.UniqueClientId).data("kendoComboBox").readonly(true);

                                    let additionalFilter = '';

                                    var fkVal = $('#' + item.UniqueClientId).data('kendoComboBox').value();
                                    var search = $('#' + item.UniqueClientId).data('kendoComboBox').text();
                                    additionalFilter = '&search=' + search + '&fkVal=' + fkVal;

                                    return rootURL + 'Entity/GetEmptyFieldSource?idField=' + item.Id + additionalFilter;
                                } else {
                                    let additionalFilter = '';

                                    var fkVal = $('#' + item.UniqueClientId).data('kendoComboBox').value();
                                    var search = $('#' + item.UniqueClientId).data('kendoComboBox').text();
                                    additionalFilter = '&search=' + search + '&fkVal=' + fkVal;

                                    return rootURL + 'Entity/GetFieldSource?idField=' + item.Id + '&idExtConn=' + this.idExtConn + '&filter=' + JSON.stringify(filter) + additionalFilter;
                                }
                            } else {
                                if (this.isPreview) {
                                    return rootURL + 'Entity/GetEmptyFieldSource?idField=' + item.Id;
                                }

                                let additionalFilter = '';

                                var fkVal = $('#' + item.UniqueClientId).data('kendoComboBox').value();
                                var search = $('#' + item.UniqueClientId).data('kendoComboBox').text();
                                additionalFilter = '&search=' + search + '&fkVal=' + fkVal;

                                return rootURL + 'Entity/GetFieldSource?idField=' + item.Id + '&idExtConn=' + this.idExtConn + additionalFilter;
                            }
                        }
                    }
                }
            },
            dataBound: () => {
                let val = $('#' + item.UniqueClientId).attr('initValue');
                if (val != null && val != '') {
                    $('#' + item.UniqueClientId).attr('initValue', null);

                    let cbo = $('#' + item.UniqueClientId).data("kendoComboBox");
                    cbo.dataSource.data().forEach(x => {
                        if (x.Id == val) {
                            cbo.value(val);
                            cbo.trigger('change');
                        }
                    });
                }
            }
        });

        if (item.IsReadOnly) {
            $("#" + item.UniqueClientId).data("kendoComboBox").readonly(true);
        }
    }

    _initGeomPickerModalMapControl(item) {
        if (item.IsReadOnly) {
            $("#" + item.UniqueClientId).attr('readonly', true);
        } else {
            $("#" + item.UniqueClientId + '-action').on('click', (evt) => {
                this.initModal(item.Label, '70%', null, false, null, true);

                $('#' + this.uniqueModalInnerId).append('<div class="xp-map-container xp-form-map" map-id="' + item.IdMap + '"></div>');
                $('#' + this.uniqueModalInnerId).css('overflow', 'hidden');
                let container = document.querySelector('.xp-map-container[map-id="' + item.IdMap + '"]');
                container.mapControl = new MapControl(item.IdMap, container, rootURL, item.IdMap + '-' + item.Id);
                container.mapControl.init().then(() => {
                    container.mapControl.addTemporaryVectorLayer({
                        uid: item.UniqueClientId,
                        name: item.Name,
                        geometryType: item.EntityField.DataSubType,
                        srid: item.EntityField.Srid,
                        geomField: item.EntityField.FieldName,
                        idField: 'id',
                        visible: true,
                        editable: true,
                        minFitScale: item.CtlProps.MinFitScale,
                        featureEditCallback: this._getFeatureEditedCallback()
                    }).then((result) => {
                        if (result != null && result.status == true) {
                            container.mapControl.isLoaded = true;

                            this._populateMap(container.mapControl, item);
                        }
                    });
                });
            });
        }
    }

    _getFeatureEditedCallback() {
        let callback = (result, uid) => {
            let field = this._searchFieldByUniqueId(this.metadata, uid);

            if (field != null) {
                if (field.CtlType == 'GeomPicker' && field.CtlProps.CtlSubType == 'MapView') {
                    $("#" + field.UniqueClientId).attr('current-value', result.length > 0 ? result[0] : '');

                    //if (result.length == 0) {
                    $event.notify(eventTypes.TEMPORARY_LAYER_SELECTION_CHANGED, { features: null, layerSettings: $("#" + field.UniqueClientId)[0].mapControl.layerHandler.getLayerById(field.Name)[0].get('temporarySettings'), isNew: true }, this, field.IdMap + '-' + field.Id);
                    //}
                } else if (field.CtlType == 'GeomPicker' && field.CtlProps.CtlSubType == 'ModalMap') {
                    $("#" + field.UniqueClientId).val(result[0]);

                    if (window['onFormMapFeatureEdited' + this.pageGuid] == null) {
                        this.closeModal(true);
                    }
                }

                if (this._isEligibleForValidation(field)) {
                    if (result.length > 0) {
                        this._decorateField(field, true);
                    } else {
                        this._decorateField(field, false);
                    }
                }

                if (window['onFormMapFeatureEdited' + this.pageGuid] != null && !this.isPreview) {
                    window['onFormMapFeatureEdited' + this.pageGuid](field);
                }
            }

            let dependants = this._getDependants(field.Guid);

            if (dependants != null && dependants.length > 0) {
                this._handleItemsState(dependants);

                let cascadedDependants = [];

                dependants.forEach(dependant => {
                    if (dependant.SqlWhere != null && dependant.SqlWhere != '' && dependant.SqlWhere.indexOf(item.EntityField.FieldName) >= 0) {
                        cascadedDependants.push(dependant);
                    }
                });

                this._handleCascadedItems(cascadedDependants);
            }

            //self check
            this._checkItemValidity(field);
        };

        return callback;
    }

    _initGeomPickerMapViewControl(item) {
        if (item.IdMap != null) {
            let container = document.querySelector('.xp-map-container[map-id="' + item.IdMap + '"]');
            $("#" + item.UniqueClientId)[0].mapControl = new MapControl(item.IdMap, container, rootURL, item.IdMap + '-' + item.Id);
            $("#" + item.UniqueClientId)[0].mapControl.init().then(() => {
                $("#" + item.UniqueClientId)[0].mapControl.addTemporaryVectorLayer({
                    uid: item.UniqueClientId,
                    name: item.Name,
                    geometryType: item.EntityField.DataSubType,
                    srid: item.EntityField.Srid,
                    geomField: item.EntityField.FieldName,
                    idField: 'id',
                    visible: true,
                    editable: !item.IsReadOnly,
                    minFitScale: item.CtlProps.MinFitScale,
                    featureEditCallback: this._getFeatureEditedCallback()
                }).then((result) => {
                    if (result != null && result.status == true) {
                        $("#" + item.UniqueClientId)[0].mapControl.isLoaded = true;
                    }
                });
            });
        }
    }

    _handleItemsState(dependants) {
        if (!this.isPreview) {
            dependants.forEach(dependant => {
                this._checkItemVisibility(dependant).then(() => {
                    if (this._getVisibleState(dependant)) {
                        this._checkItemReadonly(dependant).then(() => {
                            if (!this._getReadonlyState(dependant)) {
                                this._checkItemValidity(dependant);
                            }
                        });
                    }
                });
            });
        }
    }

    _handleCascadedItems(dependants) {
        dependants.forEach(dependant => {
            switch (dependant.CtlType) {
                case 'ComboBox': {
                    switch (this._getFieldControlSubType(dependant)) {
                        case 'ListView': break;//TO DO
                        case 'MultiSelect': this._handleCascadedMultiSelect(dependant);
                            break;
                        case 'TreeView': this._handleCascadedDropDownTree(dependant);
                            break;
                        default: this._handleCascadedCombobox(dependant);
                            break;
                    }
                }
                    break;
                default: break;
            }
        });
    }

    _handleCascadedMultiSelect(item) {
        let isEligible = true;
        let cbo = $('#' + item.UniqueClientId).data("kendoMultiSelect");

        item.DependsOnGuids.forEach(dependsOn => {
            let value = this._getItemValueByGuid(dependsOn);

            if (value == null || value === '') {
                isEligible = false;
            }
        });

        let val = cbo.value();
        if (val != null && val != '') {
            $('#' + item.UniqueClientId).attr('initValue', val);
        }

        if (isEligible) {
            cbo.readonly(false);
            cbo.value(null);
            cbo.trigger('change');
            cbo.dataSource.read();

        } else {
            cbo.value(null);
            cbo.trigger('change');
            cbo.readonly(true);
        }
    }

    _handleCascadedCombobox(item) {
        let isEligible = true;
        let cbo = $('#' + item.UniqueClientId).data("kendoComboBox");

        item.DependsOnGuids.forEach(dependsOn => {
            let value = this._getItemValueByGuid(dependsOn);

            if (value == null || value === '') {
                isEligible = false;
            }
        });

        let val = cbo.value();
        if (val != null && val != '') {
            $('#' + item.UniqueClientId).attr('initValue', val);
        }

        if (isEligible) {
            cbo.readonly(false);
            cbo.value(null);
            cbo.trigger('change');
            cbo.dataSource.read();

        } else {
            cbo.value(null);
            cbo.trigger('change');
            cbo.readonly(true);
        }
    }

    _handleCascadedDropDownTree(item) {
        let isEligible = true;
        let cbo = $('#' + item.UniqueClientId).data("kendoDropDownTree");

        item.DependsOnGuids.forEach(dependsOn => {
            let value = this._getItemValueByGuid(dependsOn);

            if (value == null || value === '') {
                isEligible = false;
            }
        });

        let val = cbo.value();
        if (val != null && val != '') {
            $('#' + item.UniqueClientId).attr('initValue', val);
        }

        if (isEligible) {
            cbo.readonly(false);
            cbo.value(null);
            cbo.trigger('change');
            cbo.dataSource.read();

        } else {
            cbo.value(null);
            cbo.trigger('change');
            cbo.readonly(true);
        }
    }

    _reloadDependantLayers() {
        let geomFieldIds = {};

        this.actionButtons.forEach(x => {
            if (x.SubType == 'SHOW_IN_MAP' || x.SubType == 'EDIT_GEOMETRY') {
                if (x.IdFieldTarget != null) {
                    geomFieldIds[x.IdFieldTarget] = {};
                }
            }
        });

        let geomFields = Object.keys(geomFieldIds);

        let maps = Array.from(document.getElementsByClassName('xp-map'));
        maps.forEach(map => {
            let layers = {};
            let mapControl = map.mapControl;

            geomFields.forEach(fieldId => {
                let foundLayers = mapControl.layerSettingsHandler.getAllLayersByGeometryField(fieldId);

                foundLayers.forEach(foundLayer => {
                    layers[foundLayer.Id] = {};
                });
            });

            let layerIds = Object.keys(layers);
            layerIds.forEach(layerId => {
                mapControl.refreshLayer(layerId);
            });
        });
    }

    _getItemValueByGuid(guid, serializeDate) {
        let item = this._getItemByGuid(guid, [this.metadata]);
        let value = null;
        if (item != null) {
            switch (item.CtlType) {
                case 'Switch': value = this._threeStateSwitchGetValue("#" + item.UniqueClientId);
                    break;
                case 'IntegerTextBox': value = $("#" + item.UniqueClientId).data('kendoNumericTextBox') != null ? $("#" + item.UniqueClientId).data('kendoNumericTextBox').value() : null;
                    break;
                case 'DatePicker': {
                    value = $("#" + item.UniqueClientId).data("kendoDatePicker") != null ? $("#" + item.UniqueClientId).data("kendoDatePicker").value() : null;
                    if (serializeDate) {
                        value = this._serializeDate(value);
                    }
                }
                    break;
                case 'NumericTextBox': value = $("#" + item.UniqueClientId).data('kendoNumericTextBox') != null ? $("#" + item.UniqueClientId).data('kendoNumericTextBox').value() : null;
                    break;
                case 'TextBox': value = $("#" + item.UniqueClientId).val();
                    break;
                case 'TextArea': value = $("#" + item.UniqueClientId).val();
                    break;
                case 'RichText': value = $("#" + item.UniqueClientId).data('kendoEditor') != null ? $("#" + item.UniqueClientId).data('kendoEditor').value() : null;
                    break;
                case 'DateTimePicker': {
                    value = $("#" + item.UniqueClientId).data("kendoDateTimePicker") != null ? $("#" + item.UniqueClientId).data("kendoDateTimePicker").value() : null;
                    if (serializeDate) {
                        value = this._serializeDateTime(value);
                    }
                }
                    break;
                case 'ComboBox': {
                    switch (this._getFieldControlSubType(item)) {
                        case 'ListView': value = $("#" + item.UniqueClientId).attr('current-value');
                            break;
                        case 'MultiSelect': value = $("#" + item.UniqueClientId).data('kendoMultiSelect').value();
                            break;
                        case 'TreeView': value = $("#" + item.UniqueClientId).data('kendoDropDownTree').value();
                            break;
                        default: value = $("#" + item.UniqueClientId).data('kendoComboBox') != null ? $("#" + item.UniqueClientId).data('kendoComboBox').value() : null;
                            break;
                    }
                }
                    break;
                case 'GeomPicker': {
                    switch (this._getFieldControlSubType(item)) {
                        case 'ModalMap': value = $("#" + item.UniqueClientId).val();
                            break;
                        case 'MapView': value = $("#" + item.UniqueClientId).attr('current-value');
                            break;
                    }
                }
                    break;
                default: break;
            }
        }

        return value;
    }

    _getItemByGuid(guid, items) {
        for (var item of items) {
            if (guid == item.Guid) {
                return item;
            }
            if (item.Items) {
                var result = this._getItemByGuid(guid, item.Items);
                if (result) {
                    return result;
                }
            }
        }
        return null;
    }

    _getDependants(itemId) {
        let result = [];

        this._searchDependantItem(this.metadata, itemId, result);

        return result;
    }

    _searchDependantItem(item, itemId, resultBag) {
        if (item.DependsOnGuids != null && item.DependsOnGuids.length > 0) {
            let matches = item.DependsOnGuids.filter(row => { return row == itemId; });

            if (matches != null && matches.length > 0) {
                resultBag.push(item);
            }
        }

        if (item.Items != null && item.Items.length > 0) {
            item.Items.forEach(child => {
                this._searchDependantItem(child, itemId, resultBag);
            });
        }
    }

    _animateProgress(id, total, current) {
        let percentage = Math.round(current / total * 100);

        var elem = $('#' + id + '-bar')[0];
        elem.style.width = percentage + '%';
        elem.innerHTML = percentage + '%';
    }

    _markFailedProcessing(id) {
        var elem = $('#' + id + '-bar')[0];
        elem.style.backgroundColor = 'red';
        $('#file-uploads-buttons').show();
    }

    _checkFileUploadAndSubmit() {
        let fileKeys = Object.keys(this.uploadedFiles);
        let filesToUpload = fileKeys.filter(row => { return !this.uploadedFiles[row].uploadedFileProcessed; });

        if (filesToUpload.length == 0) {
            this.closeModal(true);
            this._submitData(this.reloadAfterSubmit, this.ignoreNotificationAfterSubmit, this.initiatorIdAfterSubmit);
        }
    }

    _initFileControl(item) {
        const currentFormControl = this;

        let dropzoneOptions = {
            url: rootURL + "Upload/UploadChunk",
            params: function (files, xhr, chunk) {
                if (chunk) {

                    currentFormControl._animateProgress(item.UniqueClientId, chunk.file.upload.totalChunkCount, chunk.index);

                    return {
                        dzUuid: chunk.file.upload.uuid,
                        dzChunkIndex: chunk.index,
                        dzTotalFileSize: chunk.file.size,
                        dzCurrentChunkSize: chunk.dataBlock.data.size,
                        dzTotalChunkCount: chunk.file.upload.totalChunkCount,
                        dzChunkByteOffset: chunk.index * this.options.chunkSize,
                        dzChunkSize: this.options.chunkSize,
                        dzFileName: chunk.file.name
                    };
                }
            },
            uploadMultiple: false,
            maxFiles: 1,
            maxfilesexceeded: function (file) {
                this.removeAllFiles();
                this.addFile(file);
            },
            parallelUploads: 1,
            maxFilesize: 10240,
            chunking: true,
            forceChunking: true,
            parallelChunkUploads: false,
            chunkSize: 5000000,
            retryChunks: true,
            retryChunksLimit: 3,
            chunksUploaded: function (file, done) {
                currentFormControl._animateProgress(item.UniqueClientId, 1, 1);
                $.ajax({
                    type: "POST",
                    async: true,
                    url: rootURL + "Upload/CommitChunks?dzIdentifier=" + currentFormControl.uploadedFiles[item.UniqueClientId].file.upload.uuid
                        + "&fileName=" + encodeURIComponent(currentFormControl.uploadedFiles[item.UniqueClientId].file.name)
                        + "&expectedBytes=" + currentFormControl.uploadedFiles[item.UniqueClientId].file.size
                        + "&totalChunks=" + currentFormControl.uploadedFiles[item.UniqueClientId].file.upload.totalChunkCount,
                    success: function (data) {
                        if (data != null && data.StatusCode == 200) {
                            done();
                            currentFormControl.uploadedFiles[item.UniqueClientId].uploadedFileProcessed = true;
                            currentFormControl._checkFileUploadAndSubmit();
                        } else {
                            currentFormControl.uploadedFiles[item.UniqueClientId].file.accepted = false;
                            currentFormControl.dropzones[item.UniqueClientId].get(0).dropzone._errorProcessing([currentFormControl.uploadedFiles[item.UniqueClientId].file], data.ReasonPhrase);
                            currentFormControl._markFailedProcessing(item.UniqueClientId);
                        }
                    },
                    error: function (msg) {
                        currentFormControl.uploadedFiles[item.UniqueClientId].file.accepted = false;
                        currentFormControl.dropzones[item.UniqueClientId].get(0).dropzone._errorProcessing([currentFormControl.uploadedFiles[item.UniqueClientId].file], msg.responseText);
                        currentFormControl._markFailedProcessing(item.UniqueClientId);
                    }
                });
            },
            thumbnailWidth: 260,
            thumbnailHeight: 260,
            addRemoveLinks: true,
            autoProcessQueue: false,
            dictRemoveFile: this._getResource('File_RemoveUpload'),
            init: function () {
                this.on('error', function (file, errorMessage) {
                    $.ajax({
                        type: "DELETE",
                        url: rootURL + "Upload/DeleteCanceledChunks?dzIdentifier=" + file.upload.uuid,
                        async: true
                    });
                });


                var wrapperThis = this;

                this.on("addedfile", function (file) {
                    if (this.files[1] != null) {
                        this.removeFile(this.files[0]);
                    }

                    if (file.upload == null) {
                        currentFormControl.uploadedFiles[item.UniqueClientId].file = null;
                        currentFormControl.uploadedFiles[item.UniqueClientId].uploadedFileAdded = true;
                        currentFormControl.uploadedFiles[item.UniqueClientId].uploadedFileProcessed = true;
                    } else {

                        if (currentFormControl.uploadedFiles[item.UniqueClientId] == null) {
                            currentFormControl.uploadedFiles[item.UniqueClientId] = {};
                        }
                        currentFormControl.uploadedFiles[item.UniqueClientId].file = file;
                        currentFormControl.uploadedFiles[item.UniqueClientId].uploadedFileAdded = true;
                        currentFormControl.uploadedFiles[item.UniqueClientId].uploadedFileProcessed = false;
                    }


                    $('#' + item.UniqueClientId + '-img').hide();
                    $('#' + item.UniqueClientId + '-label').hide();

                    wrapperThis.emit("complete", file);
                    $(".dz-size").remove();
                    $(".dz-progress").remove();
                    $(".dz-error-message").remove();
                    $(".dz-success-mark").remove();
                    $(".dz-error-mark").remove();

                    if ($('#' + item.UniqueClientId + '-details-buttons').length > 0) {
                        $('#' + item.UniqueClientId + '-details-buttons').remove();
                    }

                    $("#" + item.UniqueClientId).append('<div class="dz-details-buttons" id="' + item.UniqueClientId + '-details-buttons"></div>');

                    $("#" + item.UniqueClientId + ' .dz-remove').appendTo($('#' + item.UniqueClientId + '-details-buttons'));
                    $("#" + item.UniqueClientId + ' .dz-remove')[0].innerHTML = '';
                    $("#" + item.UniqueClientId + ' .dz-remove').addClass('btn btn-danger fal fa-trash-alt d-inline');
                    if (currentFormControl._isEligibleForValidation(item)) {
                        currentFormControl._decorateField(item, true);
                    }

                    let dependants = currentFormControl._getDependants(item.Guid);

                    if (dependants != null && dependants.length > 0) {
                        currentFormControl._handleItemsState(dependants);

                        let cascadedDependants = [];

                        dependants.forEach(dependant => {
                            if (dependant.SqlWhere != null && dependant.SqlWhere != '' && dependant.SqlWhere.indexOf(item.EntityField.FieldName) >= 0) {
                                cascadedDependants.push(dependant);
                            }
                        });

                        currentFormControl._handleCascadedItems(cascadedDependants);
                    }

                    //self check
                    currentFormControl._checkItemValidity(item);
                });

                this.on("removedfile", function (file) {
                    $('#' + item.UniqueClientId + '-details-buttons').remove();
                    $('#' + item.UniqueClientId + '-img').show();
                    $('#' + item.UniqueClientId + '-label').show();
                    if (currentFormControl.uploadedFiles[item.UniqueClientId] != null) {
                        currentFormControl.uploadedFiles[item.UniqueClientId].uploadedFileAdded = false;
                    }

                    if (currentFormControl._isEligibleForValidation(item)) {
                        currentFormControl._decorateField(item, false);
                    }

                    let dependants = currentFormControl._getDependants(item.Guid);

                    if (dependants != null && dependants.length > 0) {
                        currentFormControl._handleItemsState(dependants);

                        let cascadedDependants = [];

                        dependants.forEach(dependant => {
                            if (dependant.SqlWhere != null && dependant.SqlWhere != '' && dependant.SqlWhere.indexOf(item.EntityField.FieldName) >= 0) {
                                cascadedDependants.push(dependant);
                            }
                        });

                        currentFormControl._handleCascadedItems(cascadedDependants);
                    }

                    //self check
                    currentFormControl._checkItemValidity(item);
                });
            }
        };

        if (item.EntityField.AcceptMimeType != null && item.EntityField.AcceptMimeType.trim() != '') {
            let acceptedMimeTypes = JSON.parse(item.EntityField.AcceptMimeType);
            dropzoneOptions.acceptedFiles = acceptedMimeTypes.join(',');
        }

        this.dropzones[item.UniqueClientId] = $("#" + item.UniqueClientId).dropzone(dropzoneOptions);
        if (item.IsReadOnly) {
            $('#' + item.UniqueClientId).addClass('disabled-control');
        }
    }

    _getTemplate() {
        let template = ``;

        if (this.metadata.UniqueClientId == null) {
            this.metadata.UniqueClientId = this._generateUUID();
            this.metadata.UniqueClientId = this._generateUUID();
        }

        if (this.metadata.TypeName == 'UILayoutDto') {
            template += `<div class="form-layout-wrapper" style="display: none; height: ` + (this.parentGuid != null ? `auto` : `calc(100% - 3.4rem)`) + `; ` + this._getWrapperStyle(this.metadata) + `"` + `" id="` + this.metadata.UniqueClientId + `-wrapper` + `"><div class="panel-content form-row col-sm-12` + (this.isFilter ? ` pr-2 pl-3 mt-3` : ``) + this._getClassName(this.metadata) + `" ui-type="` + this.metadata.TypeName + `" ui-id="` + this.metadata.Id + `" ui-entity-id="` + this.metadata.IdEntity + `" id="` + this.metadata.UniqueClientId + `"` + (this.metadata != null && this.metadata != '' ? ` ui-name="` + this.metadata.Name + `"` : ``) + ` style="` + this._getInnerStyle(this.metadata) + `"` + this._getAttributes(this.metadata) + `>`;

            if (this.metadata.Description != null && this.metadata.Description.trim() != '') {
                template += `<div class="form-row col-sm-12" style="margin-left: 0 !important; margin-right: 0 !important; ` + this._getDescriptionStyle(this.metadata) + `">` + this.metadata.Description + `</div>`;
            }
            template += this._getChildrenTemplate(this.metadata);

            if (this.isFilter) {
                template += this._getButtons();
                template += `</div></div>`;
            }
            else {
                template += `</div></div>`;
                template += this._getButtons();
            }

            template += `<div id="` + this.uniqueModalId + `"></div>`;
        }

        return template;
    }

    _getButtons() {
        let template = ``;

        if (this.isFilter) {
            template = `<div class="col-sm-12 mb-2">
                            <div class="form-group d-flex">
                                <button class="btn btn-secondary ml-auto" id="` + this.clearFilterButtonId + `" title="` + this._getResource('ClearFilter') + `" type="button"` + (this.isPreview ? ` disabled="disabled"` : ``) + `>` + this._getResource('ClearFilter') + `</button>
                                <button class="btn btn-primary ml-2" id="` + this.searchFilterButtonId + `" title="` + this._getResource('Filter') + `" type="button"` + (this.isPreview ? ` disabled="disabled"` : ``) + `>` + this._getResource('Filter') + `</button>
                            </div>
                        </div>`;
        } else {
            template = `<div class="panel-content border-faded border-left-0 border-right-0 border-bottom-0 d-flex flex-row align-items-right p-4 mr-0 ml-0 ` + (this.parentGuid != null && this.parentGuid != '' ? `mr-0 ml-0` : `mr-3 ml-3`) + `"` + (this.parentGuid != null && this.parentGuid != '' ? `` : ``) + `>` +
                this._getActionButtons()
                + `</div>`;
        }

        return template;
    }

    _getActionButtons() {
        let template = ``;
        let idx = 0;

        let hasMargin = false;

        this.actionButtons.forEach(actionButton => {
            if (actionButton.ClassName != null && actionButton.ClassName.indexOf('ml-auto') >= 0) {
                hasMargin = true;
            }
        });

        this.actionButtons.forEach(actionButton => {
            if (actionButton.SubType == 'SAVE' && !hasMargin) {
                actionButton.ClassName += ' ml-auto';
            } else if (actionButton.SubType == 'APPLY' && !hasMargin) {
                let saveExists = false;

                this.actionButtons.forEach(actionButton => {
                    if (actionButton.SubType == 'SAVE') {
                        saveExists = true;
                    }
                });

                if (!saveExists) {
                    actionButton.ClassName += ' ml-auto';
                }
            } else if (actionButton.SubType == 'CANCEL' && !hasMargin) {
                let saveExists = false;
                let applyExists = false;

                this.actionButtons.forEach(actionButton => {
                    if (actionButton.SubType == 'SAVE') {
                        saveExists = true;
                    } else if (actionButton.SubType == 'APPLY') {
                        applyExists = true;
                    }
                });

                if (!saveExists & !applyExists) {
                    actionButton.ClassName += ' ml-auto';
                }
            }

            let otherAttributes = '';

            if (actionButton.HtmlAttributes != null && actionButton.HtmlAttributes != '') {
                var attrKeys = [];

                if (actionButton.HtmlAttributes.toJSON != null) {
                    attrKeys = Object.keys(actionButton.HtmlAttributes.toJSON());
                } else {
                    attrKeys = Object.keys(actionButton.HtmlAttributes);
                }

                for (var i = 0; i < attrKeys.length; i++) {
                    otherAttributes += actionButton.HtmlAttributes[attrKeys[i]] + ' ';
                }
            }

            let actionButtonIconTemplate = ``;

            if (actionButton.Icon != null && actionButton.Icon != '') {
                actionButtonIconTemplate = `<i class="` + actionButton.Icon + ` mr-2"></i>`
            }

            template += `<button id="form-action-` + (actionButton.Id != 0 ? actionButton.Id : this.currentActionId) + `" class="btn ` + actionButton.ClassName + `" ` + otherAttributes + ` title="` + this._getActionResource(actionButton.Text) + `" type="button"` + (this.isPreview ? ` disabled="disabled"` : ``) + (this.isPreview ? `` : ` style="display:none;"`) + `">` + actionButtonIconTemplate + this._getActionResource(actionButton.Text) + `</button>`;

            if (actionButton.Id == 0) {
                this.currentActionId--;
            }
            idx++;
        });

        return template;
    }



    _getChildrenTemplate(item) {
        let template = ``;

        if (item.Items != null && item.Items.length > 0) {
            item.Items.forEach(child => {
                if (child.UniqueClientId == null) {
                    child.UniqueClientId = this._generateUUID();
                }

                switch (child.TypeName) {
                    case 'UITabControlDto': template += this._getTabControlTemplate(child);
                        break;
                    case 'UITabPageDto': template += this._getTabPageTemplate(child);
                        break;
                    case 'UIGroupDto': template += this._getCollapsableGroupTemplate(child);
                        break;
                    case 'UIParagraphDto': template += this._getParagraphTemplate(child);
                        break;
                    case 'UISublistDto': template += this._getSublistTemplate(child);
                        break;
                    case 'UIMapViewDto': template += this._getMapViewTemplate(child);
                        break;
                    case 'UIFieldControlDto': template += this._getFieldControlTemplate(child);
                        break;
                    case 'UICustomFieldControlDto': template += this._getFieldControlTemplate(child);
                        break;
                    default: template += ``;
                        break;
                }
            });
        }

        return template;
    }

    _getTabControlTemplate(item) {
        let template = `<div class="panel-content p-0` + this._getLayoutCols(item) + this._getClassName(item) + `" ui-type="` + item.TypeName + `" ui-id="` + item.Id + `" id="` + item.UniqueClientId + `"` + (item.Name != null && item.Name != '' ? ` ui-name="` + item.Name + `"` : ``) + ` style="` + this._getWrapperStyle(item) + `"` + this._getAttributes(item) + `><ul class="nav nav-tabs" role="tablist">`;

        if (item.Items != null && item.Items.length > 0) {
            let firstActive = false;
            let pagesCount = 0;
            item.Items.forEach(child => {
                if (child.TypeName == 'UITabPageDto') {
                    if (child.UniqueClientId == null) {
                        child.UniqueClientId = this._generateUUID();
                    }

                    if (!firstActive) {
                        child.IsPageActive = true;
                    } else {
                        child.IsPageActive = false;
                    }

                    template += `<li class="nav-item" onclick="getXpForm('` + this.uniqueId + `')._tabOnClick('` + child.UniqueClientId + `')" style="cursor: pointer; ` + this._getPageButtonStyle(item) + `"><a id="` + child.UniqueClientId + `-anchor" class="nav-link` + (!firstActive ? ` active` : ``) + `" data-toggle="tab" role="tab" style=` + this._getPageLinkStyle(item) + `>` + (child.Text != null ? child.Text : this._getResource(child.TypeName)) + `</a></li>`;

                    firstActive = true;
                    pagesCount++;
                }
            });

            if (pagesCount == 0) {
                return ``;
            }
        } else {
            return ``;
        }

        template += `</ul>`;

        template += `<div class="tab-content p-0 pt-3" style="` + this._getPageWrapperStyle(item) + `">`;
        template += this._getChildrenTemplate(item);
        template += `</div></div>`;

        return template;
    }

    _getTabPageTemplate(item) {
        let template = `<div class="tab-pane fade` + (item.IsPageActive ? ` show active` : ``) + this._getClassName(item) + `" ui-type="` + item.TypeName + `" ui-id="` + item.Id + `" id="` + item.UniqueClientId + `" role="tabpanel"` + (item.Name != null && item.Name != '' ? ` ui-name="` + item.Name + `"` : ``) + ` style="` + this._getWrapperStyle(item) + ` display: flex; flex-wrap: wrap;"` + this._getAttributes(item) + `>`;
        template += this._getChildrenTemplate(item);
        template += `</div>`;
        return template;
    }

    _getCollapsableGroupTemplate(item) {
        let template = `<div class="accordion accordion-outline` + this._getLayoutCols(item) + this._getClassName(item) + `" id="` + item.UniqueClientId + `" ui-type="` + item.TypeName + `" ui-id="` + item.Id + `"` + (item.Name != null && item.Name != '' ? ` ui-name="` + item.Name + `"` : ``) + ` style="` + this._getWrapperStyle(item) + `"` + this._getAttributes(item) + `>`;
        template += `<div class="card" style="` + this._getCardStyle(item) + `">`;
        template += `<div class="card-header" style="height: 2rem; ` + this._getCardHeaderStyle(item) + `" onclick="getXpForm('` + this.uniqueId + `')._accordionOnClick('` + item.UniqueClientId + `', ` + item.Collapsable + `)">
                        <a id="` + item.UniqueClientId + `-anchor" href="javascript:void(0);" class="card-title` + (item.Collapsed ? ' collapsed' : ``) + `" style="padding: 0.5rem 0.5rem; ` + this._getCardHeaderLabelStyle(item) + `" aria-expanded="` + (!item.Collapsed ? 'true' : `false`) + `">` +
            (item.Text != null ? item.Text : this._getResource(item.TypeName))
            + `<span class="ml-auto">
                                <span class="collapsed-reveal">
                                    <i class="fal fa-minus fs-xl"></i>
                                </span>
                                <span class="collapsed-hidden">
                                    <i class="fal fa-plus fs-xl"></i>
                                </span>
                            </span>
                        </a>
                    </div>`;
        template += `<div id="` + item.UniqueClientId + `-inner" class="collapse` + (!item.Collapsed ? ' show' : ``) + `" style="` + this._getCardInnerStyle(item) + `">
                                <div class="card-body form-row">`;
        template += this._getChildrenTemplate(item);
        template += `</div>`;
        template += `</div>`;
        template += `</div>`;
        template += `</div>`;

        return template;
    }

    _getParagraphTemplate(item) {
        let template = `<div class="` + this._getLayoutCols(item) + this._getClassName(item) + ` form-group" id="` + item.UniqueClientId + `-wrapper" style="` + this._getWrapperStyle(item) + `">`;

        if (item.Label != null && item.Label.trim() != '') {
            template += `<label class="form-label" style="` + this._getLabelStyle(item) + `">` + item.Label + `</label>`;
        }

        if (item.Description != null && item.Description.trim() != '') {
            template += `<div class="form-field-description" style="padding: 0.5rem 0.5rem; margin-bottom: 0.5rem; background: #eef7fd; opacity: 0.8; font-weight: 400; font-size: 0.875rem; border-radius: 8px; width: fit-content; ` + this._getDescriptionStyle(item) + `"><span style="color:indianred; padding-right: 0.25rem;">*</span>` + item.Description + `</div>`;
        }

        template += `<div class="form-row mr-0 ml-0 col-12` + this._getClassName(item) + `" id="` + item.UniqueClientId + `" ui-type="` + item.TypeName + `" ui-id="` + item.Id + `"` + (item.Name != null && item.Name != '' ? ` ui-name="` + item.Name + `"` : ``) + ` style="` + this._getInnerStyle(item) + `"` + this._getAttributes(item) + `>`;
        template += this._getChildrenTemplate(item);
        template += `</div>`;
        template += `</div>`;

        return template;
    }

    _getMapViewTemplate(item) {
        let template = `<div class="` + this._getLayoutCols(item) + this._getClassName(item) + ` form-group" id="` + item.UniqueClientId + `-wrapper" style="` + this._getWrapperStyle(item) + `">`;
        if (item.Label != null && item.Label.trim() != '') {
            template += `<label class="form-label" style="` + this._getLabelStyle(item) + `">` + item.Label + `</label>`;
        }

        if (item.Description != null && item.Description.trim() != '') {
            template += `<div class="form-field-description" style="padding: 0.5rem 0.5rem; margin-bottom: 0.5rem; background: #eef7fd; opacity: 0.8; font-weight: 400; font-size: 0.875rem; border-radius: 8px; width: fit-content; ` + this._getDescriptionStyle(item) + `"><span style="color:indianred; padding-right: 0.25rem;">*</span>` + item.Description + `</div>`;
        }

        template += `<div class="xp-mapview-container" id="` + item.UniqueClientId + `" ui-type="` + item.TypeName + `" ui-id="` + item.Id + `"` + (item.Name != null && item.Name != '' ? ` ui-name="` + item.Name + `"` : ``) + ` style="` + this._getInnerStyle(item) + `"` + this._getAttributes(item) + `>
                        <div class="xp-map-container xp-form-map" map-id="` + item.IdMap + `"></div>
                    </div>`;

        template += `</div>`;

        return template;
    }

    _getSublistTemplate(item) {
        item.isLoaded = false;
        let template = `<div class="` + this._getLayoutCols(item) + this._getClassName(item) + ` form-group" id="` + item.UniqueClientId + `-wrapper" style="` + this._getWrapperStyle(item) + `">`;
        if (item.Label != null && item.Label.trim() != '') {
            template += `<label class="form-label" style="` + this._getLabelStyle(item) + `">` + item.Label + `</label>`;
        }

        if (item.Description != null && item.Description.trim() != '') {
            template += `<div class="form-field-description" style="padding: 0.5rem 0.5rem; margin-bottom: 0.5rem; background: #eef7fd; opacity: 0.8; font-weight: 400; font-size: 0.875rem; border-radius: 8px; width: fit-content; ` + this._getDescriptionStyle(item) + `"><span style="color:indianred; padding-right: 0.25rem;">*</span>` + item.Description + `</div>`;
        }

        template += `<div class="xp-list-container" id="` + item.UniqueClientId + `" ui-type="` + item.TypeName + `" ui-id="` + item.Id + `"` + (item.Name != null && item.Name != '' ? ` ui-name="` + item.Name + `"` : ``) + ` style="` + this._getInnerStyle(item) + `"` + this._getAttributes(item) + `></div>`;

        template += `</div>`;

        return template;
    }

    _getFieldControlSubType(item) {
        if (item.CtlProps != null) {
            return item.CtlProps.CtlSubType;
        }

        return null;
    }

    _getFieldControlTemplate(item) {
        let wrapperStyle = '';

        if (!this.isFilter) {
            wrapperStyle = 'display: none;';
        } else if (item.Hidden) {
            wrapperStyle = 'display: none;';
        }

        let template = `<div class="form-item-wrapper form-group` + this._getLayoutCols(item) + this._getClassName(item) + `" id="` + item.UniqueClientId + `-wrapper" style="` + wrapperStyle + this._getWrapperStyle(item) + `">`;

        if (item.CtlType == 'Switch') {
            template += `<label class="form-label col-sm-12 pl-0" style="` + this._getLabelStyle(item) + `">` + (item.Label != null ? item.Label : 'N/A') + `</label>`;
            if (item.Description != null && item.Description.trim() != '') {
                template += `<div class="form-field-description col-sm-12" style="padding: 0.5rem 0.5rem; margin-bottom: 0.5rem; background: #eef7fd; opacity: 0.8; font-weight: 400; font-size: 0.875rem; border-radius: 8px; width: fit-content; ` + this._getDescriptionStyle(item) + `"><span style="color:indianred; padding-right: 0.25rem;">*</span>` + item.Description + `</div>`;
            }
            template += this._getFieldTypeControlTemplate(item);
        } else {
            template += `<label class="form-label" style="` + this._getLabelStyle(item) + `">` + (item.Label != null ? item.Label : 'N/A') + `</label>`;
            if (item.Description != null && item.Description.trim() != '') {
                template += `<div class="form-field-description" style="padding: 0.5rem 0.5rem; margin-bottom: 0.5rem; background: #eef7fd; opacity: 0.8; font-weight: 400; font-size: 0.875rem; border-radius: 8px; width: fit-content; ` + this._getDescriptionStyle(item) + `"><span style="color:indianred; padding-right: 0.25rem;">*</span>` + item.Description + `</div>`;
            }
            template += this._getFieldTypeControlTemplate(item);
        }

        template += `</div>`;

        return template;
    }

    _getFieldTypeControlTemplate(item) {
        let template = ``;

        if (item.CtlType != null) {
            switch (item.CtlType) {
                case 'Switch': template = this._getSwitchFieldTypeControlTemplate(item);
                    break;
                case 'IntegerTextBox': template = this._getIntegerTextBoxFieldTypeControlTemplate(item);
                    break;
                case 'NumericTextBox': template = this._getNumericTextBoxFieldTypeControlTemplate(item);
                    break;
                case 'TextBox': template = this._getTextBoxFieldTypeControlTemplate(item);
                    break;
                case 'TextArea': template = this._getTextAreaFieldTypeControlTemplate(item);
                    break;
                case 'RichText': template = this._getRichTextFieldTypeControlTemplate(item);
                    break;
                case 'DatePicker': template = this._getDatePickerFieldTypeControlTemplate(item);
                    break;
                case 'DateTimePicker': template = this._getDateTimePickerFieldTypeControlTemplate(item);
                    break;
                case 'ComboBox': {
                    switch (this._getFieldControlSubType(item)) {
                        case 'ListView': template = this._getComboBoxListViewFieldTypeControlTemplate(item);
                            break;
                        case 'MultiSelect': template = this._getMultiSelectFieldTypeControlTemplate(item);
                            break;
                        case 'TreeView': template = this._getDropDownTreeFieldTypeControlTemplate(item);
                            break;
                        default: template = this._getComboBoxFieldTypeControlTemplate(item);
                            break;
                    }
                }
                    break;
                case 'GeomPicker': {
                    switch (this._getFieldControlSubType(item)) {
                        case 'ModalMap': template = this._getGeomPickerModalMapFieldTypeControlTemplate(item);
                            break;
                        case 'MapView': template = this._getGeomPickerMapViewFieldTypeControlTemplate(item);
                            break;
                    }
                }
                    break;
                case 'File': template = this._getFileFieldTypeControlTemplate(item);
                    break;
                default: template = ``;
                    break;
            }
        }

        return template;
    }

    _getSwitchFieldTypeControlTemplate(item) {
        return `<div id="` + item.UniqueClientId + `" ui-type="` + item.TypeName + `" ui-id="` + item.Id + `"` + (item.Name != null && item.Name != '' ? ` ui-name="` + item.Name + `"` : ``) + ` style="` + this._getInputStyle(item) + `"` + this._getAttributes(item) + `></div>
                <span class="form-item-validation" id="` + item.UniqueClientId + `-validation" style="color: #FF5733; font-weight: 500; display: none;">` + this._getFieldValidationMessage(item) + `</span>`;
    }

    _getIntegerTextBoxFieldTypeControlTemplate(item) {
        return `<input id="` + item.UniqueClientId + `" class="form-control" autocomplete="off" ui-type="` + item.TypeName + `" ui-id="` + item.Id + `"` + (item.Name != null && item.Name != '' ? ` ui-name="` + item.Name + `"` : ``) + ` style="` + this._getInputStyle(item) + `"` + this._getAttributes(item) + `/>
                <span class="form-item-validation" id="` + item.UniqueClientId + `-validation" style="color: #FF5733; font-weight: 500; display: none;">` + this._getFieldValidationMessage(item) + `</span>`;
    }

    _getNumericTextBoxFieldTypeControlTemplate(item) {
        return `<input id="` + item.UniqueClientId + `" class="form-control" autocomplete="off" ui-type="` + item.TypeName + `" ui-id="` + item.Id + `"` + (item.Name != null && item.Name != '' ? ` ui-name="` + item.Name + `"` : ``) + ` style="` + this._getInputStyle(item) + `"` + this._getAttributes(item) + `/>
                <span class="form-item-validation" id="` + item.UniqueClientId + `-validation" style="color: #FF5733; font-weight: 500; display: none;">` + this._getFieldValidationMessage(item) + `</span>`;
    }

    _getTextBoxFieldTypeControlTemplate(item) {
        return `<input type="text" id="` + item.UniqueClientId + `" class="form-control normal-input" autocomplete="off" ui-type="` + item.TypeName + `" ui-id="` + item.Id + `"` + (item.Name != null && item.Name != '' ? ` ui-name="` + item.Name + `"` : ``) + ` style="` + this._getInputStyle(item) + `"` + this._getAttributes(item) + `/>
                <span class="form-item-validation" id="` + item.UniqueClientId + `-validation" style="color: #FF5733; font-weight: 500; display: none;">` + this._getFieldValidationMessage(item) + `</span>`;
    }

    _getTextAreaFieldTypeControlTemplate(item) {
        return `<textarea id="` + item.UniqueClientId + `" class="form-control normal-input" autocomplete="off" ui-type="` + item.TypeName + `" ui-id="` + item.Id + `"` + (item.Name != null && item.Name != '' ? ` ui-name="` + item.Name + `"` : ``) + ` style="` + this._getInputStyle(item) + `"` + this._getAttributes(item) + `></textarea>
                <span class="form-item-validation" id="` + item.UniqueClientId + `-validation" style="color: #FF5733; font-weight: 500; display: none;">` + this._getFieldValidationMessage(item) + `</span>`;
    }

    _getRichTextFieldTypeControlTemplate(item) {
        return `<textarea id="` + item.UniqueClientId + `" class="form-control normal-input" autocomplete="off" ui-type="` + item.TypeName + `" ui-id="` + item.Id + `"` + (item.Name != null && item.Name != '' ? ` ui-name="` + item.Name + `"` : ``) + ` style="` + this._getInputStyle(item) + `"` + this._getAttributes(item) + `></textarea>
                <span class="form-item-validation" id="` + item.UniqueClientId + `-validation" style="color: #FF5733; font-weight: 500; display: none;">` + this._getFieldValidationMessage(item) + `</span>`;
    }

    _getDatePickerFieldTypeControlTemplate(item) {
        return `<input id="` + item.UniqueClientId + `" class="form-control" ui-type="` + item.TypeName + `" ui-id="` + item.Id + `"` + (item.Name != null && item.Name != '' ? ` ui-name="` + item.Name + `"` : ``) + ` autocomplete="off" style="` + this._getInputStyle(item) + `"` + this._getAttributes(item) + `/>
                <span class="form-item-validation" id="` + item.UniqueClientId + `-validation" style="color: #FF5733; font-weight: 500; display: none;">` + this._getFieldValidationMessage(item) + `</span>`;
    }

    _getDateTimePickerFieldTypeControlTemplate(item) {
        return `<input id="` + item.UniqueClientId + `" class="form-control" ui-type="` + item.TypeName + `" ui-id="` + item.Id + `"` + (item.Name != null && item.Name != '' ? ` ui-name="` + item.Name + `"` : ``) + ` autocomplete="off" style="` + this._getInputStyle(item) + `"` + this._getAttributes(item) + `/>
                <span class="form-item-validation" id="` + item.UniqueClientId + `-validation" style="color: #FF5733; font-weight: 500; display: none;">` + this._getFieldValidationMessage(item) + `</span>`;
    }

    _getFileFieldTypeControlTemplate(item) {
        return `<div class="dropzone needsclick d-block d-flex justify-content-center align-items-center" id="` + item.UniqueClientId + `" ui-type="` + item.TypeName + `" ui-id="` + item.Id + `"` + (item.Name != null && item.Name != '' ? ` ui-name="` + item.Name + `"` : ``) + ` style="width: 100%; ` + this._getInputStyle(item) + `"` + this._getAttributes(item) + `>
                    <div class="dz-message needsclick" style="margin:auto;">
                        <i class="fal fa-cloud-upload text-muted" id="` + item.UniqueClientId + `-img" style="justify-content: center; display: flex;"></i>
                        <span class="text-uppercase ml-2" style="text-align: center;" id="` + item.UniqueClientId + `-label">` + this._getResource('File_UploadHint') + `</span>
                    </div>
                </div>
                <span class="form-item-validation" id="` + item.UniqueClientId + `-validation" style="color: #FF5733; font-weight: 500; display: none;">` + this._getFieldValidationMessage(item) + `</span>`;
    }

    _getMultiSelectFieldTypeControlTemplate(item) {
        return `<div id="` + item.UniqueClientId + `" ui-type="` + item.TypeName + `" ui-id="` + item.Id + `"` + (item.Name != null && item.Name != '' ? ` ui-name="` + item.Name + `"` : ``) + ` style="width: 100%; ` + this._getInputStyle(item) + `"` + this._getAttributes(item) + `></div>
                <span class="form-item-validation" id="` + item.UniqueClientId + `-validation" style="color: #FF5733; font-weight: 500; display: none;">` + this._getFieldValidationMessage(item) + `</span>`;
    }

    _getDropDownTreeFieldTypeControlTemplate(item) {
        return `<div id="` + item.UniqueClientId + `" ui-type="` + item.TypeName + `" ui-id="` + item.Id + `"` + (item.Name != null && item.Name != '' ? ` ui-name="` + item.Name + `"` : ``) + ` style="width: 100%; ` + this._getInputStyle(item) + `"` + this._getAttributes(item) + `></div>
                <span class="form-item-validation" id="` + item.UniqueClientId + `-validation" style="color: #FF5733; font-weight: 500; display: none;">` + this._getFieldValidationMessage(item) + `</span>`;
    }

    _getComboBoxFieldTypeControlTemplate(item) {
        return `<div id="` + item.UniqueClientId + `" ui-type="` + item.TypeName + `" ui-id="` + item.Id + `"` + (item.Name != null && item.Name != '' ? ` ui-name="` + item.Name + `"` : ``) + ` style="width: 100%; ` + this._getInputStyle(item) + `"` + this._getAttributes(item) + `></div>
                <span class="form-item-validation" id="` + item.UniqueClientId + `-validation" style="color: #FF5733; font-weight: 500; display: none;">` + this._getFieldValidationMessage(item) + `</span>`;
    }

    _getComboBoxListViewFieldTypeControlTemplate(item) {
        return `<div id="` + item.UniqueClientId + `" ui-type="` + item.TypeName + `" ui-id="` + item.Id + `"` + (item.Name != null && item.Name != '' ? ` ui-name="` + item.Name + `"` : ``) + ` style="width: 100%; ` + this._getInputStyle(item) + `"` + this._getAttributes(item) + ` current-value="">
                    <div id="` + item.UniqueClientId + `-img" class="justify-content-center align-items-center" style="width: 100%; border: 2px dashed #dedede; border-radius: 5px; background: #f5f5f5; padding: 0.5rem; height: 150px; cursor: pointer; display:none;">
                        <div class="d-flex justify-content-center" style="height: 100%; width: 50%; background-color: #3c3c3c;">
                            <img src="" style="height: 100%;"></img>
                        </div>
                        <div class="d-flex justify-content-center" style="height: 100%; width: 50%; flex-direction: column; align-content: center; flex-wrap: wrap; text-align: center;">
                            <span class="list-view-selection-title" style="font-weight: bold;"></span>
                            <span class="list-view-selection-description"></span>
                        </div>
                    </div>
                    <div id="` + item.UniqueClientId + `-placeholder" class="d-flex justify-content-center list-view-body align-items-center" style="width: 100%; flex-wrap: wrap; border: 2px dashed #dedede; border-radius: 5px; background: #f5f5f5; padding: 0.5rem; height: 150px; cursor: pointer;">
                        <div style="margin:auto; text-align: center; width: 100%;">
                            <i class="fal fa-hand-pointer text-muted" style="font-size: 3rem; width: 100%; padding-bottom: 0.25rem;"></i>
                            <span class="text-uppercase ml-2" style="text-align: center; font-size: initial;">` + this._getResource('ComboBoxSelectViewHint') + `</span>
                        </div>
                    </div>
                </div>
                <span class="form-item-validation" id="` + item.UniqueClientId + `-validation" style="color: #FF5733; font-weight: 500; display: none;">` + this._getFieldValidationMessage(item) + `</span>`;
    }

    _getGeomPickerModalMapFieldTypeControlTemplate(item) {
        return `<span class="d-flex">
                    <input type="text" id="` + item.UniqueClientId + `" class="form-control normal-input" autocomplete="off" ui-type="` + item.TypeName + `" ui-id="` + item.Id + `"` + (item.Name != null && item.Name != '' ? ` ui-name="` + item.Name + `"` : ``) + ` style="border-bottom-right-radius: 0px !important; border-top-right-radius: 0px !important;` + this._getInputStyle(item) + `"` + this._getAttributes(item) + `/>
                    <button id="` + item.UniqueClientId + `-action" class="btn btn-primary fal fa-map-marker-edit" style="border-bottom-left-radius: 0px !important; border-top-left-radius: 0px !important; padding-left: 0.55rem !important; padding-right: 0.55rem !important;"></button>
                </span>
                <span class="form-item-validation" id="` + item.UniqueClientId + `-validation" style="color: #FF5733; font-weight: 500; display: none;">` + this._getFieldValidationMessage(item) + `</span>`;
    }

    _getGeomPickerMapViewFieldTypeControlTemplate(item) {
        return `<div id="` + item.UniqueClientId + `" ui-type="` + item.TypeName + `" ui-id="` + item.Id + `"` + (item.Name != null && item.Name != '' ? ` ui-name="` + item.Name + `"` : ``) + ` style="position:relative; width: 100%; ` + this._getInputStyle(item) + `"` + this._getAttributes(item) + ` current-value="">
                    <div class="xp-map-container xp-form-map" map-id="` + item.IdMap + `"></div>
                     <span class="form-item-validation" id="` + item.UniqueClientId + `-validation" style="color: #FF5733; font-weight: 500; display: none;">` + this._getFieldValidationMessage(item) + `</span>
                </div>`;
    }

    _getFieldValidationMessage(item) {
        if (this.isFilter) {
            return '';
        }
        return this._getResource('ItemValidationMessage').replaceAll('{FieldLabel}', item.Label);
    }

    _disposeForm() {
        this.metadata = null;
        if ($('#' + this.container)[0] != null) {
            $('#' + this.container)[0].innerHTML = '';
        }

    }

    _getResource(name) {
        if (this.localization[name] != null && this.localization[name].trim() != '') {
            return this.localization[name];
        }

        return name;
    }

    _getCustomFormResource(name) {
        if (this.customFormResources[name] != null && this.customFormResources[name].trim() != '') {
            return this.customFormResources[name];
        }

        return name;
    }

    _getActionResource(name) {
        if (name == 'EDIT' || name == 'DELETE' || name == 'SHOW_IN_MAP' || name == 'EDIT_GEOMETRY' || name == 'SAVE' || name == 'CANCEL' || name == 'APPLY' || name == 'SELECT_FROM_MAP') {
            name = 'ElementAction_' + name;
        }

        if (this.actionLocalization[name] != null && this.actionLocalization[name].trim() != '') {
            return this.actionLocalization[name];
        }

        return name;
    }

    _tabOnClick(id) {
        let sublists = $('#' + id).find('.xp-list-container');

        if (sublists.length > 0) {
            for (let i = 0; i < sublists.length; i++) {
                let sublist = sublists[i];

                let sublistMetadata = this._searchFieldByUniqueId(this.metadata, sublist.id);

                if (sublistMetadata != null && !sublistMetadata.isLoaded) {
                    this._initSublistControl(sublistMetadata, false);
                    sublistMetadata.isLoaded = true;
                }
            }
        }

        $('#' + id).parent().parent().find('.nav-link').removeClass('active');
        $('#' + id).parent().parent().find('.nav-link').attr('aria-selected', 'false');
        $('#' + id + '-anchor').addClass('active');
        $('#' + id + '-anchor').attr('aria-selected', 'true');

        $('#' + id).addClass('show');
        $('#' + id).addClass('active');

        $('#' + id).siblings().removeClass('show');
        $('#' + id).siblings().removeClass('active');

        let lists = $('.k-grid-header:visible');

        for (var i = 0; i < lists.length; i++) {
            let list = lists[i];
            let listItem = $(list).parent();

            if (listItem.data('kendoGrid')) {
                listItem.data('kendoGrid').resize();
            } else if (listItem.parent().data('kendoGrid')) {
                listItem.parent().data('kendoGrid').resize();
            }
        }

        //this.lastChosenTab = id;

        if (this.saveTabs && this.objectId != null && this.objectId != 0) {
            let formTabs = sessionStorage.getItem('formTabs');

            if (formTabs != null && formTabs.trim() != '') {
                formTabs = JSON.parse(formTabs);
            } else {
                formTabs = {};
            }

            let tabMetadata = this.getFieldMetadataByUniqueId(id);

            if (tabMetadata != null) {
                formTabs[xapp.currentApp + '_' + this.formId + '_' + this.objectId] = tabMetadata.Id;

                sessionStorage.setItem('formTabs', JSON.stringify(formTabs));
            }
        }
    }

    _accordionOnClick(id, collapsable) {
        if (collapsable) {
            if ($('#' + id + '-anchor').hasClass('collapsed')) {
                $('#' + id + '-anchor').attr('aria-expanded', true);
                $('#' + id + '-anchor').removeClass('collapsed');
                $('#' + id + '-inner').addClass('show');
            } else {
                $('#' + id + '-anchor').attr('aria-expanded', false);
                $('#' + id + '-anchor').addClass('collapsed');
                $('#' + id + '-inner').removeClass('show');
            }
        }

        let lists = $('.k-grid-header:visible');

        for (var i = 0; i < lists.length; i++) {
            let list = lists[i];
            let listItem = $(list).parent();

            if (listItem.data('kendoGrid')) {
                listItem.data('kendoGrid').resize();
            } else if (listItem.parent().data('kendoGrid')) {
                listItem.parent().data('kendoGrid').resize();
            }
        }
    }

    _generateUUID() {
        var d = new Date().getTime();
        var d2 = ((typeof performance !== 'undefined') && performance.now && (performance.now() * 1000)) || 0;
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            var r = Math.random() * 16;
            if (d > 0) {
                r = (d + r) % 16 | 0;
                d = Math.floor(d / 16);
            } else {
                r = (d2 + r) % 16 | 0;
                d2 = Math.floor(d2 / 16);
            }
            return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
        }).replaceAll('-', '');
    }

    _getLayoutCols(item) {
        if (item.LayoutCols != null && item.LayoutCols != '' && item.LayoutCols > 0) {
            if (item.LayoutCols > 12) {
                return ' col-sm-12';
            } else {
                return ' col-sm-' + item.LayoutCols;
            }
        } else if (item.TypeName == 'UIFieldControlDto' || item.TypeName == 'UICustomFieldControlDto') {
            return ' col-sm-6';
        }

        return ' col-sm-12';
    }

    _getClassName(item) {
        if (item.ClassName != null && item.ClassName != '') {
            return ' ' + item.ClassName;
        }

        return '';
    }

    _getStyle(item) {
        let style = '';

        if (item.Style != null && item.Style.trim() != '') {
            return style + item.Style.trim();
        } else {
            return style;
        }
    }

    _getWrapperStyle(item) {
        let style = '';

        if (item.Style != null && item.Style.trim() != '' && JSON.parse(item.Style).styleWrapper != null) {
            return style + JSON.parse(item.Style).styleWrapper.trim().replaceAll('\n', '');
        } else {
            return style;
        }
    }

    _getInputStyle(item) {
        let style = '';

        if (item.Style != null && item.Style.trim() != '' && JSON.parse(item.Style).styleInput != null) {
            return style + JSON.parse(item.Style).styleInput.trim().replaceAll('\n', '');
        } else {
            return style;
        }
    }

    _getDescriptionStyle(item) {
        let style = '';

        if (item.Style != null && item.Style.trim() != '' && JSON.parse(item.Style).styleDescription != null) {
            return style + JSON.parse(item.Style).styleDescription.trim().replaceAll('\n', '');
        } else {
            return style;
        }
    }

    _getLabelStyle(item) {
        let style = '';

        if (item.Style != null && item.Style.trim() != '' && JSON.parse(item.Style).styleLabel != null) {
            return style + JSON.parse(item.Style).styleLabel.trim().replaceAll('\n', '');
        } else {
            return style;
        }
    }

    _getInnerStyle(item) {
        let style = '';

        if (item.Style != null && item.Style.trim() != '' && JSON.parse(item.Style).styleInner != null) {
            return style + JSON.parse(item.Style).styleInner.trim().replaceAll('\n', '');
        } else {
            return style;
        }
    }

    _getPageButtonStyle(item) {
        let style = '';

        if (item.Style != null && item.Style.trim() != '' && JSON.parse(item.Style).stylePageButton != null) {
            return style + JSON.parse(item.Style).stylePageButton.trim().replaceAll('\n', '');
        } else {
            return style;
        }
    }

    _getPageLinkStyle(item) {
        let style = '';

        if (item.Style != null && item.Style.trim() != '' && JSON.parse(item.Style).stylePageLink != null) {
            return style + JSON.parse(item.Style).stylePageLink.trim().replaceAll('\n', '');
        } else {
            return style;
        }
    }

    _getPageWrapperStyle(item) {
        let style = '';

        if (item.Style != null && item.Style.trim() != '' && JSON.parse(item.Style).stylePageWrapper != null) {
            return style + JSON.parse(item.Style).stylePageWrapper.trim().replaceAll('\n', '');
        } else {
            return style;
        }
    }

    _getCardStyle(item) {
        let style = '';

        if (item.Style != null && item.Style.trim() != '' && JSON.parse(item.Style).styleCard != null) {
            return style + JSON.parse(item.Style).styleCard.trim().replaceAll('\n', '');
        } else {
            return style;
        }
    }

    _getCardHeaderStyle(item) {
        let style = '';

        if (item.Style != null && item.Style.trim() != '' && JSON.parse(item.Style).styleCardHeader != null) {
            return style + JSON.parse(item.Style).styleCardHeader.trim().replaceAll('\n', '');
        } else {
            return style;
        }
    }

    _getCardHeaderLabelStyle(item) {
        let style = '';

        if (item.Style != null && item.Style.trim() != '' && JSON.parse(item.Style).styleCardHeaderLabel != null) {
            return style + JSON.parse(item.Style).styleCardHeaderLabel.trim().replaceAll('\n', '');
        } else {
            return style;
        }
    }

    _getCardInnerStyle(item) {
        let style = '';

        if (item.Style != null && item.Style.trim() != '' && JSON.parse(item.Style).styleCardInner != null) {
            return style + JSON.parse(item.Style).styleCardInner.trim().replaceAll('\n', '');
        } else {
            return style;
        }
    }

    _getAttributes(item) {
        if (item.HtmlAttributes != null) {
            let attributes = '';

            let keys = Object.keys(item.HtmlAttributes);

            for (var i = 0; i < keys.length; i++) {
                if (keys[i] != '_events' && keys[i] != '_handlers' && keys[i] != 'uid' && keys[i] != 'parent') {
                    attributes += ' ' + keys[i] + '="' + item.HtmlAttributes[keys[i]] + '"';
                }
            }

            return attributes;
        } else {
            return '';
        }
    }

    getItemById(id) {
        return $('#' + id);
    }
}